{
  "accessibility": {
    "closeModal": "Chiudi finestra modale",
    "useSetting": "Usa l'impostazione",
    "srOnly": {
      "close": "Chiudi",
      "loading": "Caricamento in corso..."
    }
  },
  "account": {
    "salesResources": {
      "title": "Risorse per le vendite",
      "searchDocuments": "Cerca documenti",
      "minimalRating": "Valutazione Minima",
      "maxRating": "Valutazione massima"
    },
    "saasRebilling": {
      "enableRebillingMessage": "Abilita la rifatturazione per questo cliente per ottenere fino a 10 volte i profitti sull'utilizzo del telefono, delle email, delle automazioni ecc.",
      "enableRebilling": "Abilita rifatturazione",
      "servicesActivateAfterPayment": "I servizi di rifatturazione saranno attivi dopo che il cliente avrà aggiunto un metodo di pagamento. Fino ad allora, l'accesso all'account del cliente avrà delle restrizioni.",
      "cannotModifyOnHold": "Impossibile modificare le configurazioni di rifatturazione poiché questo account ha già un piano SaaS in sospeso. I markup di rifatturazione saranno configurati secondo il piano quando il cliente aggiungerà un metodo di pagamento.",
      "rebillingSettings": "Impostazioni di rifatturazione"
    }
  },
  "affiliates": {
    "aboutMe": "Informazioni su di me",
    "error": {
      "unableToSend": "Impossibile inviare l'email"
    },
    "industriesServed": "Settori serviti",
    "sendAMessage": "Invia un messaggio",
    "sendMessageIntro": "Invia un messaggio per presentarti a questo consulente. Includi dettagli su di te e sui servizi che stai cercando.",
    "socialSites": "Siti social",
    "success": {
      "emailSent": "Email inviata correttamente"
    },
    "validationErrors": {
      "validEmail": "Fornisci un'email valida.",
      "validMessage": "Fornisci un messaggio valido.",
      "validName": "Fornisci un nome valido."
    },
    "yearsInBusiness": "Anni in attività",
    "yourEmail": "La tua email",
    "yourName": "Il tuo nome",
    "paymentDetailsAccessMessage": " Questa sezione sui dati di pagamento è accessibile e modificabile solo dal <strong>titolare dell'agenzia</strong>. Se ha bisogno di assistenza, contatta il tuo <strong>titolare dell'agenzia ({ agencyOwnerEmail })</strong>.",
    "partnerBadgeAlt": "Distintivo del partner",
    "photoAlt": "Foto del partner",
    "defaultCompany": "Nessuna azienda",
    "moreServices": "+ {count} servizi in più"
  },
  "agency": {
    "saas": {
      "saasMode": "Modalità SaaS",
      "pendingPaymentInformation": "Informazioni sul pagamento in sospeso",
      "customerId": "ID cliente",
      "noPaymentMethods": "Sembra che non siano stati aggiunti metodi di pagamento! Aggiungi un metodo di pagamento per attivare la modalità SaaS",
      "enableSaasDescription": "Abilita SaaS in questo luogo per creare abbonamenti e rifatturare l'utilizzo di telefono ed email",
      "missingEmailAddress": "Manca l'indirizzo email dell'account, aggiungi prima i dettagli.",
      "toConvertToSaaS": "Per convertire questo account in SaaS, devi prima aggiungere un amministratore del luogo e riprovare",
      "newUser": "Crea nuovo utente",
      "stripeCustomerConnected": "Il cliente Stripe è stato collegato con successo!",
      "requestClientPaymentDetails": "Richiedi i dettagli di pagamento del cliente",
      "saasLocationDescription": "I luoghi in modalità SaaS necessitano della carta di credito del cliente per funzionare. Puoi richiederla inviando un'email, un SMS o condividendo un URL",
      "selectSpace": "Seleziona spazio per continuare",
      "spaceDescription": "Lo spazio che selezioni qui sarà utilizzato per conservare le informazioni di questo cliente, elaborare i suoi pagamenti e gestire i suoi abbonamenti.",
      "stripe": "Stripe",
      "freeCreditsDescription": "Quando un utente si registra, puoi offrirgli crediti gratuiti per utilizzare i servizi di email e telefonia.",
      "thatAboutMinsInCalls": "Sono circa {count} messaggi o {count1} minuti di chiamate",
      "subscriptionSettings": "Impostazioni abbonamento",
      "toUpgradeOrCancelPlan": "Per aggiornare o annullare il piano",
      "allowClientUpgrade": "Consenti al cliente (account secondario) di passare a un piano superiore.",
      "addNewPlanFeatures": "Aggiungi le funzionalità del nuovo piano al momento dell'aggiornamento",
      "upgradeFeatureDescription": "Dopo il passaggio a un piano superiore, gli account secondari avranno accesso alle funzionalità aggiuntive del nuovo piano. accesso alle funzionalità aggiuntive nel nuovo piano.",
      "allowClientCancel": "Consenti al cliente (account secondario) di annullare il proprio abbonamento.",
      "snapshotDescription": "Lo snapshot selezionato verrà aggiunto automaticamente al nuovo luogo SaaS creato",
      "ownSnapshots": "Snapshot personali",
      "selectAndContinue": "Seleziona e Continua"
    },
    "advancedSettings": {
      "controlLocationSettings": "Controlla le impostazioni del luogo",
      "disableAddSmtp": "Disabilita il pulsante Aggiungi servizio email nelle impostazioni dei servizi email dell'account secondario",
      "disableAddSmtpDescription": "Limita gli utenti degli account secondari ad aggiungere il proprio provider di servizi email",
      "enableReVerification": "Abilita riverifica per 90 giorni",
      "lcEmailNotEnabled": "Il luogo non ha LeadConnector come provider di email predefinito",
      "onlyVisibleForAgency": "Puoi vedere queste impostazioni abilitate solo per l'agenzia",
      "reVerificationDescription": "Ogni stato di verifica dell'email verrà revocato dopo 90 giorni (proteggi la tua reputazione di mittente e garantisci la massima deliverability nella casella di posta)",
      "account": {
        "accountDetails": "Dettagli dell'account",
        "advancedEmailSettings": "Impostazioni email avanzate",
        "hipaa": "HIPAA",
        "hipaaCompliant": "Conforme a HIPAA",
        "smsEmailLimits": "Limiti SMS/Email",
        "socialProfiles": "Profili social",
        "subscribed": "Iscritto"
      },
      "activityTracking": {
        "history": "Cronologia"
      },
      "addAccount": {
        "accountInfo": "Informazioni sull'account",
        "accountSnapshots": "Snapshot dell'account",
        "businessNiche": "Nicchia aziendale",
        "chooseBusinessNiche": "Scegli la nicchia aziendale...",
        "pickSnapshot": "Scegli uno snapshot",
        "selectSnapshot": "Seleziona snapshot",
        "title": "Aggiungi account secondario",
        "accountInfo1": "Informazioni sull'account"
      },
      "addBalance": {
        "addBalanceToWallet": "Aggiungi saldo al portafoglio",
        "addMoneyToWallet": "Aggiungi denaro al portafoglio",
        "balanceAddedSuccessfully": "Saldo aggiunto correttamente",
        "cardWillBeCharged": "La carta che termina in {cardNumber} verrà addebitata",
        "complimentaryCredits": "Crediti omaggio ({credits})",
        "creditsRemovedByAgency": "Crediti rimossi dall'agenzia",
        "currentBalance": "Saldo attuale",
        "customerCCWillNotBeCharged": "Non verrà addebitato alcun costo sulla carta di credito del cliente",
        "moneyWillBeAddedToWallet": "Il denaro verrà aggiunto al portafoglio",
        "pleaseProvideAmountBetween": "Inserisci un importo compreso tra {min} e {max}",
        "processing": "Elaborazione",
        "removeBalance": "Rimuovi saldo",
        "transactionSuccessful": "Transazione riuscita",
        "walletBalance": "Saldo del portafoglio ({balance})"
      },
      "addPaymentMethod": {
        "adding": "Aggiunta in corso...",
        "cardDetails": "Dettagli della carta",
        "cardSuccessfullyAdded": "Carta aggiunta correttamente",
        "errorWhileAddingCard": "Errore durante l'aggiunta della nuova carta!",
        "maximumCardUpdateLimitReached": "Limite massimo di aggiornamento della carta raggiunto",
        "rateLimitMessage": "Sembra che oggi tu abbia raggiunto il numero massimo di tentativi consentiti per l'aggiunta di carte. Riprova tra 24 ore."
      },
      "aiProductRebilling": {
        "funnel": " funnel",
        "images": " Immagini,",
        "per1000Words": " /1000 parole, ",
        "perFunnel": " /funnel",
        "perImage": " / Immagine,",
        "pleaseCheckSupport": "controlla la nostra",
        "ratesMayDiffer": "Le tariffe possono variare a seconda della regione. I calcoli mostrati sono basati sulle tariffe per il Regno Unito,",
        "ratesMayDifferUS": "Le tariffe possono variare a seconda della regione. I calcoli sono mostrati in base alle tariffe Twilio per gli Stati Uniti; per maggiori dettagli, consulti Twilio.",
        "pleaseCheckTwilioRates": "Per gli SMS in uscita verso Stati Uniti/Canada verranno addebitati 0,0079 $/segmento. Per gli SMS in entrata 0,0075 $/segmento.",
        "words": " parole, "
      },
      "api": {
        "advancedFunctionalityNote": "Nota sulle funzionalità avanzate",
        "agencyApiKeys": "API Key dell'agenzia",
        "apiAccess": {
          "partOfAdvancedApi": "Questo fa parte dell'API avanzata disponibile nel piano Pro.",
          "toUpgrade": "per aggiornare."
        },
        "createNew": "Crea nuovo",
        "developerCouncilInfo": "Informazioni sul consiglio degli sviluppatori",
        "noAccess": "Non hai accesso a questa sezione.",
        "securityAlert": "Messaggio di avviso di sicurezza",
        "table": {
          "fetchingKeys": "Recupero delle chiavi aziendali...",
          "noKeysYet": "Non hai ancora nessuna API Key.",
          "toCreateFirstKeys": "per creare le tue prime API Key."
        },
        "zapierNote": "Nota Zapier"
      },
      "calendarBeta": {
        "abilityChooseGoogleCalendars": "Possibilità di scegliere Google Calendar per le opzioni \"Aggiungi a\" + \"Conflitto\" dei calendari per controllare la disponibilità di ogni utente",
        "abilityToAllocateRoundRobin": "Possibilità di assegnare gli appuntamenti a rotazione",
        "abilityToChooseSpecificUser": "Possibilità di scegliere un utente specifico con cui prenotare l'appuntamento",
        "adminAbilitySeeEveryUser": "Amministratore – Possibilità di visualizzare tutti gli appuntamenti del calendario degli utenti",
        "adminAbilityViewAllCalendar": "Amministratore – Possibilità di visualizzare tutti gli appuntamenti del calendario degli utenti",
        "adminsCanDeleteIntegrations": "Gli amministratori possono eliminare qualsiasi integrazione desiderino, ma gli utenti possono eliminare solo le proprie",
        "adminsCanSeeAllIntegrations": "Gli amministratori possono vedere tutte le integrazioni indipendentemente da chi le ha create, ma gli utenti possono vedere quelle che hanno creato per se stessi",
        "contactDetailAppointments": "Dettagli del contatto > Appuntamenti (nuovo)",
        "conversationsScheduleAppointment": "Conversazioni > Programma un appuntamento (nuovo)",
        "essentialConsiderations": "Considerazioni essenziali",
        "funnelsWebsitesCalendar": "Funnel/Siti web > Calendario (nuovo)",
        "helpReorientTriggers": "Durante la chiamata, aiuteremo a riorientare i trigger per adattarli alla nuova configurazione del calendario",
        "iAgreeMessage": "Se sei d'accordo con le modifiche sopra indicate, clicca su \"Accetto\" per iniziare a utilizzare il calendario (beta) in questo luogo",
        "integrationNew": "Integrazione (nuovo)",
        "loseAbilityToViewEdit": "Gli utenti della nuova versione perderanno la possibilità di \"visualizzare/modificare\" gli appuntamenti (creati nella versione precedente) tramite la finestra modale Dettagli dell'opportunità, ma potranno continuare a eseguire tutte queste azioni nella pagina Appuntamenti",
        "newOldTriggersCoexist": "I nuovi e i vecchi trigger coesisteranno",
        "nonAdminAbilityViewPersonal": "Utente non amministratore – Possibilità di visualizzare solo i propri appuntamenti personali (i dati assegnati e la mappatura del calendario sotto GESTIONE DEI TEAM non hanno effetto)",
        "nonAdminViewPersonalOnly": "Utente non amministratore – Possibilità di visualizzare solo i propri appuntamenti personali",
        "notAtMoment": "Non al momento. Ma stiamo facendo del nostro meglio per portarla su dispositivi mobili il prima possibile.",
        "oldAppointmentsCanBeViewed": "I vecchi appuntamenti possono essere visti nella pagina degli appuntamenti tramite un interruttore.",
        "oldAppointmentsDisplayed": "I vecchi appuntamenti verranno visualizzati insieme ai nuovi appuntamenti nello stesso elenco di appuntamenti",
        "oldCalendarVersionAppointments": "Vecchia versione del calendario + vecchi appuntamenti",
        "onlyNewCalendarWidget": "È possibile aggiungere solo il nuovo widget del calendario",
        "opportunityAddAppointment": "Opportunità > Aggiungi appuntamento (nuovo)",
        "profilePageAdmin": "Pagina del profilo per l'amministratore (nuovo)",
        "profilePageAllUsers": "Pagina del profilo (tutti gli utenti)",
        "providesAllOptions": "Fornisce tutte le opzioni (gruppi + servizi) necessarie per configurare il nuovo calendario",
        "reintegratingConnectionsRequired": "Potrebbe essere necessario reintegrare tutti i collegamenti una volta abilitata la beta del calendario per un luogo",
        "roundRobinHighlight": "La possibilità di effettuare appuntamenti a rotazione tra diversi gruppi di agenti è il punto forte di questo aggiornamento.",
        "schedulingCalendarAppointments": "Programmazione > Calendario/Appuntamenti (nuovi filtri + opzione per passare tra appuntamenti nuovi e vecchi)",
        "settingsCalendarBeta": "Impostazioni > Calendario (beta)",
        "surfacingFirstTime": "Presentazione per la prima volta",
        "teamManagementAdminOnly": "Gestione dei team (disponibile solo per gli amministratori)",
        "toggleOffNewVersion": "Opzione disattivata (nuova versione)",
        "toggleOnOldVersion": "Opzione attivata (vecchia versione)",
        "whatChangesWithNewVersion": "Quali cambiamenti comporta la nuova versione del calendario?",
        "whatDoesCalendarEntail": "Cosa comporta il calendario (beta privata)?",
        "whatHappensToOldAppointments": "Cosa succede ai nostri vecchi appuntamenti dopo la transizione?",
        "whatWillWeSeeMobile": "Cosa vedremo sui dispositivi mobili durante la beta?",
        "willOldAppointmentsBeFactored": "Gli appuntamenti passati verranno considerati nel calcolo della disponibilità per i nuovi appuntamenti?",
        "willOldCalendarUrlsWork": "I nostri vecchi URL del calendario continueranno a funzionare dopo la transizione?",
        "willWeGetNewVersionMobile": "Potremo usare la nuova versione su dispositivi mobili durante la beta?",
        "yesOldSettingsPageContinues": "Sì. La vecchia pagina delle impostazioni rimarrà attiva e potrai continuare a effettuare modifiche al suo interno. Il vecchio widget del calendario e il nuovo widget del calendario funzioneranno indipendentemente, ma saranno in costante sincronizzazione tra loro per garantire un calcolo accurato della tua disponibilità tra i due sistemi. Per evitare confusione, ti consigliamo vivamente di utilizzare i nuovi URL ogni volta che è possibile, così da non dover gestire due URL separati per gli stessi gruppi di utenti.",
        "yesSyncOnGoogleCalendar": "Sì, dato che la sincronizzazione unidirezionale è attiva, Google Calendar garantirà che le fasce orarie non disponibili vengano bloccate."
      },
      "companyPlansModal": {
        "billedAnnually": "Fatturazione annuale",
        "billedMonthly": "Fatturazione mensile",
        "changePlanFor": "Modifica piano per {locationName}",
        "notAuthorized": "Non hai l'autorizzazione per eseguire questa azione. Solo gli amministratori/utenti dell'agenzia o amministratori del luogo possono eseguirla.",
        "payAnnually": "Paga annualmente",
        "payMonthly": "Paga mensilmente"
      },
      "locationBillingHistory": {
        "billingHistory": "Cronologia di fatturazione",
        "cardNo": "N. carta",
        "errorWhileFetchingInvoices": "Errore durante il recupero delle fatture, fai clic per riprovare",
        "invoiceDescription": "Descrizione della fattura",
        "invoiceNo": "N. fattura",
        "noInvoices": "Nessuna fattura",
        "refunded": "Rimborsato",
        "succeeded": "riuscito",
        "view": "VISUALIZZA"
      },
      "locationWallet": {
        "autoRechargeWith": "Ricarica automatica con",
        "balance": "Saldo:",
        "credits": "Crediti",
        "seeTransactions": "Visualizza transazioni",
        "whenBalanceLowerThan": "quando il saldo è inferiore a"
      },
      "mailTransactionModal": {
        "checkYourEmail": "Controlla la tua email ({emails}).",
        "csvSentMessage": "Invieremo un file CSV alla tua email. Di solito ci vogliono 7-10 minuti.",
        "enterEmailAddress": "Inserisci l'indirizzo email",
        "exportAndSendCsv": "Esporta e invia CSV",
        "exportTransactions": "Esporta transazioni",
        "itUsuallyArrives": "Di solito arriva in 10 minuti.",
        "useCommasToSeparate": "Usa le virgole per separare più email."
      },
      "modifySubscription": {
        "cancelClientDescription": "Annulla l'abbonamento del tuo cliente e chiudi l'account",
        "cancelDescription": "Annulla l'abbonamento e chiudi l'account",
        "cancelImmediately": "Annulla immediatamente",
        "cancelNow": "Annulla ora",
        "cancelSubscription": "Annulla abbonamento",
        "changedYourMind": "Hai cambiato idea?",
        "changedYourMindClient": "Puoi riattivare l'abbonamento del tuo cliente",
        "changedYourMindYou": "Puoi riattivare il tuo abbonamento",
        "confirmByTyping": "Conferma digitando {text} qui sotto",
        "confirmCancellation": "Conferma l'annullamento",
        "modifySubscription": "Modifica l'abbonamento",
        "modifyYourSubscription": "Modifica il tuo abbonamento",
        "resumeSubscription": "Riattiva abbonamento",
        "subscriptionWillBeCancelledOn": "In questo modo verrà programmato l'annullamento del tuo abbonamento per il {date}. Puoi ripristinare l'abbonamento interrompendo l'annullamento programmato in qualsiasi momento.",
        "subscriptionWillBeCancelledOnClient": "In questo modo verrà programmato l'annullamento dell'abbonamento del cliente per il {date}. Tu e i tuoi clienti potete ripristinare l'abbonamento interrompendo l'annullamento programmato in qualsiasi momento.",
        "subscriptionWillBeCancelledOnDate": "Il tuo abbonamento verrà annullato il {date}.",
        "subscriptionWillBeCancelledOnDateClient": "L'abbonamento del tuo cliente verrà annullato il {date}.",
        "subscriptionWillBeResumed": "Il tuo abbonamento verrà riattivato e la fatturazione riprenderà normalmente.",
        "subscriptionWillBeResumedClient": "L'abbonamento del tuo cliente verrà riattivato e la fatturazione riprenderà normalmente.",
        "upgradeDescription": "Passa a un piano di abbonamento superiore",
        "weAreGladYouStaying": "Siamo felici di sapere che rimani con noi!",
        "nextBillingDate": "Prossima data di fatturazione: {date}",
        "cancelImmediatelyTitle": "Desidera davvero annullare immediatamente l'abbonamento?",
        "cancelNowDescription": "L'annullamento del tuo abbonamento è programmato per il {date}. Se scegli di annullare ora, il tuo account, inclusa tutta l'attività in uscita come messaggi ed email programmati, verrà immediatamente interrotto.",
        "cancelNowDescriptionClient": "L'annullamento dell'abbonamento del tuo cliente è programmato per il {date}. Se scegli di annullare ora, l'account del tuo cliente, inclusa tutta l'attività in uscita come messaggi ed email programmati, verrà immediatamente interrotto.",
        "modifyDescription": "Puoi eseguire quest'azione ({action}) per il tuo abbonamento",
        "modifyDescriptionClient": "Puoi eseguire quest'azione ({action}) per l'abbonamento del tuo cliente"
      },
      "noPaymentMethodWarning": {
        "addNow": "Aggiungi subito",
        "youNeedToEnterCardInfo": "Devi inserire le informazioni della tua carta.",
        "youNeedToEnterClientCardInfo": "Devi inserire le informazioni della carta del tuo cliente."
      },
      "productRebilling": {
        "chargesBasedOnTokens": "Gli addebiti si basano sui token. I conteggi delle parole mostrati di seguito sono stime che ti aiutano a capire l'utilizzo. Le spese effettive possono variare.",
        "examplePricingGpt4oMini": "Esempio di prezzi - GPT-4o Mini",
        "for750kWords": "(per 750.000 parole) ",
        "gpt4oMini": " GPT-4o-mini ",
        "input": "Input",
        "or": "o ",
        "output": "Output",
        "perImage": " / Immagine",
        "perResultSelection": " / Selezione risultati",
        "ratesMayDifferUK": "Le tariffe possono variare a seconda dell'area geografica. I calcoli mostrati sono basati sulle tariffe per il Regno Unito, controlla la nostra",
        "ratesMayDifferUS": "Le tariffe possono variare a seconda dell'area geografica e del tipo di numero. I calcoli sono stati effettuati in base alle tariffe Twilio per gli Stati Uniti.",
        "pleaseCheckSupport": "controlla la nostra",
        "resultSelection": " Selezione risultati",
        "supportDoc": "documentazione di supporto",
        "forMoreDetails": "per ulteriori dettagli",
        "words": " parole"
      },
      "removePaymentMethod": {
        "endingIn": "Termina in *{cardNo}",
        "no": "No",
        "removeCard": "Rimuovere la carta?",
        "removing": "Rimozione...",
        "yesRemove": "Sì, rimuovi"
      },
      "requestSaasModal": {
        "requestClientPaymentDetails": "Richiedi dettagli di pagamento del cliente",
        "saasLocationDescription": "Configura un abbonamento SaaS per questo luogo",
        "selectSpace": "Seleziona spazio",
        "spaceDescription": "Scegli dove vuoi impostare la fatturazione per questo luogo"
      },
      "saasEnableProducts": {
        "disable": "Disabilita",
        "enableDisableProducts": "Abilita/Disabilita prodotti",
        "feature": "Funzionalità",
        "unsavedChanges": "Modifiche non salvate"
      },
      "saasSubscriptionPlan": {
        "agencyStripeFailed": "La prossima fatturazione per questo cliente sembra essere passata. Questo accade quando l'account Stripe della tua agenzia non funziona correttamente. Accedi all'account Stripe della tua agenzia per risolvere il problema.",
        "copiedText": "testo copiato:",
        "couldNotCopy": "Async: impossibile copiare il testo: ",
        "multiplier": " X ",
        "nextBillingDatePrefix": " Prossima data di fatturazione: ",
        "plan": "Piano",
        "pleaseContactAgency": "Contatta l'agenzia per attivare l'abbonamento.",
        "stripeSubscriptionId": "ID abbonamento Stripe:",
        "subscriptionPlans": "Piani di abbonamento",
        "subscriptionWillBeCancelledOn": "Il tuo abbonamento verrà annullato il {date}",
        "subscriptionWillBeCancelledOnClient": "L'abbonamento del tuo cliente verrà annullato il {date}",
        "toModifyClientSubscription": "per modificare l'abbonamento del tuo cliente",
        "toModifyYourSubscription": "per modificare il tuo abbonamento",
        "whatsappNumberSubscription": "Abbonamento al numero WhatsApp",
        "yourBillingDatePast": "La tua prossima data di fatturazione sembra essere passata. Contatta {email} per risolvere questo problema. Nel frattempo tutto continuerà come al solito."
      },
      "salesResources": {
        "certifiedUser": "Utente certificato",
        "clearFilter": "Rimuovi filtro",
        "dateRange": "Intervallo di date"
      },
      "upgradePlanProcessedModal": {
        "paymentInfo": "Pagherai {amount} $ al mese fatturati {interval}",
        "planUpgradeFailed": "Non è stato possibile aggiornare il tuo piano!",
        "planUpgraded": "Il tuo piano è stato aggiornato!",
        "retryUpgrade": "Riprova aggiornamento",
        "upgradeFailed": "L'aggiornamento del tuo piano non è riuscito, riprova",
        "upgradedSuccessfully": "Hai aggiornato correttamente il tuo piano {oldPlan} a {newPlan}"
      },
      "upgradePlanSelectionModal": {
        "billedAsMonthlyCharge": "fatturato come costo mensile di {amount} al mese",
        "billedAsYearlyCharge": "fatturato come costo annuale di {amount} all'anno",
        "upgradeFrom": "Aggiorna da",
        "whatYouWillGet": "Cosa riceverai:"
      },
      "walletTransactionModal": {
        "balanceAfterTransaction": "Saldo dopo la transazione:",
        "callDuration": "Durata della chiamata:",
        "callSid": "SID chiamata:",
        "charge": "Costo:",
        "contact": "Contatto:",
        "contactName": "Nome del contatto:",
        "contactPhone": "Telefono del contatto:",
        "credit": "Credito:",
        "creditsAfterTransaction": "Crediti dopo la transazione:",
        "dateSent": "Data di invio",
        "deleted": "<Deleted>.",
        "discount": "Sconto:",
        "eventId": "ID evento:",
        "from": "Da:",
        "noContactFound": "Nessun contatto trovato",
        "noOfSegments": "Numero di segmenti:",
        "openContactPage": "Apri pagina dei contatti",
        "openConversation": "Apri conversazione",
        "openEvent": "Apri evento",
        "originalCharge": "Costo originale:",
        "received": "Ricevuto",
        "smsSid": "SMS SID:",
        "timeBilled": "Ora di fatturazione:",
        "timeOfCall": "Ora della chiamata",
        "transactionDetails": "Dettagli della transazione -",
        "transactionId": "ID transazione:",
        "type": "Tipo:",
        "segments": "Segmenti"
      },
      "calendarSettings": {
        "meetings": "Incontri",
        "services": "Servizi",
        "hideCalendarWarning": "Se vuoi nascondere del tutto il modulo del calendario, fallo dalle impostazioni dell'account secondario > il mio personale > ruoli e autorizzazioni",
        "calendarSettingsUpdated": "Impostazioni del calendario aggiornate",
        "meetingDescription": "Abilita questa opzione per consentire agli account secondari di utilizzare la funzione Incontri, progettata per la gestione dei calendari delle vendite, le chiamate di onboarding, la programmazione a rotazione, le collaborazioni in team, le prenotazioni di corsi, i colloqui e altro ancora. Ideale per le aziende che necessitano di strumenti di programmazione flessibili e collaborativi.",
        "serviceDescription": "Attiva Servizi per consentire agli account secondari di accedere a una soluzione di prenotazione completa per le attività basate sui servizi. Ciò include la creazione di pagine di prenotazione con più servizi, la gestione delle risorse, la gestione di più luoghi, l'impostazione di prezzi specifici per il personale, l'aggiunta di varianti di servizio o componenti aggiuntivi e altro ancora."
      }
    },
    "apiKeys": {
      "apiKey": "ApiKey",
      "copied": "Copiato!",
      "copyApiKey": "Copia API Key",
      "createApiKey": "Crea API Key",
      "deleteAllKeys": "Elimina tutte le chiavi",
      "nameRequired": "Il campo del nome è obbligatorio.",
      "somethingWentWrong": "Spiacenti! Qualcosa è andato storto! Riprova.",
      "updatedSuccessfully": "Aggiornamento avvenuto correttamente"
    },
    "billing": {
      "accountPaused": "Il tuo account {name} è stato sospeso.",
      "accountProvisioned": "Il tuo account è in fase di provisioning.",
      "activateSubAccount": "Attiva account secondario",
      "activeServices": "Servizi attivi",
      "addNewCard": "Aggiungi nuova carta",
      "addNewService": "Aggiungi nuovo servizio",
      "addPaymentMethod": "aggiungi un metodo di pagamento",
      "alertIcon": "Icona di avviso",
      "approve": "Approva",
      "authenticateCardMessage": "Per una maggiore sicurezza, devi autenticare nuovamente i dati della tua carta.",
      "badActorWarning": "Se ritieni che questo account secondario sia stato creato da un malintenzionato, ti consigliamo di eliminare questo account secondario e annullare l'abbonamento corrispondente.",
      "callUs": "Chiamaci",
      "cancelAndDelete": "Annulla abbonamento ed elimina account secondario",
      "completeFormNextStep": "Completa il modulo al passaggio successivo",
      "congratulations": "🎉 Congratulazioni! 🎉",
      "contactAgency": "Contatta la tua agenzia per risolvere questo problema",
      "contactThroughEmailOrPhone": "Puoi contattarci tramite email o telefono per risolvere questo problema",
      "dataSafe": "Tutti i tuoi dati sono al sicuro e tutte le automazioni, pagine web, ecc. riprenderanno a funzionare dopo il corretto completamento del pagamento.",
      "declineSubAccount": "Rifiuta l'account secondario",
      "deleteRecommendation": "Si consiglia di eliminare questo account secondario. Oppure puoi farlo in un secondo momento dalla pagina Account secondari > Gestisci cliente.",
      "emailUsAt": "Scrivici un'email all'indirizzo",
      "moveToDashboard": "Sposta nella dashboard",
      "noPaymentMethods": "Sembra che non siano stati aggiunti metodi di pagamento! Per favore",
      "paymentMethod": "Metodo di pagamento",
      "paymentMethodUpdated": "Il tuo metodo di pagamento è stato aggiornato",
      "paymentNotCompleted": "Stai visualizzando questo messaggio perché il pagamento non è stato completato.",
      "proceedToNextStep": "Procedi al passaggio successivo",
      "questionMark": "?",
      "reachOutMessage": "non esitare a contattarci in caso di domande.",
      "reactivateBillingFor": "Riattiva la fatturazione per {location}",
      "retryPayment": "Riprova il pagamento",
      "secureSystemMessage": "Siamo passati a un sistema di fatturazione più sicuro.",
      "setupMessage": "Qualcuno ti contatterà per configurare l'account. Di solito ci vogliono 12-24 ore,",
      "signout": "Esci",
      "subAccountId": "ID account secondario:",
      "successfullyInitiated": "{product} è stato avviato correttamente",
      "systemError": "Si è verificato un errore di sistema",
      "toReactivate": "per riattivare l'account",
      "userImage": "immagine utente",
      "verificationSkipped": "La verifica dell'email e del telefono sarà saltata per questo account secondario e il cliente potrà accedervi.",
      "verifyAccount": "Verifica l'account",
      "verifyAfterAttempt": "Puoi verificare questo account dopo almeno un tentativo di verifica da parte dell'amministratore dell'account secondario",
      "verifySubAccount": "Verifica l'account secondario",
      "recommendedPlans": "Piani consigliati",
      "buildYourOwnPlan": "CREA IL TUO PIANO",
      "resetToDefaults": "Ripristina le impostazioni predefinite",
      "paymentMethodChange": "Se ha bisogno di cambiare il metodo di pagamento",
      "approveSubAccount": "Approva l'account secondario",
      "approveSubAccountDescription": "L'account secondario verrà ripristinato e i suoi amministratori saranno in grado di accedervi e utilizzarlo.",
      "productInitiated": "Prodotto avviato"
    },
    "deleteConfirmation": {
      "actionCannotBeReversed": "Questa azione non può essere annullata.",
      "cancelKeep": "Annulla, mantieni",
      "confirmDeletionInstructions": "Conferma l'eliminazione digitando {word} qui sotto:",
      "enterConfirm": "Inserisca {word} per rigenerare",
      "message": "L'API Key di questo luogo verrà eliminata.",
      "title": "Vuoi eliminare l'API Key del luogo?",
      "yesDelete": "Sì, elimina"
    },
    "generalDetails": {
      "noPermission": "Non hai l'autorizzazione per caricare il file. Controlla le tue autorizzazioni insieme all'amministratore della tua agenzia.",
      "relatedContacts": "Contatti correlati ({count})"
    },
    "locationApiKeys": {
      "deleteAllConfirmMessage": "Vuoi davvero eliminare tutte le API Key del luogo?",
      "deleteAllConfirmTitle": "Eliminare tutte le API Key del luogo?",
      "deleteConfirmMessage": "Quest'azione eliminerà l'API Key per il luogo: {location}. Desideri continuare?",
      "deleteAgencyApiKeyConfirmMessage": "Quest'azione eliminerà l'API Key. Desideri continuare?",
      "fetchingLocations": "Recupero dei luoghi...",
      "maxApiKeysMessage": "Puoi avere un massimo di 5 API Key.",
      "noLocationsFound": "Nessun luogo trovato",
      "old": "Vecchio",
      "proPlanRequiredMessage": "Questo fa parte dell'API avanzata disponibile nel piano Pro.",
      "searchLocation": "Cerca luogo",
      "title": "API Key del luogo"
    },
    "locationCard": {
      "deletionScheduledMessage": "Questo account secondario verrà eliminato (momento di eliminazione: {date}); se hai cambiato idea",
      "emailUsageNotRebilled": "L'utilizzo delle email viene rifatturato",
      "emailUsageRebilled": "L'utilizzo delle email viene rifatturato al tuo cliente",
      "listings": "Schede",
      "manageClient": "Gestisci cliente",
      "paymentPending": "Il pagamento è in sospeso",
      "remainingWalletBalance": "Saldo residuo del portafoglio di questo luogo SaaS",
      "requestPaymentAgain": "Richiedi nuovamente il pagamento",
      "saasModeActivated": "La modalità SaaS è abilitata",
      "saasModeNotActivated": "La modalità SaaS non è abilitata",
      "saasSubscriptionNotEnabled": "Il piano di abbonamento SaaS non è abilitato",
      "saasSubscriptionRunning": "Il piano di abbonamento SaaS è attivo",
      "social": "Social",
      "switchToSaaS": "Passa a SaaS",
      "switchToSubAccount": "Passa all'account secondario",
      "telephoneUsageNotBilled": "L'utilizzo del telefono non viene addebitato",
      "telephoneUsageRebilled": "L'utilizzo del telefono viene rifatturato al tuo cliente",
      "wordpressActive": "WordPress attivo",
      "wordpressInactive": "WordPress inattivo",
      "wordpressNotSoldYet": "WordPress non è ancora stato venduto",
      "wordpressSaleSuccessful": "Vendita WordPress riuscita",
      "yextActive": "Yext attivo",
      "yextInactive": "Yext inattivo",
      "yextNotSoldYet": "Yext non è ancora stato venduto",
      "yextSaleSuccessful": "Vendita Yext riuscita",
      "reviews": "Recensioni"
    },
    "messageUsage": {
      "acceptTnc": "Accetta i termini e condizioni",
      "cannotPerformAction": "Impossibile eseguire questa azione. Contatta il supporto.",
      "currentLimit": "Limite attuale",
      "days": "Giorno/i",
      "failedToUpdate": "Impossibile aggiornare l'utilizzo dei messaggi",
      "helpCentre": "Centro assistenza",
      "increaseLimitFurther": "Aumenta il limite ulteriormente",
      "increaseLimitNow": "Aumenta il limite ora",
      "lessThanUsage": "L'utilizzo attuale è {usage}, e l'utilizzo selezionato è meno dell'utilizzo attuale.",
      "lessThanUsageModal": "L'utilizzo attuale è {usage}, il limite non può essere meno dell'utilizzo attuale",
      "limitAlreadyUnlocked": "Il limite è già sbloccato",
      "limitReached": "Limite raggiunto",
      "limitUpdatedFrom": "Limite {type} aggiornato da {old} a {new}",
      "lookingForSmsLimit": "Cerchi il limite di SMS?",
      "minLimitShould": "Il limite minimo deve essere {limit}",
      "newLimit": "Nuovo limite di {type}",
      "perDay": "/ giorno",
      "sameLimit": "Il limite selezionato è lo stesso del limite attuale!",
      "smsLimitLocation": "Il limite di SMS ora si trova a livello di luogo",
      "smsLimitSettingsInfo": "Ora puoi trovare queste impostazioni in \"Limite di messaggistica\" in \"Impostazioni avanzate\"",
      "timesInLast30Days": "Volte negli ultimi 30 giorni",
      "todaysUsage": "Utilizzo odierno",
      "typePerDay": "{type} / giorno",
      "updateLimit": "Aggiorna limite",
      "updateLimitFor": "Aggiorna il limite di {type} per {name}"
    },
    "prospectDetails": {
      "activeCampaignsWorkflows": "{type} attivo",
      "contactSource": "Fonte di contatto",
      "customer": "Cliente",
      "noPastCampaignsWorkflows": "Nessun {type} passato",
      "pastCampaignsWorkflows": "Passato {type}"
    },
    "settings": {
      "affiliateSettings": "Impostazioni affiliato",
      "agencyBilling": "Fatturazione dell'agenzia",
      "agencyTeamManagement": "Gestione dei team dell'agenzia",
      "apiKeys": "API Key",
      "compliance": "Conformità",
      "customMenuLink": "Link del menu personalizzato",
      "launchpadSettings": "Impostazioni del Launchpad",
      "phoneSystemTwilio": "Sistema telefonico - Twilio",
      "smtpService": "Servizio SMTP",
      "userSettings": "Impostazioni utente",
      "agencySettings": "Impostazioni dell'agenzia",
      "mailgun": "MailGun"
    },
    "snapshot": {
      "errorCreating": "Errore durante la creazione dello snapshot",
      "pickAnAccount": "Devi selezionare un account.",
      "snapshotName": "Nome dello snapshot",
      "snapshotNameRequired": "Devi assegnare un nome allo snapshot."
    },
    "socialDetails": {
      "blogRss": "RSS del blog",
      "foursquare": "Foursquare",
      "foursquareUrl": "Foursquare URL",
      "googlePlacesId": "ID luoghi Google",
      "googlePlus": "Google+",
      "googlePlusUrl": "URL di Google+",
      "instagramUrl": "URL Instagram",
      "linkedInUrl": "URL di LinkedIn",
      "pinterest": "Pinterest",
      "pinterestUrl": "URL di Pinterest",
      "yelp": "Yelp",
      "yelpUrl": "Yelp URL",
      "youTube": "YouTube"
    },
    "requestSms": "Richiesta tramite SMS",
    "iAlreadyHaveACustomer": "Ho già un cliente",
    "noAccountFound": "Nessun account trovato!!",
    "thisIs": "Questo è",
    "pleaseEnterValueBetween0To30Days": "Inserisca un valore compreso tra 0 e 30 giorni",
    "learnHowToAddOneTimeSetupFeeToThesePlans": "Scopri come aggiungere una commissione di configurazione una tantum a questi piani",
    "doNotDeleteStripeProductsWarning": "Ti preghiamo di <span style=\"font-weight: bold;\">non eliminare</span> questi prodotti all'interno del tuo account Stripe",
    "opportunityStats": "Statistiche delle opportunità",
    "createNewSnapshot": "Crea un nuovo snapshot",
    "stripeSettings": {
      "agencyDashboardVisibleTo": "Dashboard agenzia visibile a",
      "onlyMe": "Solo io",
      "allAgencyAdmins": "Tutti gli amministratori dell'agenzia",
      "stripeConnect": "Sarà presto obsoleto. Passa a Stripe Connect",
      "recommendStripe": "Consigliamo di usare Stripe Connect per una migliore sicurezza",
      "switchToStripeConnect": "Passa a Stripe Connect",
      "highLevelAccess": "HighLevel avrà accesso ai Suoi dati e potrà creare pagamenti e clienti per Suo conto",
      "stripeAccountWarning": "Una volta connesso, l'account Stripe non può essere modificato in un secondo momento. Si consiglia di utilizzare un nuovo account Stripe dedicato ai guadagni di HighLevel.",
      "connectToStripeAccount": "Collega il tuo account Stripe",
      "unverified": "L'account Stripe collegato a questa agenzia non è verificato e non può riscuotere pagamenti. Completa la verifica accedendo al tuo account Stripe.",
      "loginToStripe": "Accedi a Stripe",
      "connectedAccount": "Account collegato",
      "verified": "VERIFICATO",
      "totalPendingBalance": "Saldo in sospeso totale",
      "disconnectStripe": "Scollega Stripe",
      "removeSaasPlanConfigurations": "Vuoi rimuovere tutte le configurazioni del piano SaaS?",
      "haveSaasPlans": "Hai dei piani SaaS creati nell'account Stripe!",
      "disconnectWarning": "Se lo disconnetti, tutti i piani SaaS andranno persi e dovrai ricrearli.",
      "acknowledgeDisconnect": "Sono consapevole del fatto che tutti i miei piani SaaS andranno persi e dovrò ricrearli",
      "disconnect": "Scollega"
    },
    "zoomSuccess": {
      "title": "Spero che tu abbia avuto un'esperienza ottimale!",
      "message": "Grazie per aver partecipato alla chiamata. Aspetto con ansia di accoglierti di nuovo!"
    },
    "supportDashboard": {
      "trialExperienceSpecialist": "Il tuo specialista delle esperienze di prova",
      "successSpecialist": "Il tuo specialista del successo clienti",
      "supportSpecialist": "Il tuo specialista dell'assistenza",
      "jumpOnZoomCall": "Parla con me su Zoom per effettuare la tua chiamata di avvio",
      "jumpOnChat": "Partecipa a una chat con me per ricevere assistenza",
      "joinVideoCallNow": "Partecipa subito alla videochiamata",
      "whatToExpect": "Cosa aspettarsi?",
      "helpArticles": "Articoli della guida",
      "changelog": "Registro delle modifiche",
      "ideasBoard": "Bacheca delle idee"
    },
    "saasDashboard": {
      "title": "Dashboard SaaS",
      "plansAndPricing": "Piani e prezzi"
    },
    "listAccounts": {
      "newInterfaceAvailable": "Ora è disponibile un'interfaccia più ordinata e veloce per questa pagina. Provala!",
      "enableInLabs": "Abilita in Laboratori",
      "pendingTransferRequests": "Hai delle richieste di trasferimento di account secondari in sospeso.",
      "otherAgenciesRequested": "Altre agenzie hanno richiesto di trasferirti degli account secondari.",
      "reviewRequests": "Controlla le richieste",
      "clientList": "Elenco clienti (account secondari)",
      "subAccountTransfers": "Trasferimenti di account secondari"
    },
    "implementationModal": {
      "title": "La tua esperienza di videochiamata HighLevel sta per iniziare!",
      "videoCall": "Videochiamata",
      "whatsNext": "Qual è il prossimo passo?",
      "enteringLobby": "Entrerai nella nostra lobby con altri membri della comunità HighLevel proprio come te!",
      "successConcierge": "Il nostro concierge del successo clienti ti accoglierà e ti metterà in contatto con il primo consulente disponibile per una sessione individuale.",
      "haveReady": "Tieni pronto quanto segue",
      "stableInternet": "Connessione Internet stabile.",
      "videoNameMatches": "Il nome del tuo video corrisponde al tuo nome utente HighLevel.",
      "estimatedDuration": "Durata stimata della sessione",
      "firstVisit": "Prima visita: sessione di onboarding HighLevel (45-60 minuti).",
      "returning": "Ritorno: assistenza per la configurazione dell'implementazione continua (15-25 minuti).",
      "meetingBegins": "La riunione inizierà automaticamente tra <span class=\"text-[#155EEF]\">{ countdown } secondi.</span>  Oppure puoi unirti immediatamente facendo clic sul pulsante qui sotto:",
      "joinNow": "Partecipa subito"
    },
    "gdpr": {
      "logo": "Logo GDPR",
      "dataProtection": "Protezione dei dati e GDPR",
      "introduction": "Introduzione",
      "intro1": "Noi di HighLevel ci impegniamo a proteggere la privacy dei nostri utenti e dei loro clienti. Ci teniamo al corrente degli sviluppi delle leggi sulla protezione dei dati per garantirti la tua sicurezza quando utilizzi la nostra piattaforma.",
      "intro2": "Questa pagina è pensata per spiegare quali sono i regolamenti, come si applicano all'uso della piattaforma HighLevel e i passaggi che abbiamo intrapreso per rispettarli.",
      "intro3": " Dovresti consultare questo documento in concomitanza con la nostra Informativa sulla privacy e contattare un professionista legale specializzato se hai bisogno di ulteriori informazioni o consigli.",
      "gdprRegulation": "Regolamento generale sulla protezione dei dati (GDPR)",
      "regulation1": "Il Regolamento (UE) 2016/679, più comunemente noto come Regolamento generale sulla protezione dei dati (GDPR), è un regolamento UE volto ad armonizzare le normative in materia di protezione dei dati e privacy in tutta l'UE. Le disposizioni del GDPR si applicano ovunque siano coinvolti dati personali di un soggetto UE.",
      "regulation2": "Il GDPR si concentra sul dare agli individui maggiore controllo sui modi in cui i loro dati vengono utilizzati dalle aziende e sul rendere la raccolta e il trattamento dei dati più trasparenti.",
      "regulation3": "Il GDPR è stato incorporato direttamente nella legislazione del Regno Unito al termine del periodo di transizione della Brexit, il che significa che le imprese britanniche devono ancora rispettare le sue disposizioni tramite lo \"UK GDPR\".",
      "basicConcepts": "Concetti di base del GDPR",
      "controllerAndProcessor": "Titolare e responsabile del trattamento",
      "controllerProcessorObligation": "Il GDPR impone vari obblighi a una persona a seconda che sia un titolare o un responsabile del trattamento dei dati personali.",
      "controllerDefinition": " Il titolare del trattamento è un soggetto che decide di trattare dati personali e prende decisioni riguardo alla base giuridica del trattamento e ai metodi che verranno utilizzati. I titolari del trattamento hanno determinati obblighi riguardo ai dati personali, che dovresti conoscere prima di raccogliere dati personali dai tuoi clienti.",
      "processorDefinition": "Il responsabile del trattamento è un soggetto che tratta i dati per conto del titolare del trattamento. Non prende decisioni autonome riguardo ai dati o al loro trattamento, ma li elabora esclusivamente su istruzione del titolare e deve attenersi a tutte le sue indicazioni.",
      "youAreController": "Quando usi il servizio HighLevel, sei un titolare del trattamento. Sei tu a controllare i dati che carichi nel sistema HighLevel, cosa fai con quei dati e perché. Di conseguenza, sei responsabile di garantire che tu abbia una base legale su cui trattare i dati e di non conservarli più a lungo del necessario.",
      "highlevelIsProcessor": "Dovresti assicurarti di comprendere i tuoi obblighi come titolare del trattamento e aggiornare i tuoi sistemi e politiche per consentire il trasferimento legale di dati personali a HighLevel. HighLevel è un responsabile del trattamento dei dati. Noi, attraverso la piattaforma HighLevel, memorizziamo e gestiamo i dati raccolti secondo le tue istruzioni. Non utilizzeremo mai dati personali che hai caricato nel sistema HighLevel per scopi nostri o senza le tue istruzioni.",
      "legalBasisForProcessing": "Base legale per il trattamento",
      "legalBasisRequirement": "I dati personali possono essere raccolti e trattati solo se vi è una base legale per farlo. Le basi legali consentite sono definite nel GDPR.",
      "processorReliesOnCustomers": "In qualità di responsabile del trattamento, HighLevel si affida ai nostri clienti per selezionare la base corretta in cui raccogliere e trattare i dati personali, e per inserire le notifiche e i consensi appropriati. Prima di utilizzare il servizio HighLevel, dovresti prenderti il tempo per identificare quale base legale potrebbe essere disponibile per te e raccogliere e conservare dati personali solo nella misura necessaria per adempiere a tale base. Non dovresti cambiare la base su cui hai raccolto dati personali senza una valida ragione, quindi è importante comprendere i requisiti delle diverse basi e assicurarsi di scegliere quella giusta fin dall'inizio.",
      "dataSubjectAccessRights": "Diritti di accesso dei soggetti interessati",
      "dataSubjectRights": "Il GDPR garantisce ai soggetti interessati (vale a dire i tuoi clienti) determinati diritti relativi ai loro dati personali, incluso il diritto di accedere, correggere e/o cancellare qualsiasi dato relativo a loro.",
      "highlevelEasySystems": "HighLevel ha implementato sistemi semplici per consentirti di informarci qualora ricevessi una richiesta da un soggetto interessato, e per informarti se noi riceviamo una richiesta simile. Ci assicureremo che, seguendo le tue istruzioni, queste richieste vengano prontamente soddisfatte. Dovresti familiarizzare con gli obblighi che ti saranno imposti, inclusi quelli relativi a qualsiasi dato personale che possiedi sui tuoi sistemi o servizi diversi da HighLevel.",
      "transfersToUSA": "Trasferimenti di dati negli USA",
      "transfersRestrictions": "I dati personali non possono essere trasferiti al di fuori dello SEE se non in circostanze specifiche. Utilizziamo le Clausole contrattuali standard come parte del nostro Accordo sul trattamento dei dati, che firmiamo con tutti i nostri clienti.",
      "dataSecurity": "Sicurezza dei dati",
      "securitySafeguards": "Abbiamo adottato rigorose misure e garanzie di sicurezza per garantire che tutti i dati personali in nostro possesso siano conservati in modo sicuro. Testiamo regolarmente i nostri prodotti alla ricerca di bug e vulnerabilità.",
      "backupSystems": "Ci assicuriamo di avere sistemi di backup regolari e di avere sistemi e processi di recupero e integrità dei dati per minimizzare il rischio di corruzione o perdita di dati personali.",
      "stepsForCompliance": "Passi che abbiamo intrapreso per garantire la conformità al GDPR",
      "dutyAsProcessor": "Prendiamo molto sul serio i nostri doveri come responsabile del trattamento. Abbiamo messo in atto una serie di procedure e adottato diverse misure per garantire che rimaniamo conformi al GDPR e che tu possa inviarci legalmente i dati personali raccolti, ad esempio:",
      "standardContractualClauses": "Il nostro Accordo sul trattamento dei dati utilizza le Clausole contrattuali standard per garantire che tu possa inviarci legalmente dati personali negli Stati Uniti.",
      "detectBreaches": "Siamo in grado di rilevare violazioni personali e informare i nostri clienti il prima possibile.",
      "dealWithAccessRequests": "Siamo in grado di gestire le richieste di accesso ai dati e di cancellazione, garantendo di informarti qualora un soggetto interessato presenti tali richieste.",
      "assessedDocumented": "Abbiamo valutato e documentato i dati personali che abbiamo elaborato per tuo conto.",
      "assessedSecurity": "Abbiamo valutato la nostra sicurezza e l'abbiamo aggiornata dove necessario per assicurarci che sia adeguata al livello di rischio che affrontiamo in relazione a una violazione dei dati.",
      "dataProcessingAgreement": "Accordo sul trattamento dei dati",
      "dateUpdated": "Data di aggiornamento: 1 aprile 2023",
      "downloadAgreement": "Scarica accordo",
      "supportEmail": "support{'@'}gohighlevel.com",
      "anyQuestions": "Avete domande?"
    },
    "sendGridSettings": {
      "title": "Impostazioni di SendGrid",
      "settingsForLocations": "Impostazioni di SendGrid per i luoghi",
      "sendGrid": "SendGrid",
      "last12Months": "Ultimi 12 mesi",
      "totalSent": "Invii totali",
      "opens": "Aperture",
      "clicks": "Clic",
      "bounces": "Bounce"
    },
    "launchpadSettings": {
      "disableLaunchpad": "Disabilita Launchpad per tutti i miei luoghi.",
      "description1": "Launchpad è una pagina di destinazione ben progettata che ha dimostrato di aumentare la soddisfazione e la fidelizzazione dei clienti tramite un maggiore utilizzo del prodotto. ",
      "description2": "Il collegamento di GMB, FB, il plugin Webchat, l'utilizzo di app mobili, ecc. si sono rivelate ottime funzionalità che promuovono una fidelizzazione dei clienti più duratura.",
      "confirmDisable": "Vuoi davvero disabilitare Launchpad?"
    },
    "affiliateSettings": {
      "affiliateLinkDescription": "Questo è il tuo link di affiliazione, usalo per permettere alle persone che conosci di creare un account e ricevi il 40% delle loro entrate mensili ricorrenti a vita.",
      "appendToUrls": "Aggiungi questo alla fine dei tuoi URL:",
      "needToSignUp": "Devi registrarti?",
      "goToUrl": "Vai all'URL:",
      "andSignUpUsing": "e registrati usando l'indirizzo email",
      "asYourEmailAddress": "come il tuo indirizzo email per FirstPromoter.",
      "pageSettings": "Impostazioni della pagina",
      "facebookPixelId": "Facebook Pixel ID",
      "pixelId": "ID pixel"
    },
    "agencyAPIKeySettings": {
      "enhancedAccountSecurity": "A partire dal 17 giugno 2024, la sicurezza avanzata degli account verrà abilitata automaticamente sul tuo account per impostazione predefinita. I miglioramenti avanzati della sicurezza includono:",
      "discontinuationOfAutoGeneration": "Interruzione della generazione automatica delle API Key per il luogo",
      "exclusionOfApiKeysInLocationCrudApis": "Esclusione delle API Key nelle API CRUD per il luogo",
      "optOutLink": "Per rinunciare a questa modifica, disabilita la Sicurezza avanzata degli account in <a href=\"/settings/company\">Impostazioni &gt; Impresa</a>",
      "advancedFunctionalityNote": "Questa API è destinata a funzionalità avanzate. Il nostro team di supporto non è in grado di fornire assistenza diretta per quanto riguarda la configurazione dell'API.",
      "developerCouncilInfo": "Offriamo un Consiglio degli sviluppatori che si riunisce per sessioni di consulenza una volta al mese (<a href=\"https://gohighlevel.com/events\">https://gohighlevel.com/events</a>) e un canale Slack della comunità degli sviluppatori dove puoi trovare assistenza dalla comunità e dal nostro team API. (<a href=\"https://www.gohighlevel.com/dev-slack\">https://www.gohighlevel.com/dev-slack</a>)",
      "zapierNote": "Per utilizzare Zapier, è necessario utilizzare l'API Key per il luogo specifico. Puoi ottenerla dall'elenco qui sotto o entrando nell'account tramite lo strumento di cambio nel menu a sinistra.",
      "partOfAdvancedApi": "Questo fa parte dell'API avanzata disponibile nel piano Pro.",
      "upgradeMessage": "Questo fa parte dell'API avanzata disponibile nel piano Pro. <a>Fai clic qui</a> per aggiornare."
    },
    "accountMap": {
      "addAccountManually": "Aggiungi account manualmente"
    },
    "accountTeamsManagement": {
      "settingsAsGroups": "Impostazioni come gruppi."
    },
    "accountDetails": {
      "basicDetails": "Dettagli di base",
      "saas": "SaaS",
      "rebilling": "Rifatturazione",
      "marketplaceApps": "App del marketplace",
      "advancedEmailSettings": "Impostazioni avanzate",
      "calendarSettings": "Impostazioni del calendario"
    },
    "advancedEmailSettings": {
      "controlLocationSettings": "Controlla le impostazioni del luogo",
      "disableAddEmailService": "Disabilita il pulsante Aggiungi servizio email nelle impostazioni dei servizi email dell'account secondario",
      "disableAddSmtp": "Disabilita il pulsante Aggiungi servizio email nelle impostazioni dei servizi email dell'account secondario",
      "restrictSubAccountEmailProvider": "Limita gli utenti degli account secondari ad aggiungere il proprio provider di servizi email",
      "disableAddSmtpDescription": "Limita gli utenti degli account secondari ad aggiungere il proprio provider di servizi email",
      "enableReVerification": "Abilita riverifica per 90 giorni",
      "locationNoLeadConnector": "Il luogo non ha LeadConnector come provider email predefinito",
      "lcEmailNotEnabled": "Il luogo non ha LeadConnector come provider email predefinito",
      "onlyForAgency": "Puoi vedere queste impostazioni abilitate solo per l'agenzia",
      "onlyVisibleForAgency": "Puoi vedere queste impostazioni abilitate solo per l'agenzia",
      "reVerificationDescription": "Ogni stato di verifica dell'email verrà revocato dopo 90 giorni (proteggi la tua reputazione di mittente e garantisci la massima deliverability nella casella di posta)"
    }
  },
  "attributes": {
    "addAttribute": "Aggiungi attributo",
    "attributeName": "Nome attributo",
    "enterAttributeName": "Inserire il nome dell'attributo",
    "number": "Numero",
    "selectAttributeType": "Seleziona tipo di attributo"
  },
  "audit": {
    "changeModal": {
      "additionalMetaData": "Metadati aggiuntivi",
      "title": "Campi aggiunti / aggiornati"
    }
  },
  "bulkActions": {
    "additionalDetails": "Dettagli aggiuntivi",
    "allOnGivenDate": "Tutti nella data indicata",
    "attempted": "Tentativo effettuato",
    "batchQuantity": "Quantità per batch",
    "bulkActionProcessing": "Elaborazione dell'azione in blocco",
    "bulkActionTitle": "Azione in blocco",
    "campaignRequired": "La campagna è obbligatoria",
    "currentStatus": "Stato attuale",
    "delayBetweenBatches": "Tempo tra i batch",
    "dispatchMode": "Modalità di invio: {mode}",
    "editBatchQuantity": "Modifica quantità per batch",
    "emailStats": "Statistiche email",
    "enterBatchSprintLimit": "Inserisca un limite per il batch sprint",
    "hideStats": "Nascondi statistiche",
    "mode": "Modalità",
    "nextProcessingOn": "Prossima elaborazione il",
    "noStatsFound": "Nessuna statistica trovata",
    "parentBulkActionID": "ID azione in blocco principale",
    "pleaseEnterQuantity": "Inserisci una quantità",
    "processAllAsSoonAsPossible": "Elabora tutto il prima possibile",
    "processAllOnGivenDate": "Elabora tutto nella data indicata",
    "processDuring": "Elabora durante",
    "processGraduallyDrip": "Elaborazione graduale (rilascio graduale)",
    "processingAllowedOn": "Elaborazione consentita il",
    "restoredBulkActionId": "ID azione in blocco ripristinata:",
    "revert": "Ripristina",
    "revertedBulkActionId": "ID azione in blocco annullata:",
    "saveChanges": "Salva modifiche",
    "scheduledStart": "Inizio programmato",
    "showErrorLog": "Mostra registro di errori",
    "showImported": "Mostra importati",
    "showStats": "Mostra statistiche",
    "skipped": "Saltato",
    "statistics": "Statistiche",
    "statuses": {
      "complete": "Completata",
      "next-drip": "Prossimo rilascio graduale",
      "notStarted": "Non avviata",
      "processing": "Elaborazione in corso",
      "queueing": "Accodamento",
      "reading": "Lettura",
      "resumed": "Ripresa",
      "reverted": "ripristinata",
      "waiting": "In attesa"
    },
    "successful": "Riuscito",
    "tagsAdded": "Etichette aggiunte",
    "tagsRemoved": "Etichette rimosse",
    "tagsRestored": "Etichette ripristinate",
    "timeElapsed": "Tempo trascorso",
    "totalExported": "Totale esportati",
    "totalMerge": "Totale uniti",
    "unknownError": "Errore sconosciuto",
    "updateBatchQuantity": "Aggiorna la quantità per batch",
    "updated": "Aggiornato",
    "usesDynamicList": "** Utilizza l'elenco dinamico",
    "workflowRequired": "Il flusso di lavoro è obbligatorio"
  },
  "business": {
    "addedToCompany": "Contatto/i aggiunto/i correttamente all'impresa",
    "cantAddMoreContacts": "Impossibile aggiungere più di 50 contatti alla volta",
    "cleanerUi": "Interfaccia utente più chiara",
    "common": {
      "addContact": "Aggiungi contatto",
      "internalServerError": "Errore interno del server",
      "to": "a"
    },
    "companiesNowHave": "Le aziende ora dispongono",
    "companyNoteLabsText": "Le note aziendali sono una funzione dei Laboratori",
    "contactRemoveCompany": "Vuoi davvero rimuovere questo contatto dall'impresa?",
    "moreFunctionalUx": "UX più funzionale",
    "newCompanyUpdate": "Nuovo aggiornamento aziendale!",
    "tabs": "Schede",
    "tasks": {
      "assignTask": "Assegna attività",
      "assignee": "Assegnatario",
      "deleteTask": "Elimina attività",
      "editTask": "Modifica attività",
      "markAsComplete": "Contrassegna come completato",
      "markAsPending": "Contrassegna come in sospeso",
      "nameAndDescription": "Nome e descrizione",
      "noTasksAvailable": "Nessuna attività disponibile"
    },
    "visitLabs": "Visita i Laboratori"
  },
  "calendar": {
    "googleCalendar": "Google Calendar",
    "noSync": "Nessuna sincronizzazione",
    "outlookCalendar": "Calendario di Outlook"
  },
  "common": {
    "topBar": {
      "toggleFrontendDebugger": "Attiva/disattiva debugger frontend"
    },
    "icons": {
      "star": ""
    },
    "errorOccurred": "Si è verificato un errore, riprova",
    "tabs": "Schede",
    "showPassword": "Mostra password",
    "hidePassword": "Nascondi password",
    "goToHomepage": "Vai alla homepage",
    "leadConnectorHqLogo": "Logo Lead Connector HQ",
    "companyLogo": "Logo aziendale",
    "countries": {
      "australia": "Australia",
      "austria": "Austria",
      "czechRepublic": "Repubblica Ceca",
      "belgium": "Belgio",
      "brazil": "Brasile",
      "canada": "Canada",
      "chile": "Cile",
      "denmark": "Danimarca",
      "switzerland": "Svizzera",
      "germany": "Germania",
      "estonia": "Estonia",
      "spain": "Spagna",
      "finland": "Finlandia",
      "france": "Francia",
      "uk": "Regno Unito",
      "hongKong": "Hong Kong",
      "hungary": "Ungheria",
      "ireland": "Irlanda",
      "italy": "Italia",
      "japan": "Giappone",
      "kenya": "Kenya",
      "lithuania": "Lituania",
      "mexico": "Messico",
      "netherlands": "Paesi Bassi",
      "newZealand": "Nuova Zelanda",
      "norway": "Norvegia",
      "philippines": "Filippine",
      "puertoRico": "Porto Rico",
      "poland": "Polonia",
      "portugal": "Portogallo",
      "sweden": "Svezia",
      "singapore": "Singapore",
      "unitedStates": "Stati Uniti",
      "vietnam": "Vietnam",
      "southAfrica": "Sudafrica"
    },
    "countryshortcodes": {
      "ca": "CA",
      "eu": "UE",
      "in": "IN",
      "na": "NA",
      "us": "USA"
    },
    "misc": {
      "0": "0",
      "1": "1",
      "10": "10",
      "10x": "10x",
      "1 (555) 987-6543": "+1 (555) 987-6543",
      "1x": "1x",
      "3x": "3x",
      "720_x_720_px": " 720 x 720 px",
      "x": "x",
      "g": "G",
      "m": "/M",
      "s": "s",
      "k": " K",
      "esc": "ESC",
      "fb": "fb",
      "ghl": "GHL",
      "mrr": "MRR",
      "dnd": "DND",
      "gbp": "GBP",
      "sms": "SMS",
      "api": "API",
      "otp": "OTP",
      "tcr": "TCR",
      "ein": "EIN",
      "acn": "ACN",
      "cbn": "CBN",
      "vat": "IVA",
      "cvv": "CVV",
      "amex": "AMEX",
      "visa": "VISA",
      "mastercard": "MasterCard",
      "dinersClub": "Diners Club",
      "2fa": "2FA",
      "ivr": "IVR",
      "ppc": "PPC",
      "cpaas": "CPaaS",
      "lc": "LC",
      "a2p": "A2P",
      "sha": "SHA",
      "_frameborder0_scrollingauto_width100_height500ifra": "&quot; frameborder=&quot;0&quot; scrolling=&quot;auto&quot; width=&quot;100%&quot; height=&quot;500&quot;&gt;</iframe>",
      "iframe_src": "<iframe src=\"",
      "editNumberPoolStrongnamestrong": "Modifica pool di numeri - <strong>{name}</strong>",
      "displayphonenumber": "PhoneNumber",
      "js_heap_memory": "Memoria heap JS",
      "vuex_store_modules": "Moduli dello store Vuex",
      "vuex_store_size": "Dimensione dello store Vuex",
      "admanagerlogo": "ad-manager-logo",
      "seosearchatlaslogo": "seo-search-atlas-logo",
      "modelimage": "modello-immagine",
      "tipaltiiframe": "tipalti-iframe",
      "fileimage": "file-immagine",
      "urlimage": "url-immagine",
      "msgsndr8": "msgsndr8",
      "testmaindomaincom": "testmain{'@'}domain.com",
      "webdevexamplecom": "web-dev{'@'}example.com",
      "httpexamplecom": "http://esempio.com",
      "smtpgmailcom": "smtp.gmail.com",
      "xyzcomOrUtmcampaignxyz": "xyz.com o utm_campagna=xyz",
      "websitecom": "website.com",
      "strongshakenstirstrongVerifica": "La verifica <strong>SHAKEN/STIR</strong> per il tuo account secondario è completa. Guadagnati la fiducia dei tuoi clienti con le chiamate verificate.",
      "mp3wavfile": "file mp3/wav",
      "usd": "$",
      "1_555_9876543": "+1 (555) 987-6543"
    },
    "stepProgress": "Passaggio {currentStep} di {totalSteps}",
    "loadMore": "Carica di più",
    "1_segment_is_equal_to_a_sms_of_160_characters_clic": "1 segmento è equivalente a un SMS di 160 caratteri. Fai clic sull'icona per conoscere maggiori dettagli sui prezzi.",
    "1_segment_is_equal_to_an_sms_of_160_characters_cli": "1 segmento è equivalente a un SMS di 160 caratteri. Fai clic sull'icona per conoscere maggiori dettagli sui prezzi.",
    "_email": "/ email",
    "_ip": "/ IP",
    "_min": " /min",
    "_of_total": "% del totale",
    "_please_add_a_payment_method_for": "! Aggiungi un metodo di pagamento per ",
    "_segment": " / segmento",
    "_used": "% utilizzato",
    "a_new_twilio_account_needs_to_be_created_before_we": "È necessario creare un nuovo account Twilio prima di poter iniziare la rifatturazione",
    "a_sub_account_can_have_up_to_10_custom_objects_if_": "Un account secondario può avere fino a 10 oggetti personalizzati. Se il limite viene superato, da questo snapshot non verrà creato alcun oggetto personalizzato.",
    "a_twilio_account_is_already_setup_for_this_location": "Un account Twilio è già configurato per questa sede",
    "accountName": "Nome dell'account",
    "account_sid": "SID account:",
    "action": "Azione",
    "actions": "Azioni",
    "activate": "Attiva",
    "active": "Attivo",
    "active_listeners": "Ascoltatori attivi",
    "active_subscriptions": "Abbonamenti attivi",
    "ad_manager": " Gestione annunci",
    "add": "Aggiungi",
    "addAction": "Aggiungi azione",
    "add_eliza": "Aggiunga Eliza",
    "add_image": "Aggiungi immagine",
    "add_payment_method": "Aggiungi metodo di pagamento",
    "add_to_account": "Aggiungi all'account",
    "add_user_icon": "Aggiungi icona utente",
    "add_your_first_email": "Aggiunga la Sua prima email.",
    "address": "Indirizzo",
    "adwords_reporting": "Report di Google Ads",
    "affiliate_manager": "Responsabile affiliati",
    "agency": "Agenzia",
    "agency_logo": "logo dell'agenzia",
    "agency_settings": "Impostazioni dell'agenzia",
    "agent_reporting": "Report sugli agenti",
    "ai_employee": " AI Employee ",
    "all": "Tutto",
    "allow_subaccounts_to_cancel_their_subscription": "Consenti agli account secondari di annullare il proprio abbonamento",
    "allow_subaccounts_to_upgrade_to_a_higher_plan": "Consenti agli account secondari di passare a un piano superiore",
    "allowed_format": "Formato consentito:",
    "am": "AM",
    "announcements_click_to_open_in_new_tab": "Annunci - fai clic per aprire in una nuova scheda",
    "answers": "Risposte",
    "app_name": "Nome dell'app",
    "appointments": "Appuntamenti",
    "apps": " app",
    "ask_ai": "Chiedi all'AI",
    "ask_anything": "Fai una domanda...",
    "assigned_to_another_user": "(Assegnato a un altro utente)",
    "at_least_one_location_is_required": "Almeno un luogo è obbligatorio",
    "attach_snapshot": "Allega snapshot",
    "attribution_reporting": "Report sulle attribuzioni",
    "authorized_representative": "Rappresentante autorizzato",
    "automation_type": "Tipo di automazione",
    "available_hours": "Ore disponibili",
    "avg_memoryinstance": "Memoria media/istanza",
    "back": "Indietro",
    "base_url": "URL di base",
    "between_10_kb_and_5_mb": " Compreso tra 10 KB e 5 MB",
    "birthday_sms": "SMS di compleanno",
    "birthday_sms_with_image": "SMS di compleanno con immagine",
    "blogging": "Blogging",
    "bounced": "Respinta",
    "bulk_requests": "Richieste in blocco",
    "business_email": "Email aziendale",
    "business_hours_configurations": "Configurazioni degli orari di apertura",
    "business_industry": "Settore di attività",
    "business_information": "Dettagli dell'azienda",
    "business_logo": "Logo aziendale",
    "business_niche": "Nicchia aziendale",
    "business_phone": "Telefono aziendale",
    "business_physical_address": "Indirizzo fisico dell'azienda",
    "business_regions_of_operations": "Aree operative dell'azienda",
    "business_registration_id_type": "Tipo di ID di registrazione dell'attività",
    "business_registration_number": "Numero di registrazione dell'attività",
    "business_type": "Tipo di azienda",
    "business_website": "Sito web aziendale",
    "busy": "Occupato",
    "buttons": {
      "cancel": "Annulla",
      "confirm": "Conferma",
      "deleteAll": "Elimina tutto",
      "view": "Visualizza",
      "close": "Chiudi",
      "previous": "Precedente",
      "next": "Successivo",
      "clear": "Rimuovi",
      "save": "Salva",
      "edit": "Modifica",
      "delete": "Elimina",
      "reset": "Reimposta",
      "refresh": "Aggiorna",
      "nextLoading": "Successivo...",
      "copied": "Copiato",
      "notNow": "Non adesso",
      "send": "Invia",
      "send1": "Invia",
      "download": "Scarica",
      "sendNow": "Invia adesso",
      "saved": "Salvato",
      "back": "Indietro",
      "update": "Aggiorna",
      "add": "Aggiungi",
      "submit": "Invia",
      "submitting": "Invio in corso",
      "done": "Fatto",
      "manageUsers": "Gestisci utenti",
      "no": "No",
      "yes": "Sì"
    },
    "calendar": "Calendario",
    "calendar_groups": "Gruppi di calendari",
    "call": "Chiamata",
    "call_reporting": "Report sulle chiamate",
    "call_tracking_is_disabled": "Il tracciamento delle chiamate è disabilitato",
    "call_voicemail_settings": "Impostazioni di chiamata e segreteria telefonica",
    "calls": " chiamate",
    "campaign": "Campagna",
    "campaigns": "Campagne",
    "cancel": " Annulla ",
    "cancel_subscription": "Annulla abbonamento",
    "cancelled": "Annullato",
    "certificates": "Certificati",
    "change": "Modifica",
    "changed_data": "Dati modificati",
    "charge": " Costo",
    "charged_to_customer": "Addebitato al cliente",
    "chat": "Chat",
    "chat_user": "Utente della chat",
    "chat_widget_icon": "Icona del widget della chat",
    "chats_will_be_saved_for_2_days": "Le chat verranno salvate per 2 giorni",
    "check": "controlla",
    "check_number_validity_before_first_sms_block_incom": "Controlla la validità del numero prima del primo SMS, blocca le chiamate spam in arrivo e cerca i nomi dei chiamanti sconosciuti prima di rispondere al telefono. Si applicano costi aggiuntivi",
    "cinque_terre": "Cinque Terre",
    "city": "Città",
    "clear_history": "Cancella Cronologia",
    "click_here": "Fai clic qui",
    "click_on_create_new_snapshot_to_add_one": " Clicchi su Crea nuovo snapshot per aggiungerne uno.",
    "click_to_access_the_highlevel_welcome_course": "Fai clic per accedere al corso di benvenuto HighLevel",
    "click_to_upgrade": "Fai clic per aggiornare",
    "clicked": "Cliccata",
    "clio": "Clio",
    "cloning": "Clonazione",
    "close_debugger": "Chiuda il debugger",
    "close_whatsapp_template_creator": "Chiudi il creatore di modelli WhatsApp",
    "collection": "Collezione",
    "columns": "Colonne",
    "coming_soon": "In arrivo",
    "company_email_": "Email aziendale (",
    "complete_component_data": "Dati completi del componente",
    "complete_event_data": "Dati completi dell'evento",
    "complete_query_data": "Dati completi della query",
    "completed": "Completato",
    "complimentary_credits": "Crediti gratuiti",
    "component": "Componente",
    "component_name": "Nome del Componente",
    "component_type": "Tipo di Componente",
    "components": " componenti",
    "condition": "Condizione",
    "confirm": "CONFIRM",
    "confirmation_message": "Messaggio di conferma",
    "confirmed": "Confermato",
    "connect_with_a_certified_admin_click_to_open_in_ne": "Entra in contatto con un amministratore certificato - fai clic per aprire in una nuova scheda",
    "connect_with_us_start_live_chat": "Entra in contatto con noi - avvia la chat dal vivo",
    "connect_your_stripe_account": "collega il tuo account Stripe ",
    "connect_zoom": "Collega Zoom",
    "consider_leaving_it_blank_should_you_choose_to_use": "Puoi anche lasciare il campo vuoto, se scegli di utilizzare il luogo dell'incontro preconfigurato",
    "contact": "Contatto",
    "contact_support": "contatta l'assistenza",
    "contact_us_call_highlevel_at_18887324197": "Contattaci - chiama HighLevel al numero +1(888)732-4197",
    "contacts": "Contatti",
    "content_ai": "Content AI",
    "controls": "Controlli",
    "conversations": "Conversazioni",
    "copied": "Copiato",
    "cost_borne_by_you": " ai costi sostenuti da te",
    "count": "Numero",
    "country": "Paese",
    "createNewFolder": "Crea nuova cartella",
    "credit_balance": "SALDO CREDITI",
    "current_location_id": "ID posizione attuale",
    "custom": "Personalizzato",
    "custom_email": "Email personalizzata",
    "custom_niche": "Nicchia personalizzata",
    "customer_notifications": "Notifiche ai clienti",
    "customize": "Personalizza",
    "customize_chat_widget": "Personalizza il widget della chat",
    "dashboard_stats": "Statistiche dashboard",
    "data_keys": "Chiavi dati",
    "date": "Data",
    "days": "Giorni",
    "dedicated_ip": "IP dedicato ",
    "default": "Predefinito",
    "default_snapshots": "Snapshot predefiniti",
    "delete": "Elimina",
    "deleted": "eliminato",
    "delivered": "Consegnata",
    "description": "descrizione",
    "details": "Dettagli",
    "disable_gbp_messaging_not_recommended": "disabilita la messaggistica GBP (non consigliato)",
    "disable_tracking": "Disabilita il tracciamento",
    "disabled": "Disabilitato",
    "dismiss": "Scarta",
    "display_name": "Nome visualizzato",
    "do_not_delete": "non eliminare",
    "do_something": "FAI QUALCOSA",
    "do_you_want_to_keep_the_same_or_create_a_new_one": "Vuoi mantenere lo stesso o crearne uno nuovo?",
    "download_application_icon": "Icona di download applicazione",
    "draft": "Bozza",
    "dropdown_icon": "icona dell'elenco a discesa",
    "duplicate": "Duplicato",
    "duration": "Durata",
    "eliza": "Eliza",
    "eliza_bypass_tag_optional": "Etichetta di bypass Eliza (opzionale)",
    "eliza_is_required": "Eliza è necessaria.",
    "eliza_service": "Servizio Eliza",
    "email": "Email",
    "email_resell_settings": "Impostazioni di rivendita via email",
    "email_sending": "Invio di email",
    "email_signature": "Firma Email",
    "enable": "Abilita",
    "enable_beta": " Abilita Beta",
    "enable_company_automation": "Abiliti l'automazione aziendale",
    "enable_disable_deprecated_features": "Abilita / Disabilita funzionalità deprecate",
    "enable_gbp_call_tracking": " Abilita il tracciamento delle chiamate GBP ",
    "enable_gbp_messaging": "abilita la messaggistica GBP",
    "enable_signature_on_all_outgoing_messages": "Attiva la firma per tutti i messaggi in uscita",
    "enabled": "Abilitato",
    "notEnabled": "Non abilitato",
    "enter_a_logical_name": "Inserisci un nome logico",
    "enter_the_exact_business_address_as_it_appears_in_": "Indica l'indirizzo esatto dell'azienda come visualizzato nella voce dell'EIN.",
    "enter_the_exact_legal_business_name_as_registered_": "Indica la ragione sociale esatta dell'azienda, come registrata con l'EIN.",
    "enter_the_full_street_address_as_it_appears_in_the": "Indica l'indirizzo completo come visualizzato nella voce dell'EIN.",
    "enter_user_email": "Inserisci l'email dell'utente",
    "enter_user_phone_number": "Inserisci il numero di telefono dell'utente",
    "enter_your_business_registration_id_type": "Inserisci il tipo di ID di registrazione dell'attività",
    "enter_your_business_vertical_eg_travel": "Inserisci il settore verticale della tua impresa (ad esempio: viaggi)",
    "error_code": "Codice di errore",
    "error_code_chart": "Tabella dei codici di errore",
    "error_while_copying_api_key": "Errore durante la copia della chiave API!",
    "event": "Evento",
    "event_bus_listeners": "Ascoltatori del bus eventi",
    "events": " eventi",
    "everything_in": "Tutto in ",
    "exact": "Exact",
    "execute_this_action_if_the_current_time_falls_in_t": "Esegui questa azione se l'ora corrente rientra in questa finestra, altrimenti attendi la finestra successiva per eseguire l'azione.",
    "extension": "Estensione",
    "facebook": "Facebook",
    "facebook_ads": "Facebook Ads",
    "facebook_ads_reporting": "Report di Facebook Ads",
    "facebook_adsets": "Facebook AdSets",
    "facebook_campaigns": "Campagne Facebook",
    "facebook_icon": "Icona di Facebook",
    "facebook_page": "Pagina Facebook",
    "feature_image": "immagine in evidenza",
    "features": "Funzionalità:",
    "feedback": "Feedback: ",
    "file_path": "Percorso del file",
    "firestore_listeners": "Listener di Firestore",
    "forms": "Moduli",
    "free": "Gratis",
    "fri": "Ven",
    "friendly_business_name": "Nome informale dell'azienda",
    "from": " da ",
    "funnels": "Funnel",
    "gbp_call_tracking": "Tracciamento delle chiamate GBP",
    "gbp_configuration": "Configurazione GBP",
    "general": "Generale",
    "general_information": "Informazioni generali",
    "generating_link_please_wait": "Generazione del link in corso, si prega di attendere...",
    "google_ads_adgroups": "Gruppi di annunci Google Ads",
    "google_ads_ads": "Google Ads Annunci",
    "google_ads_campaigns": "Campagne Google Ads",
    "google_ads_keywords": "Parole chiave di Google Ads",
    "google_business_messaging": "Google Business Messaging",
    "google_business_profile": "Google Business Profile",
    "google_my_business_icon": "Icona di Google My Business",
    "hello": "Salve ",
    "here": "qui",
    "hhmm_a": "hh:mm A",
    "hi": "Salve ",
    "hide": "Nascondi",
    "highlevel_events_click_to_open_in_new_tab": "Eventi di HighLevel - fai clic per aprire in una nuova scheda",
    "how_can_i_help_you_today": "Come posso aiutarti oggi?",
    "how_did_the_call_go": "Com'è andata la chiamata?",
    "how_do_i_calculate_my_email_cost_click_on_the_icon": "Come calcolo il costo delle mie email? Fai clic sull'icona per saperne di più",
    "how_does_it_work": "Come funziona",
    "htmlElement": "Elemento HTML (TODO):",
    "html_element_todo": "Elemento HTML (TODO): ",
    "id": "ID: ",
    "if": "Se",
    "if_activated_the_sender_information_will_be_automa": "Se abilitato, le informazioni sul mittente verranno aggiunte automaticamente al primo SMS di qualsiasi invio di Messaggi in blocco per garantire la conformità agli standard e aumentare i tassi di consegna.",
    "if_activated_we_will_insert_unsubscribe_links_in_y": "Se abilitato, inseriremo dei link per l'annullamento dell'iscrizione nei piè di pagina delle tue email, in modo che i destinatari possano annullare l'iscrizione senza contrassegnare l'email come spam.",
    "ignore_this_update": "Ignora questo aggiornamento",
    "image": "immagine",
    "image_turned_on": "Immagine attivata",
    "imported_date": "Data importata",
    "imported_snapshots": "Snapshot importati",
    "inbound": "In entrata",
    "inbound_number": "Numero in entrata",
    "incoming_call_timeout": "Timeout della chiamata in entrata",
    "instance_id": "ID istanza",
    "instances": "Istanze: ",
    "instructions_mentioned_in_this_page": "istruzioni menzionate in questa pagina",
    "internal": "Interno",
    "intro_message": "Messaggio Introduttivo",
    "intro_question": "Domanda introduttiva",
    "invalid": "Non valido",
    "invoicing": "Fatturazione",
    "is_scheduled_for_deletion_on": " è programmato per l'eliminazione il ",
    "job_position": "Posizione lavorativa",
    "job_title": "Titolo di lavoro",
    "join_our_facebook_group_click_to_open_in_new_tab": "Unisciti al nostro gruppo Facebook - fai clic per aprire in una nuova scheda",
    "jpg_or_png": " JPG o PNG ",
    "just_one_sec": "Solo un attimo...",
    "key_sizes": "Dimensioni principali",
    "label": "etichetta",
    "labels": {
      "sortDirection": "Direzione di ordinamento",
      "tableStyling": "Progettazione della tabella",
      "loadingMore": "Caricamento di più...",
      "loading": "Caricamento in corso...",
      "filter": "Filtra",
      "search": "Cerca...",
      "sortBy": "Ordina per",
      "perPage": "Per pagina",
      "date": "Data",
      "time": "Ora",
      "readMore": "Leggi di più",
      "day": "Giorno",
      "slot": "Fascia oraria",
      "template": "Modello",
      "city": "Città",
      "country": "Paese",
      "state": "Stato",
      "customerName": "Nome del cliente",
      "friendlyName": "Nome semplice",
      "required": "* obbligatorio",
      "addressLine1": "Riga indirizzo 1",
      "addressLine2": "Riga indirizzo 2",
      "postalCode": "Codice postale",
      "searchUsers": "Cerca utenti",
      "unknown": "Sconosciuto",
      "businessName": "Nome dell'azienda"
    },
    "last_updated": "Ultimo aggiornamento",
    "launchpad_icon": "icona Launchpad",
    "lead": "Lead",
    "leadconnector": "LeadConnector",
    "learn_how": "(Scopri come)",
    "legal_business_name": "Ragione sociale dell'azienda",
    "limit_updated_from": " limite aggiornato da ",
    "listeners": " ascoltatori",
    "loading_your_conversation_history": "Caricamento della cronologia delle conversazioni in corso...",
    "location": "Luogo",
    "locations": " luoghi",
    "logical_name": "Nome Logico",
    "logical_name_is_required": "Il nome logico è obbligatorio.",
    "logo": "Logo",
    "mailgun": "MailGun",
    "making_calls": "Effettuare chiamate",
    "manage_custom_email": "Gestisci email personalizzate",
    "marketing": "Marketing",
    "maximize": "Ingrandisci",
    "me_": "Io (",
    "member_since": "Membro dal",
    "membership": "Iscrizione",
    "memory_analysis": "Analisi della Memoria",
    "memory_api_not_available": "API di memoria non disponibile",
    "message": "Messaggio",
    "minimize": "Riduci a icona",
    "minimum_must_be": " Il minimo deve essere ",
    "miscellaneous_charges": "Costi vari",
    "missed_call_text_back": "Invia un messaggio di risposta automatica per le chiamate perse",
    "missed_text_back_call_message": "Messaggio di risposta automatica per le chiamate perse",
    "model": "Modello",
    "module": "Modulo",
    "modules": " Moduli",
    "mon": "Lun",
    "month": "/mese",
    "monthly": "mensilmente",
    "more_emails_in_thread": " altre email nel thread",
    "mount_count": "Numero di montaggi",
    "mount_time": "Tempo di montaggio",
    "moved_to_calendar_settings": "Spostato nelle impostazioni del calendario",
    "multiple_locations_using_same_twilio_account": "Più sedi che utilizzano lo stesso account Twilio",
    "must_be_in_range_of_0": " Deve essere compreso tra 0 e",
    "must_be_less_than_monthly_plan_12": " Deve essere inferiore al piano mensile * 12 ",
    "my_business_is": "La mia azienda è ",
    "my_snapshots": "I miei snapshot",
    "name": "Nome",
    "name_of_other_registration_id_type": "Nome di un altro tipo di ID di registrazione",
    "newFolder": "Nuova cartella",
    "new_task_update": "Nuovo aggiornamento attività!",
    "next": "Successivo",
    "no_answer": "Nessuna risposta",
    "no_bigger_than_25mb": "non più grande di 2,5 MB",
    "no_customer_selected": "Nessun cliente selezionato",
    "no_error_data_found": "Nessun dato di errore trovato",
    "no_payment_method_available": "Nessun metodo di pagamento disponibile",
    "no_provider_found": "Nessun provider trovato",
    "no_snapshots_found": "Nessuno snapshot trovato!",
    "noshow": "Mancata presentazione",
    "not": "Non",
    "not_now": "Non adesso",
    "not_saved": "Non salvato",
    "notes": "Note",
    "notifications": "Notifiche",
    "now": "Ora",
    "numbers_and": " numero/i e ",
    "objective": "Obiettivo:",
    "of": "di",
    "onboarding_video_tutorials_click_to_open_in_new_ta": "Video tutorial di onboarding - fai clic per aprire in una nuova scheda",
    "online_listings": "Inserzioni online",
    "only_assigned_data": "Solo dati assegnati",
    "open_performance_debugger": "Apri il debugger delle prestazioni",
    "opened": "Aperta",
    "opportunities": "Opportunità",
    "options": {
      "ascending": "Ascendente",
      "descending": "Discendente",
      "none": "-- Nessuno --"
    },
    "or_drag_and_drop": "oppure trascina e rilascia",
    "outbound": "In uscita",
    "pagination": "Impaginazione",
    "pass_body_content_here": " Inserisci il contenuto del corpo qui ",
    "password": "Password",
    "paused": "Sospeso",
    "payment_links": "Link di pagamento",
    "payment_methods": "Metodi di pagamento",
    "payment_refund": "Rimborso del pagamento",
    "payment_settings_navigation": "Navigazione delle impostazioni di pagamento",
    "payments": "Pagamenti",
    "payments_integration": "Integrazione di pagamento",
    "pending": "In sospeso",
    "per_page": "Per pagina",
    "percentage": "Percentuale",
    "permanently_delete_this_email": "Elimina definitivamente questa email",
    "personal_logo": "Logo personale",
    "phone": "Telefono",
    "phone_number_with_country_code": "Numero di telefono (con prefisso internazionale)",
    "pick_a_niche": "Seleziona una nicchia",
    "pick_a_snapshot": "Scegli uno snapshot",
    "pick_business_industry": "Seleziona il settore di attività",
    "pick_business_registration_id_type": "Seleziona il tipo di ID di registrazione dell'attività",
    "pick_business_type": "Seleziona il tipo di impresa",
    "pick_job_position": "Seleziona una posizione lavorativa",
    "plans_pricing": "Piani e prezzi",
    "please_enter_a_value_greater_than_20": "Inserisci un valore maggiore di 20.",
    "pm": "PM",
    "points": "Punti",
    "postalzip_code": "Codice postale",
    "previous": "Precedente",
    "privacy_policy_url": "URL dell'informativa sulla privacy",
    "privacy_policy_url_will_be_shown_on_your_google_ag": "L'URL dell'informativa sulla privacy sarà mostrato nelle informazioni del tuo agente Google.",
    "process_your_payment": "Elabora il tuo pagamento",
    "profile_picture": "Foto del profilo",
    "profit": "Profitto",
    "prospecting": " Prospezione ",
    "provide_prebuild_snapshots_to_the_new_accounts": "Fornisci snapshot predefiniti ai nuovi account.",
    "queries": " query",
    "questions": "Domande",
    "quick_actions_icon": "Icona delle azioni rapide",
    "re_generate_key": "Rigenera Chiave",
    "read_only": "Sola Lettura",
    "receipts_settings": "Impostazioni delle ricevute",
    "receiving_calls": "Ricezione chiamate",
    "recent_events": "Eventi recenti",
    "recommended": "Consigliato",
    "recommended_resolution": "Risoluzione consigliata:",
    "reconnect": "Ricollegati ",
    "record_payment": "Registra pagamento",
    "registered": " registrato.",
    "renameFolder": "Rinomina cartella",
    "replied": "Con risposta",
    "representative_email": "Email del rappresentante",
    "resell_settings": " Impostazioni di rivendita",
    "reset": "Reimposta",
    "resolve_now": "Risolvi ora",
    "resource_counts": "Conteggi delle risorse",
    "restore": "Ripristina",
    "results": "Risultati",
    "reviews": "Recensioni",
    "rollover_unused_credits_to_next_month": "Trasferisci i crediti non utilizzati al mese successivo",
    "row": " riga",
    "runNow": "Esegui ora",
    "sample_data": "(Dati di esempio)",
    "sat": "Sab",
    "save": "Salva",
    "save_missed_call_text_settings": "Salva impostazioni di messaggi di chiamata persa",
    "save_staging_url": "Salva l'URL di staging",
    "saved": "Salvato",
    "saving": "Salvataggio in corso...",
    "search": "Cerca",
    "search_active_apps": "Cerca app attive...",
    "search_components": "Cerca componenti...",
    "search_customer": "Cerca cliente",
    "search_email": "Cerca email",
    "search_history": "Cronologia delle ricerche...",
    "search_icon": "icona di ricerca",
    "search_listeners": "Cerca ascoltatori...",
    "search_modules": "Cerca moduli...",
    "search_queries": "Cerca query...",
    "see_this_review_on_gbp": "Vedi questa recensione su GBP ",
    "segments": " segmenti",
    "select": "Seleziona",
    "select_a_snapshot": "Seleziona uno snapshot",
    "monetary": "MONETARIO",
    "pleaseSelectAValue": "Seleziona un valore",
    "select_account": "Seleziona account",
    "select_an_account": "Seleziona un account",
    "select_eliza_bypass_tag": "Seleziona il tag di bypass Eliza",
    "select_phone_number": "Seleziona numero di telefono",
    "select_send_to_eliza_tag": "Seleziona etichetta di invio a Eliza",
    "select_snapshot": " Seleziona snapshot",
    "select_upto": "Seleziona fino a ",
    "selected": "Selezionato: ",
    "send": "Invia",
    "send_to_eliza_tag_optional": "Invia a Eliza Tag (Opzionale) ",
    "seo": " SEO ",
    "settings": "Impostazioni",
    "setup_pending": "Configurazione in sospeso",
    "share": "Condividi",
    "shared_snapshots": "Snapshot condivisi",
    "shared_type": "Tipo condiviso",
    "shipping_and_delivery": "Spedizione e consegna",
    "shipping_origin": "Origine della spedizione",
    "show": "Mostra",
    "showed": "Presentazione",
    "signin_with_single_signon": "Accedi con Single Sign-On",
    "size": "Dimensione",
    "sms_message_sent_to_customer": "Messaggio SMS inviato al cliente",
    "snapshot_date": "Data dello snapshot",
    "snapshot_name": "Nome dello snapshot",
    "social_planner": "Agenda social",
    "sortBy": "Ordina per",
    "sortOptions": {
      "createdDate": "Data di creazione"
    },
    "source": "Fonte",
    "sources": "Fonti:",
    "spent": "Speso",
    "staging_url_settings_for_db_event": "Impostazioni URL di staging (per evento di DB)",
    "state": "Stato",
    "state_prov_region_": "Stato / Provincia / Regione *",
    "states": {
      "alabama": "Alabama",
      "alaska": "Alaska",
      "arizona": "Arizona",
      "arkansas": "Arkansas",
      "california": "California",
      "colorado": "Colorado",
      "connecticut": "Connecticut",
      "delaware": "Delaware",
      "district_of_columbia": "Distretto di Columbia",
      "florida": "Florida",
      "georgia": "Georgia",
      "hawaii": "Hawaii",
      "idaho": "Idaho",
      "illinois": "Illinois",
      "indiana": "Indiana",
      "iowa": "Iowa",
      "kansas": "Kansas",
      "kentucky": "Kentucky",
      "louisiana": "Louisiana",
      "maine": "Maine",
      "maryland": "Maryland",
      "massachusetts": "Massachusetts",
      "michigan": "Michigan",
      "minnesota": "Minnesota",
      "mississippi": "Mississippi",
      "missouri": "Missouri",
      "montana": "Montana",
      "nebraska": "Nebraska",
      "nevada": "Nevada",
      "new_hampshire": "New Hampshire",
      "new_jersey": "New Jersey",
      "new_mexico": "New Mexico",
      "new_york": "New York",
      "north_carolina": "Carolina del Nord",
      "north_dakota": "Dakota del Nord",
      "ohio": "Ohio",
      "oklahoma": "Oklahoma",
      "oregon": "Oregon",
      "pennsylvania": "Pennsylvania",
      "rhode_island": "Rhode Island",
      "south_carolina": "Carolina del Sud",
      "south_dakota": "Dakota del Sud",
      "tennessee": "Tennessee",
      "texas": "Texas",
      "utah": "Utah",
      "vermont": "Vermont",
      "virginia": "Virginia",
      "washington": "Washington",
      "west_virginia": "Virginia Occidentale",
      "wisconsin": "Wisconsin",
      "wyoming": "Wyoming",
      "noRecordsFound": "Nessun record trovato",
      "noEntriesToShow": "Nessuna voce da mostrare",
      "unsuccessful": "Non riuscito",
      "pending": "In sospeso",
      "noUsersFound": "Nessun utente trovato"
    },
    "status": "Stato",
    "stop_delete_operation": "Interrompi operazione di eliminazione",
    "street_address": "Indirizzo",
    "street_address_as_it_appears_in_the_ein_listing": "Indirizzo come visualizzato nella voce dell'EIN.",
    "stripe_icon": "Icona Stripe",
    "stripe_integration": "Integrazione di Stripe",
    "stripe_secret_key": "Chiave segreta Stripe",
    "subscriptions": "Abbonamenti",
    "sun": "Dom",
    "surveys": "Sondaggi",
    "suspend_subaccount_when_their_saas_subscription_fa": "Sospendi l'account secondario quando il suo abbonamento SaaS non riesce.",
    "switchAccount": "Cambia account",
    "switch_off_sections_below_to_disable": "Disattiva le sezioni sottostanti per disabilitare",
    "tags": "Etichette",
    "tax_settings": "Impostazioni tasse",
    "team_management": "Gestione dei team",
    "team_notifications": "Notifiche del team",
    "template": "Modello",
    "terms_and_conditions": "Termini e condizioni",
    "test_mobile_no": "Testa numero di cellulare",
    "text_messages": "Messaggi di testo",
    "the_proposed_size_is_350px_180px": "La dimensione proposta è di 350 px * 180 px",
    "the_proposed_size_is_512512px": "La dimensione proposta è 512*512 pixel",
    "the_selected_language_will_be_used_by_the_system_a": "La lingua selezionata verrà utilizzata dal sistema come predefinita.",
    "the_welcome_message_automatically_appears_after_a_": "Il messaggio di benvenuto appare automaticamente dopo che un utente avvia una nuova conversazione.",
    "these_are_margins_that_are_billed_to_your_clients_": "Si tratta di margini che vengono fatturati ai tuoi clienti in aggiunta ",
    "this_data_will_be_used_for_future_compliance_regis": "Questi dati saranno utilizzati per la futura registrazione della conformità.",
    "this_is_my_twilio_use_same": "Questo è il mio Twilio, usa lo stesso",
    "this_is_visible_to_both_agency_and_location": "Questo è visibile sia all'agenzia che alla sede",
    "this_name_will_be_visible_to_leads_chatting_with_y": "Questo nome sarà visibile ai lead che chattano con la tua azienda",
    "this_setting_is_applicable_with_only_team_calendar": "Questa impostazione è applicabile solo ai calendari del team.",
    "this_stripe_customer_is_already_connected_to_anoth": "Questo cliente Stripe è già collegato a un altro account secondario.",
    "thu": "Gio",
    "tiktok": "TikTok",
    "time_signed": " Ora di firma: ",
    "time_zone_": "Fuso orario *",
    "timestamp": "Timestamp",
    "title": "Titolo",
    "to_resolve_this_problem_follow_the": "Per risolvere questo problema, segui le ",
    "token": "Token:",
    "total": "Totale: ",
    "trigger_link": "Link di attivazione",
    "triggers": "Trigger",
    "tue": "Mar",
    "twilio": "Twilio",
    "twilio_setup_pending": "Configurazione di Twilio in attesa",
    "type": "Tipo",
    "type_campaign_objective": "Digita l'obiettivo della campagna",
    "type_message": "Digita messaggio",
    "unsavedChangesWarning": "Le tue modifiche non verranno salvate. Vuoi davvero uscire?",
    "unsaved_changes": "Modifiche non salvate",
    "unsubscribed": "Iscrizione annullata",
    "unsuccessful": "Non riuscito",
    "update_business_profile_details": "Aggiorna i dettagli del profilo aziendale",
    "update_is_inprogress_visit_integrations_page_to_fi": "L'aggiornamento è in corso, visita la pagina delle integrazioni per saperne di più.",
    "update_url": "Aggiorna URL",
    "updated_date": "Data di aggiornamento",
    "updates": " aggiornamenti",
    "updating": "Aggiornamento in corso...",
    "upgrade_to_agency_pro": "passa al piano Agency Pro ",
    "upload": "Carica",
    "upload_a_file": "Carica un file",
    "usd": " USD",
    "use_this_for_zapier_and_api_integration": "Da usare per l'integrazione di API e Zapier.",
    "user_email": "Email dell'utente",
    "user_permissions": "Autorizzazioni utente",
    "user_role": "Ruolo utente",
    "user_type": "Tipo di utente",
    "valid": "Valido",
    "verification_status": "Stato di verifica",
    "verify": "Verifica",
    "verify_email_using_otp": "Verifica l'email tramite OTP",
    "view_less": " Visualizza meno ",
    "visiblehidden": "Visibile/Nascosto",
    "visit_our_help_center_click_to_open_in_new_tab": "Visita il nostro Centro assistenza - fai clic per aprire in una nuova scheda",
    "voicemail": "Segreteria telefonica",
    "wave_integration": "Integrazione di Wave",
    "we_have_found_some_errors_in_your_contact_fields_c": "Abbiamo trovato alcuni errori nei tuoi campi di contatto. Fai clic sulla cartella per visualizzarli e risolverli.",
    "websites": "Siti web",
    "wed": "Mer",
    "welcome_message": "Messaggio di benvenuto",
    "whatsapp": " WhatsApp",
    "whatsapp_icon": "Icona WhatsApp",
    "when": "Quando",
    "when_selected_calls_will_be_routed_to_your_mobile_": "Quando selezioni questa opzione, le chiamate verranno indirizzate alla tua app per dispositivi mobili. (Supportato sia su iOS che su Android)",
    "when_selected_calls_will_be_routed_to_your_web_app": "Quando selezioni questa opzione, le chiamate verranno indirizzate alla tua app web.",
    "which_business_do_you_want_to_link_to_this_locatio": "A quale azienda desideri collegare questo luogo?",
    "widget_code": "Codice Widget",
    "will_give_you_about": " avrai circa",
    "wordpress": "WordPress",
    "wordpress_icon": "Icona WordPress",
    "workflows": "Flussi di lavoro",
    "xero_integration": "Integrazione Xero",
    "you_need_to_complete_few_easy_steps_to_delete_this": "Devi completare alcuni semplici passaggi per eliminare questo luogo",
    "you_are_not_authorized_to_perform_this_action_only": "Non hai l'autorizzazione per eseguire questa azione. Solo gli amministratori dell'agenzia possono eliminare gli account secondari.",
    "your_email_cost": "Il costo della Sua email",
    "your_facebook_page_has_been_integrated_however_the": "La Sua pagina Facebook è stata integrata. Tuttavia, le seguenti funzionalità non funzioneranno poiché LeadConnector non dispone delle autorizzazioni necessarie: ",
    "your_outlook_connection_has_expired_please_disconn": "Il collegamento a Outlook è scaduto. Scollega e ricollega l'account per ristabilire il collegamento.",
    "zip_code": "CAP",
    "zoom_connected_please_close_this_modal": "Zoom Connected, per favore chiuda questa finestra modale",
    "hidden": "Nascosto",
    "messageDetails": "Informazioni sul messaggio",
    "openOptions": "Apri opzioni",
    "progress": "Avanzamento",
    "close": "Chiudi",
    "loading": "Caricamento",
    "fullName": "Nome completo",
    "languages": "Lingue",
    "phoneNumber": "Numero di telefono",
    "phoneNumberWithCountry": "Numero di telefono con prefisso internazionale",
    "sendMessage": "Invia messaggio",
    "services": "Servizi",
    "servicesProvided": "Servizi forniti",
    "pleaseProvideAValid": "Fornisci un numero di telefono valido.",
    "copy": "Copia",
    "editApiKey": "Modifica API Key",
    "confirmPay": "Conferma e paga",
    "contactUs": "Contattaci",
    "decline": "Rifiuta",
    "deleteSubaccount": "Elimina account secondario",
    "disabled1": "disabilitato",
    "purchaseSummary": "Riepilogo dell'acquisto",
    "subscriptionPlan": "Piano di abbonamento",
    "businessName": "Nome dell'azienda",
    "chooseOne": "Scegline uno.",
    "stateProvRegion": "Stato / Provincia / Regione",
    "streetAddress": "Indirizzo stradale",
    "timeZone": "Fuso orario",
    "website": "Sito web",
    "zipPostalCode": "CAP / Codice postale",
    "apiKey": "API Key",
    "createdAt": "Creato:",
    "deleteAllLocationApi": "Elimina tutte le API key di localizzazione",
    "deleteApiKey": "Elimina API Key",
    "generatedBy": "Generato da",
    "lastUsedAt": "Ultimo utilizzo:",
    "pageNavigation": "Navigazione della pagina",
    "somethingWentWrong": "Qualcosa è andato storto!",
    "clickHere": "Fai clic qui",
    "emailRebillingActive": "Rifatturazione email attiva",
    "saasSubscriptionActive": "Abbonamento SaaS attivo",
    "scheduledForDeletion": "Eliminazione programmata",
    "twilioRebillingActive": "Rifatturazione Twilio attiva",
    "iAcknowledgeThisIs": "Riconosco che si tratta di un account secondario valido e ho verificato il caso d'uso dell'invio di più di {limit} {type} / giorno",
    "iAcknowledgeThisIs1": "Riconosco che si tratta di un account secondario valido e ho verificato il caso d'uso dell'invio, quindi modifico il limite quotidiano di SMS",
    "emailSentByLocation": "Email inviate per luogo finora oggi.",
    "goToSmsLimit": "Vai alle impostazioni del limite di SMS",
    "toIncreaseTheLimit": "Per aumentare ulteriormente il limite, contatta il team di supporto.",
    "newLimitOfLimit": "Il nuovo limite di {limit} è scaduto. Inserisci un valore compreso tra {min} e {max}",
    "typeLimitUpdatedSuccessfully": "Limite di {type} aggiornato correttamente",
    "locationsCurrentLimitIs": "Il limite attuale del luogo è {current}. Puoi aggiornare il limite solo tra {min} e {max} da qui. Per qualsiasi aggiornamento del limite oltre {maxAllowed}, contatta il team di supporto.",
    "notNow": "Non adesso",
    "smsSentByLocation": "SMS inviati per luogo finora oggi.",
    "youHaveSuccessfullyUpdated": "Hai aggiornato con successo il limite",
    "willAutoUnlockIn": "Si sbloccherà automaticamente tra",
    "contactType": "Tipo di contatto",
    "createdBy": "Creato da:",
    "createdOn": "Data di creazione:",
    "dateOfBirth": "Data di nascita",
    "emailAddress": "Indirizzo email",
    "firstName": "Nome",
    "lastName": "Cognome",
    "twilioLookupMarkedThis": "Twilio Lookup ha contrassegnato questo numero di telefono come \"non valido\".",
    "twilioLookupStatedThis": "Twilio Lookup ha dichiarato che questo è un numero {type}, quindi non riceverà SMS.",
    "accountSnapshot": "Snapshot dell'account",
    "auditLogs": "Registri di controllo",
    "account": "Account",
    "selectAccount": "Seleziona account",
    "facebookUrl": "URL di Facebook",
    "instagram": "Instagram",
    "linkedin": "LinkedIn",
    "twitter": "Twitter",
    "twitterUrl": "URL di Twitter",
    "youtubeUrl": "URL di YouTube",
    "text": "Testo",
    "allTagsLinkedTo": "Tutte le etichette collegate ai contatti selezionati devono essere rimosse",
    "automation": "Automazione",
    "bulkOperation": "Operazione in blocco",
    "campaign1": "Campagna",
    "created": "Creato",
    "dateTime": "Data e ora",
    "description1": "Descrizione",
    "drip": "Rilascio graduale",
    "edit": "Modifica",
    "someStatsAreNot": "Alcune statistiche non sono disponibili se il provider è SMTP. La precisione delle metriche dipende dal dominio del destinatario.",
    "error": "Errore",
    "from1": "Da",
    "immediately": "Immediatamente",
    "pause": "Sospendi",
    "processed": "Elaborazione eseguita",
    "queued": "In coda",
    "restored": "Ripristinato",
    "resume": "Riprendi",
    "sent": "Inviato",
    "scheduled": "Programmato",
    "success": "Successo",
    "templateName": "Nome del modello",
    "total1": "Totale",
    "totalAttempted": "Totale tentativi",
    "user": "Utente",
    "viewDetails": "Visualizza dettagli",
    "workflow": "Flusso di lavoro",
    "company": "Impresa",
    "note": "Nota",
    "perPage": "per pagina",
    "showing": "Presentazione",
    "task": "Attività",
    "tasks": "Attività",
    "customFields": "Campi personalizzati",
    "dueDate": "Data di scadenza",
    "tryNow": "Provalo subito!",
    "archive": "Archivia",
    "markAsRead": "Contrassegna come letto",
    "markAsUnread": "Contrassegna come non letto",
    "youNeedToAdd": "Devi aggiungere un calendario per iniziare a pianificare gli appuntamenti.",
    "additionalNotes": "Note aggiuntive",
    "appointmentStatus": "Stato dell'appuntamento",
    "appointmentTitle": "Titolo dell'appuntamento",
    "contactName": "Nome del contatto",
    "contactTimezoneUsedFor": "Fuso orario del contatto (utilizzato per il promemoria)",
    "day": "Giorno",
    "editAppointment": "Modifica appuntamento",
    "nameRequired": "Il nome è obbligatorio",
    "slotRequired": "La fascia oraria è obbligatoria",
    "teamMemberIsRequired": "Il membro del team è obbligatorio.",
    "meetingLocation": "Luogo dell'incontro",
    "pickTeamMember": "Scegli membro del team",
    "phoneNumbers": "Numeri di telefono",
    "roundRobin": "A rotazione",
    "selectCalendar": "Seleziona calendario",
    "selectTeamMember": "Seleziona membro del team",
    "actionRequired": "Azione richiesta",
    "scheduleAppointment": "Programma un appuntamento",
    "considerLeavingItBlank": "Puoi anche lasciare il campo vuoto, se scegli di utilizzare il titolo dell'appuntamento preconfigurato",
    "assignedTo": "Assegnato a",
    "download": "Scarica",
    "loadingTranscription": "Caricamento della trascrizione in corso...",
    "mute": "Disattiva il microfono",
    "playpause": "Riproduci/Metti in pausa",
    "playbackSpeed": "Velocità di riproduzione",
    "remove": "Rimuovi",
    "stop": "Interrompi",
    "timePlayedTotalTime": "Tempo di gioco : Tempo totale",
    "viewTranscript": "Visualizza trascrizione",
    "below": "sotto",
    "calls1": "Chiamate",
    "liveChat": "Live Chat",
    "whatsapp1": "WhatsApp",
    "chatConversationAssigned": "Conversazione di chat assegnata",
    "youAreChoosingNot": "Stai scegliendo di non eliminare e chiudere l'account secondario LC Phone, ciò significa che ti verrà comunque addebitato tutto l'utilizzo indipendentemente dal luogo addebitato o meno.",
    "thingsAreJustGetting": "Siamo solo all'inizio, esploriamo come GHL può aiutarti a far crescere la tua azienda.\nNel frattempo, puoi continuare a inviare messaggi senza limiti",
    "wohooConversationsAreFlowing": "Evviva! Ora le conversazioni scorrono alla grande",
    "conversationBegan": "La conversazione è iniziata",
    "fetchOlderMessages": "Recupera i messaggi più vecchi",
    "inboundDndHasBeen": "La funzione DND in entrata è stata attivata per questo contatto",
    "internalComment": "Commento interno",
    "confirmByTyping": "Conferma digitando",
    "iConfirmToDisconnect": "Confermo di scollegare e chiudere l'account LC Phone per questo luogo. Sono consapevole che ciò significa che tutti i numeri e le campagne A2P verranno eliminati e non potranno essere recuperati.",
    "iConfirmThatI": "Confermo di averne discusso con il mio cliente e di avere l'autorità per intraprendere questa azione",
    "connect": "Collega",
    "disputeThisReview": "Contesta questa recensione",
    "dndIsActiveFor": "La funzione DND è attiva per le chiamate",
    "off": "Disabilitato",
    "done": "Fatto",
    "downloadFile": "Scarica file",
    "AddAccount": "+ Aggiungi account",
    "attachFile": "Allega file",
    "clickHereToAdd": "Fai clic qui per aggiungerne uno.",
    "customerName": "Nome del cliente",
    "customerPhone": "Telefono del cliente",
    "orEnterAMessage": "Oppure digita un messaggio",
    "fromEmail": "Email mittente",
    "fromName": "Nome mittente",
    "youDontHaveAny": "Non hai ancora nessun modello.",
    "requestPayment": "Richiedi pagamento",
    "schedule": "Programma",
    "selectATemplate": "Seleziona un modello",
    "sendNow": "Invia ora",
    "smtpProvidersHasSome": "I provider SMTP hanno alcune limitazioni. Fai clic qui per saperne di più.",
    "subject": "Oggetto",
    "useATemplateSnippet": "Utilizza un modello (Frammento)",
    "deliveredtotalDelivered": "Consegne completate: {delivered}/{total}",
    "countMoreEmailsIn": "Altre {count} email nel thread",
    "primary": "(Primario)",
    "reply": "Risposta",
    "respond": "Rispondi",
    "retry": "Riprova",
    "to": "A:",
    "fbCommentReplyDm": "Risposta al commento su FB - DM",
    "fbMessage": "Messaggio FB",
    "theseAttachmentsMayNot": "Questi allegati potrebbero non essere più supportati.",
    "urlCannotBeFound": "L'URL non è stato trovato",
    "activity": "Attività",
    "filters": "Filtri",
    "goToPost": "Vai al post",
    "inboundCall": "Chiamata in entrata",
    "instagramDm": "DM di Instagram",
    "internalChat": "Chat interna",
    "search2": "Cerca...",
    "starred": "Contrassegnato con la stella",
    "leftAVoicemail": "Ha lasciato un messaggio nella segreteria telefonica",
    "manual": "Manuale",
    "mergeFields": "Unisci campi",
    "addToDocuments": "Aggiungi ai documenti",
    "failedToAddAttachments": "Aggiunta degli allegati ai documenti non riuscita",
    "attachmentsAddedToDocuments": "Allegati aggiunti correttamente ai documenti",
    "newCommentOnPagename": "Nuovo commento al post di {pageName}.",
    "outboundCall": "Chiamata in uscita",
    "replyAsDm": "Rispondi nei DM",
    "replyingAsAPrivate": "La risposta in DM privato non è disponibile per i commenti più vecchi di 7 giorni.",
    "reportFeedbackForAi": "Segnala feedback per l'AI",
    "storyMention": "Menzione nella storia",
    "storyReply": "Risposta alla storia",
    "bulkRequest": "Richiesta in blocco",
    "eventsAreCurrentlyCaptured": "Gli eventi vengono attualmente acquisiti solo per l'indirizzo email del contatto.",
    "failed": "Non riuscito",
    "gbpMessage": "Messaggio GBP",
    "pageName": "Nome della pagina",
    "unknown": "Sconosciuto",
    "typeAMessage": "Digita un messaggio",
    "new": "Nuovo",
    "newAppointmentBookedBy": "Nuovo appuntamento prenotato da",
    "customerNameRequired": "Il nome del cliente è obbligatorio",
    "messageIsRequired": "Il messaggio è obbligatorio",
    "pickATemplateTo": "Scegli un modello da usare.",
    "newMessage": "Nuovo messaggio",
    "newTask": "Nuova attività",
    "toMakeACall": "Per effettuare una chiamata, inserisci un numero di telefono in questo campo.",
    "primary1": "Primario",
    "provider": "Provider",
    "refresh": "Aggiorna",
    "resetPassword": "Ripristina password",
    "thisReviewHasAlready": "Questa recensione è già stata pubblicata su {network}. Vuoi davvero ripubblicarla?",
    "seeThisReviewOn": "Vedi questa recensione su GBP",
    "reviewResponse": "Risposta alla recensione",
    "searchUsers": "Cerca utenti",
    "sendEmail": "Invia email",
    "sending": "Invio in corso...",
    "thisSubaccountHasPhonenumberco": "Questo account secondario ha {phoneNumberCount} numeri e {campaignsCount} campagna/e A2P. L'eliminazione di questo account comporterà comunque addebiti se l'account del sistema telefonico LC non viene scollegato e chiuso.",
    "thisSubaccountDoesNot": "Questo account secondario non ha numeri e campagne A2P. La sospensione di questo account non comporterà alcun addebito, ma ti consigliamo di scollegare e chiudere l'account LC Phone.",
    "summary": "Riepilogo",
    "unassigned": "Non assegnato",
    "viewSubmission": "Visualizza invio",
    "contactSupport": "Contatta l'assistenza",
    "create": "Crea",
    "illDoThisLater": "Lo farò in un secondo momento",
    "enterBusinessName": "Inserisci il nome dell'azienda",
    "firstNameOfThe": "Nome del titolare dell'azienda",
    "mobileBusinessPhone": "Cellulare / Telefono aziendale",
    "iDontHaveA": "Non ho un sito web",
    "clientName": "Nome cliente",
    "letUsSetupYour": "Configuriamo il tuo account o il tuo primo cliente",
    "clientNameIsRequired": "Il nome del cliente è obbligatorio",
    "pleaseEnterAValid": "Inserisci un indirizzo email valido",
    "emailAddressIsRequired": "L'indirizzo email è obbligatorio",
    "firstNameIsRequired": "Il nome è obbligatorio",
    "lastNameIsRequired": "Il cognome è obbligatorio",
    "phoneNumberIsRequired": "Il numero di telefono è obbligatorio",
    "copyOfName": "Copia di {name}",
    "goToDashboard": "Vai alla dashboard",
    "permissionsNotEnabled": "Autorizzazioni non abilitate!",
    "createAndSellCustom": "Crea e vendi prodotti personalizzati con dropshipping con stampa su richiesta",
    "viewApp": "Visualizza l'app",
    "seamlessFulfillmentRealtimeShi": "Evasione senza soluzione di continuità e tariffe di spedizione in tempo reale per i tuoi negozi e-commerce",
    "learnMore": "Scopri di più",
    "activateFormMapping": "Attiva la mappatura dei moduli",
    "avatarName": "Nome avatar",
    "formFields": "Campi del modulo",
    "formName": "Nome del modulo",
    "mapFields": "Mappa i campi",
    "update": "Aggiorna",
    "pauseSubaccount": "Metti in pausa account secondario",
    "pausing": "Sospensione in corso...",
    "subaccount": "account secondario",
    "howItWorks": "Come funziona",
    "uponCompletingThisAction": "Al termine di questa azione, la richiesta di trasferimento verrà inviata all'agenzia ricevente ({relNo}). L'account secondario verrà trasferito immediatamente dopo essere stato accettato. Tieni presente che questa azione è irreversibile.",
    "ejectSubaccount": "Espelli l'account secondario",
    "newAgencyCreationMail": "Email di creazione della nuova agenzia inviata all'utente selezionato. L'utente può creare una nuova agenzia facendo clic sul link inviato per posta.",
    "unableToTransferSubaccount": "Impossibile trasferire l'account secondario a questa agenzia.",
    "nominateAccountOwnerFor": "Nomina il titolare dell'account per il nuovo account",
    "pleaseConfirmOwnershipWill": "Conferma che la proprietà sarà trasferita a",
    "scheduledDate": "Data programmata",
    "thisDateIsBased": "Questa data si basa sul fuso orario di questa azienda, che è il seguente: {timezone}",
    "campaignName": "Nome campagna",
    "copyCampaign": "Copia campagna",
    "endTime": "Ora di fine",
    "event10xEmail4": "Evento: 10X Email 4 (distribuzione delle inserzioni) ",
    "10xEmail1Reviews": "10X Email 1 (recensioni)",
    "fromAddress": "Indirizzo mittente",
    "leadValue": "Valore di lead",
    "option1": "Opzione 1",
    "option2": "Opzione 2",
    "option3": "Opzione 3",
    "preview": "Anteprima",
    "selectCampaign": "Seleziona campagna",
    "startTime": "Ora di inizio",
    "time": "Ora",
    "users": "Utenti",
    "noRecordsFound": "Nessun record trovato",
    "pageDetail": "Dettaglio pagina",
    "selectAll": "Seleziona tutto",
    "submission": "Invio",
    "addProduct": "Aggiungi prodotto",
    "visitors": "visitatori",
    "By": " da",
    "conversions": "Tasso di conversione ",
    "liveReviews": "Recensioni live",
    "liveVisitors": "Visitatori live",
    "pageVisits": "Visite alla pagina",
    "stream": "Flusso",
    "addOneOrMore": "Aggiungi uno o più URL di pagina o copiali direttamente dal tuo browser web.",
    "WeWillAutomatically": " Tracceremo automaticamente i visitatori del tuo sito in tempo reale. ",
    "connectYourLocationsFacebook": "Collega l'account Facebook della tua posizione",
    "connected": "Collegato!",
    "Contains": " contiene ",
    "expression": "Espressione",
    "facebookAccount": "Account Facebook",
    "wowYouDontNeed": "Wow! Non devi configurare nulla qui, puoi andare avanti.",
    "Regex": " regex ",
    "selectUrlMatchType": "Seleziona il tipo di corrispondenza URL",
    "Simple": " semplice ",
    "LivePreview": " Anteprima live",
    "seconds": "secondi",
    "launch": "Lancio ",
    "decorativeVector1": "Vettore decorativo 1",
    "showingFromToTo": "Mostra da {from} a {to} di {total} voci",
    "cloneProduct": "Clona prodotto",
    "connectFacebookInstagram": "Connetti Facebook e Instagram",
    "connectPage": "Collega la pagina!",
    "everythingIn": "Tutto in",
    "agentChat25": "Chat con un agente (~ 2-5 minuti di attesa)",
    "aiSupportChat": "Chat di supporto AI",
    "startChat": "Avvia chat",
    "locations1": "luoghi",
    "phone1": "telefono",
    "slack": "Slack",
    "segments1": "segmenti",
    "areYouSureYou": "Vuoi davvero eliminare questa cartella?",
    "verified": "Verificato",
    "highlevelPrice": "Prezzo di HighLevel",
    "howDoesItWork": "Come funziona?",
    "payNow": "Paga ora",
    "priceMustBeMore": "Il prezzo deve essere maggiore o uguale al prezzo di HighLevel",
    "saving2": "Salvataggio",
    "yourPrice": "Il tuo prezzo",
    "yourProfit": "Il tuo profitto",
    "youNeedToComplete": "È necessario completare alcuni semplici passaggi di conformità per disabilitare la modalità SaaS per questo luogo",
    "youAreNotAuthorized": "Non hai l'autorizzazione per eseguire questa azione. Solo gli amministratori dell'agenzia possono eseguirla.",
    "disableSaasModeFor": "Disabilita modalità SaaS per {name}",
    "companyBilling": "Fatturazione aziendale",
    "bccEmailsCommaDelimited": "Email in CCN (delimitate da virgole)",
    "unableToDeleteMailgun": "Impossibile eliminare l'account Mailgun, contatta l'assistenza.",
    "forwardingAddress": "Indirizzo di inoltro",
    "forwardingAddressesCommaDelimi": "Indirizzi di inoltro (delimitati da virgole)",
    "amount": "Importo",
    "billingDate": "Data di fatturazione",
    "debugWalletTransactionsTotal": "DEBUG transazioni del portafoglio, totale: {count}",
    "detailedTransactions": "Transazioni dettagliate",
    "transactionsOnlyAfter26th": "Sono elencate e disponibili per l'esportazione solo le transazioni successive al 26 aprile 2022",
    "someRecordsMayTake": "Per alcuni record, potrebbero volerci 24 ore perché vengano aggiornati qui.",
    "totalBalance": "Saldo totale",
    "walletTransactions": "Transazioni portafoglio",
    "walletTransactionsAllDate": "Transazioni portafoglio - Tutte - {date}",
    "enterMessage": "Inserisci messaggio",
    "applyThisChangeTo": "Applica questa modifica a tutti gli account secondari.",
    "characters": "Caratteri",
    "iConfirmThatI1": "Confermo di averne discusso con il mio cliente e di avere la sua approvazione.",
    "iConfirmThatI2": "Confermo che mi assicurerò che tutti gli SMS inviati da questo account siano conformi alle politiche attuali.",
    "theContentsOfThis": "Il contenuto di questo messaggio verrà aggiunto automaticamente al primo SMS inviato tramite i Messaggi in blocco.",
    "iConfirmThatSms": "Confermo che i messaggi SMS saranno inviati solo ai contatti che hanno acconsentito a riceverli.",
    "quickTip": "Suggerimento rapido",
    "messageWillBeAppended": "Il messaggio verrà aggiunto al primo SMS di una conversione se questo non contiene la dicitura per l'annullamento dell'iscrizione",
    "readMore": "Leggi di più",
    "noncompliantActivityMayLead": "Un'attività non conforme agli standard può portare alla sospensione delle funzionalità del tuo account relative alle azioni vocali e agli SMS.",
    "typeConfirmBelowTo": "Digita Conferma qui sotto per procedere",
    "products": "Prodotti",
    "chooseCountry": "Scegli il paese...",
    "email2": "Email*",
    "firstName1": "Nome*",
    "lastName1": "Cognome*",
    "brandDetails": "Informazioni sul brand",
    "brandName": "Nome del brand*",
    "useEitherLegalName": "Usa il nome legale dell'organizzazione che invia i messaggi, oppure il tuo nome se questo brand non è per un'organizzazione.",
    "businessIndustry": "Settore di attività*",
    "chooseVertical": "Scegli una verticale...",
    "mobileNumberForOtp": "Numero di cellulare per la verifica OTP (con prefisso paese)*",
    "pleaseProvideAMobile": "Fornisci un numero di cellulare a cui hai accesso per confermare la verifica OTP. Saranno accettati solo numeri degli USA o del Canada. Non puoi utilizzare un numero di telefono CPaaS come quello ottenuto da LeadConnector. Non puoi usare lo stesso numero di cellulare per registrare più di 3 brand di ditta individuale. Questo limite è gestito da TCR.",
    "increasedDeliveryRate": "Tasso di consegna più elevato",
    "sendUpto3000Segments": "Invia fino a 3000 segmenti al giorno",
    "businessDetails": "Dettagli aziendali",
    "thereWasSomeIssue": "Si è verificato un problema durante l'invio del profilo.",
    "yourProfileSubmissionFailed": "L'invio del tuo profilo non è riuscito.",
    "endUserConsent": "Consenso dell'utente finale",
    "minLength40Characters": "Lunghezza minima: 40 caratteri. Lunghezza massima: 2048 caratteri.",
    "closeExamples": "Chiudi esempi",
    "sampleMessage1": "Messaggio di esempio #1*",
    "seeExamples": "Vedi esempi",
    "enterCampaignDetails": "Inserisci i dettagli della campagna",
    "youWillReceiveAn": "Riceverai un messaggio OTP al numero di cellulare fornito per la verifica da parte di TCR. Rispondi \"Yes\" entro 24 ore dalla ricezione dell'SMS.",
    "brandNameIsRequired": "Il nome del brand è obbligatorio.",
    "businessVerticalIsRequired": "La verticale di attività è obbligatoria.",
    "mobileNumberIsRequired": "Il numero di cellulare è obbligatorio.",
    "hideDetail": "Nascondi dettagli",
    "showDetail": "Mostra dettagli",
    "people": "persone",
    "person": "persona",
    "after": "dopo",
    "before": "prima",
    "hour": "ora",
    "hours": "ore",
    "minute": "minuto",
    "minutes": "minuti",
    "triggerLinksEmbeddedIn": "link di attivazione (incorporati nel messaggio) cliccati come % dei messaggi inviati",
    "addNewEvent": "Aggiungi nuovo evento",
    "addTask": "Aggiungi attività",
    "manualCall": "Chiamata manuale",
    "manualSms": "SMS manuale",
    "messenger": "Messenger",
    "wait": "Attendi",
    "webhook": "Webhook",
    "about": "Informazioni",
    "accessRestricted": "Accesso limitato",
    "addPartner": "Aggiungi partner",
    "addPartnerForm": "Aggiungi il modulo per i partner",
    "affiliatePortal": "Portale affiliati",
    "badges": "Distintivi",
    "aBriefBio": "Una breve biografia",
    "dashboard": "Dashboard",
    "experience": "Esperienza",
    "industryServed": "Settore di operatività",
    "instagramAccount": "Account Instagram",
    "invoiceHistory": "Cronologia delle fatture",
    "englishGermanHindi": "English, German, Hindi",
    "linkToWebsite": "link al sito web",
    "linkedinAccount": "Account LinkedIn",
    "locationId": "ID luogo",
    "partnerName": "Nome del partner",
    "partnerStatus": "Stato del partner",
    "paymentDetails": "Dati di pagamento",
    "paymentHistory": "Cronologia dei pagamenti",
    "profilePhoto": "Foto del profilo",
    "profilePhotoUrl": "URL della foto del profilo",
    "promoterReports": "Report di Promoter",
    "searchPartner": "Cerca partner",
    "twitterAccount": "Account Twitter",
    "updatePartner": "Aggiorna partner",
    "updatePartnerForm": "Aggiorna il modulo per i partner",
    "yearOfExperience": "anno di esperienza",
    "youtubeAccount": "Account YouTube",
    "serviceProvided": "Servizio fornito",
    "controlTheSubaccountSettings": "Controlla le impostazioni dell'account secondario",
    "generalInfo": "Informazioni generali",
    "okay": "Ok",
    "proceed": "Procedi",
    "addCard": "Aggiungi carta",
    "makeThisCardPrimary": "Imposta questa carta come primaria",
    "nameOnCard": "Nome sulla carta",
    "chargedToCustomer": "Addebitato al cliente",
    "clientBillingPage": "Pagina di fatturazione del cliente",
    "companyStripeIntegrationPage": "Pagina di integrazione Stripe dell'impresa",
    "enableRebilling": "Abilita rifatturazione",
    "enabling": "Abilitazione in corso...",
    "forMoreDetails": "per ulteriori dettagli.",
    "youreOnTheFreelancer": "Sei sul piano Freelancer che ti limita a un markup di 1,05x.",
    "minimumAmountShouldBe": "La quantità minima deve essere compresa tra ${min} e ${max}",
    "beforeEnablingThisFeature1": "Prima di abilitare questa funzionalità, collega il tuo account Stripe a",
    "planToSetYour": "per aumentare i tuoi margini.",
    "rebillAmount": "Importo di rifatturazione",
    "supportDoc": "documentazione di supporto",
    "10WillGiveYou": "Con 10 $ avrai circa",
    "minimumMustBeBetween": "Il minimo deve essere compreso tra 0,0001 e 0,005",
    "sorryYouCannotRebillAtTheMarkup": "Spiacenti! Non è possibile rifatturare con il markup sul piano Freelancer,",
    "modifyingTheseSettingsWillChange": "La modifica di queste impostazioni comporterà una variazione dei costi futuri sostenuti dai tuoi clienti.",
    "pleaseDoNotModifyThese": "Non effettuare modifiche di cui non conosci gli effetti.",
    "theseSettingsWillApply": "Queste impostazioni verranno applicate ai tuoi nuovi clienti in futuro",
    "congratulationsYourDedicatedIp": "Congratulazioni! Il valore di rivendita del tuo IP dedicato è stato salvato correttamente.",
    "youHaveAgreedToProvide": "Hai accettato di fornire IP dedicati direttamente a un account secondario. L'agenzia coprirà le spese per conto dell'account secondario.",
    "youHaveDiscontinuedToProvide": "Hai smesso di fornire IP dedicati direttamente a un account secondario. L'agenzia non coprirà più le spese per conto dell'account secondario.",
    "oopsSomethingWentWrongAndWeCouldnt": "Ops! Si è verificato un problema e non siamo riusciti a salvare la configurazione di rivendita dell'IP dedicato. Riprova più tardi.",
    "pleaseAgreeToTheTerms": "Per favore, accetti i termini",
    "errorWhileFetchingDomains": "Errore durante il recupero dei domini",
    "sameStripeCustomerProfileCantBeMapped": "Lo stesso profilo cliente di Stripe non può essere associato a più di un account secondario.",
    "pleasePickADifferentStripeCustomer": "Scegli un profilo cliente Stripe diverso o usa l'opzione \"Condividi un link\" in modo da poter creare un nuovo profilo cliente Stripe per questo account secondario.",
    "clickNextToChooseAPlan": "Fai clic su \"Avanti\" per selezionare un piano e creare un nuovo abbonamento.",
    "youDontHaveAnyActiveSubscriptions": "Non hai abbonamenti attivi",
    "youCanEitherSelectAnExistingSubscription": "Puoi selezionare un abbonamento esistente oppure crearne uno nuovo nel passaggio successivo.",
    "useCommasToSeparateMultipleEmails": "Usa le virgole per separare più email.",
    "useCommasToSeparateMultiplePhoneNumbers": "Usa le virgole per separare più numeri di telefono.",
    "noUserFoundInThisLocation": "Nessun utente trovato in questo luogo",
    "noPhoneNumberAttached": "Nessun numero di telefono allegato",
    "pleaseUseTheFollowingLinkToAttachYourPaymentMethod": "Utilizza il seguente link per collegare il tuo metodo di pagamento.",
    "allowDuplicateContact": "Consenti duplicati dei contatti",
    "allowDuplicateOpportunity": "Consenti duplicati delle opportunità",
    "mergeFacebookContactsByName": "Unisci per nome i contatti di Facebook",
    "onlyIncomingMessagesFromFacebookWillBeMerged": "Verranno uniti solo i messaggi in arrivo da Facebook corrispondenti al nome di un contatto esistente. Per i nomi viene fatta distinzione tra maiuscole e minuscole.",
    "disableContactTimezone": "Disabilita il fuso orario del contatto",
    "markEmailsAsInvalidDueToHardBounce": "Contrassegna le email come non valide a causa di hard bounce",
    "contactsEmailsWillBeMarkedAsInvalid": "Le email del contatto saranno automaticamente contrassegnate come non valide quando respinte con hard bounce. Le azioni email nelle automazioni saranno saltate per i contatti con email non valide.",
    "gatherIntelligenceOnUnknownPhoneNumbers": "Raccogli informazioni su numeri di telefono sconosciuti",
    "makeSmsCompliantByAddingAnOptOutMessage": "Rispetta gli standard di conformità per gli SMS aggiungendo un messaggio per annullare l'iscrizione.",
    "ifActivatedTheOptOutMessageWillBeAutomaticallyAdded": "Se abilitato, il messaggio di annullamento dell'iscrizione sarà automaticamente aggiunto al primo SMS inviato tramite i Messaggi in blocco per garantire la conformità agli standard e aumentare i tassi di consegna.",
    "platformLanguage": "Lingua della piattaforma",
    "outboundCommunicationLanguageForCustomValues": "Lingua delle comunicazioni in uscita per i valori personalizzati",
    "updateInformation": "Aggiorna informazioni",
    "upgradeToTheAgency": "Passa al piano Agency Pro",
    "yourCost": "Il tuo costo",
    "addACalendarTo": "Aggiungi un calendario per iniziare a prenotare appuntamenti.",
    "addselectAContactTo": "Per programmare degli appuntamenti, aggiungi/seleziona un contatto",
    "appointmentSlotIsNot": "La fascia oraria per l'appuntamento non è ancora stata selezionata",
    "loading1": "Caricamento...",
    "teamMemberIsRequired1": "Il membro del team è obbligatorio",
    "currentPlan": "Piano attuale",
    "features1": "Funzionalità",
    "upgrade": "Aggiorna",
    "viewLess": "Visualizza meno",
    "viewMoreCount": "Mostra di più (+{count})",
    "cardNumber": "Numero della carta",
    "expiryDate": "Data di scadenza",
    "paymentMethods": "Metodi di pagamento",
    "primaryCard": "Carta primaria",
    "removeCurrentCard": "Rimuovi carta attuale",
    "AddBalance": "+ Aggiungi saldo",
    "complimentaryCredits": "Crediti gratuiti:",
    "expiringOnDate": "Scadenza il {date}",
    "apiVersion": "Versione API",
    "application": "Applicazione",
    "ipAddress": "Indirizzo IP",
    "related": "Correlati",
    "request": "Richiesta",
    "yourAccountIncludingAll": "Il tuo account, inclusi tutti gli eventi come messaggi programmati ed email, verrà interrotto immediatamente.",
    "yourAccountIncludingAll1": "Il tuo account, inclusi tutti gli eventi come messaggi programmati ed email, verrà interrotto immediatamente.",
    "nextBillingDateDate": "Prossima data di fatturazione: {date}",
    "scheduledForCancellation": "Programmato per l'annullamento",
    "abandoned": "Abbandonato",
    "add1": "Aggiungi",
    "addOpportunity": "Aggiungi opportunità --",
    "addOpportunityName": "Aggiungi nome opportunità",
    "Task": "+ Attività",
    "bookupdateAppointment": "Prenota/aggiorna appuntamento",
    "companyName": "Nome dell'impresa",
    "areYouSureYou1": "Vuoi davvero eliminare questa opportunità?",
    "contactInfo": "Informazioni di contatto",
    "editOpportunity": "Modifica opportunità --",
    "enterValue": "Inserisci il valore",
    "goToContactDetail": "Vai alla pagina dei dettagli del contatto",
    "leads": "Lead",
    "lost": "Persa",
    "nameIsRequired": "Il nome è obbligatorio.",
    "youreNotAllowedTo": "Non ti è permesso cambiare il nome del cliente! Controlla la tua autorizzazione con l'amministrazione dell'agenzia.",
    "open": "Apri",
    "opportunity": "Opportunità",
    "opportunityAlreadyExistsIn": "L'opportunità esiste già in questa sequenza",
    "opportunityInfo": "Informazioni sull'opportunità",
    "opportunityName": "Nome opportunità",
    "opportunitySource": "Fonte dell'opportunità",
    "owner": "Titolare",
    "pipeline": "Sequenza",
    "removeOwner": "Rimuovi titolare",
    "selectPipeline": "Seleziona sequenza",
    "selectStage": "Seleziona fase",
    "stage": "Fase",
    "countTasks": "{count} attività",
    "won": "Vinta",
    "and": "e ",
    "addASubscription": "Aggiungi un abbonamento",
    "noSaasPlanEnabled": "Nessun piano SaaS abilitato",
    "per": "per",
    "assignTo": "Assegna a",
    "assignedTo1": "Assegnato a:",
    "areYouSureYou2": "Vuoi davvero eliminare questa attività?",
    "due": "In scadenza:",
    "dueDateIsRequired": "La data di scadenza è obbligatoria",
    "dueIn": "In scadenza tra",
    "dueToday": "In scadenza oggi",
    "late": "In ritardo",
    "notAssigned": "Non assegnato",
    "taskDescription": "Descrizione dell'attività",
    "taskTitle": "Titolo dell'attività",
    "annually": "annualmente",
    "attachments": "Allegato/i",
    "areYouSureYou3": "Vuoi davvero eliminare questa richiesta in blocco?",
    "startImmediately": "Inizia immediatamente",
    "customers": "Clienti",
    "tag": "Etichetta",
    "pickType": "Scegli un tipo",
    "whoShouldItRun": "Per chi dovrebbe essere eseguito?",
    "addBulkRequest": "Aggiungi una richiesta in blocco",
    "editBulkRequest": "Modifica richiesta in blocco",
    "scheduledDateIsRequired": "La data di programmazione è obbligatoria",
    "newCampaignName": "Nome della nuova campagna",
    "areYouSureYou4": "Vuoi davvero eliminare questa campagna?",
    "moveToFolder": "Sposta nella cartella",
    "pleaseRename": "rinomina",
    "removeFromFolder": "Rimuovi dalla cartella",
    "photoPreview": "anteprima foto",
    "pleaseWait": "Attendi...",
    "customValues": "Valori personalizzati",
    "whatActionShouldWe": "Quale azione dovremmo eseguire?",
    "entitynameName": "Nome {entityName}",
    "useLcEmail": "Usa LC Email",
    "21Jun2018": "21 giu 2018",
    "930Am": "09:30",
    "Via": " tramite ",
    "createdTrackingNumbers": "Numeri di tracciamento creati",
    "iUnderstandImBuyingadding": "So che sto acquistando/aggiungendo {count} nuovi numeri di telefono.",
    "forwardCallsTo": "Inoltra le chiamate a:",
    "numberName": "Nome del numero",
    "numberPoolName": "Nome del pool di numeri",
    "numberToSwap": "Numero da scambiare",
    "sameAsForwardingNumber": "Uguale al numero di inoltro",
    "callFromSource": "Chiama da [Fonte].",
    "callRecording": "Registrazione delle chiamate",
    "84Complete": "84% completo",
    "thisCallWillBe": "Questa chiamata sarà registrata per il controllo di qualità.",
    "whisperMessage": "Messaggio per l'agente",
    "allExceptDirect": "Tutti tranne i visitatori diretti",
    "allExceptDirectOrganic": "Tutti tranne i visitatori diretti e organici",
    "allSearch": "Tutta la ricerca",
    "allVisitorsRecommended": "Tutti i visitatori (consigliato)",
    "bing": "Bing",
    "direct": "Diretti",
    "visitorsWithoutAReferring": "Visitatori senza un sito web di riferimento",
    "for": "per",
    "google": "Google",
    "landingPageOrUrl": "Parametro URL o pagina di destinazione",
    "organic": "Organico",
    "paid": "Pagato",
    "pickOneYouCan": "Scegli un'opzione - puoi sempre cambiarla in un secondo momento.",
    "ppcSearch": "Ricerca PPC",
    "visitorsFromGoogleBing": "Visitatori dalla ricerca PPC di Google, Bing e Yahoo",
    "referringPage": "Pagina di riferimento",
    "visitorsFrom": "Visitatori provenienti da",
    "visitorsFromGoogleAds": "Visitatori da Google Ads",
    "visitorsWhoAreReferred": "Visitatori che sono stati indirizzati da",
    "visitorsWhoLandOn": "Visitatori che arrivano su",
    "whichVisitorsDoYou": "Quali visitatori vuoi monitorare?",
    "yahoo": "Yahoo",
    "17Complete": "17% completo",
    "callTimeoutS": "Timeout chiamata",
    "callWhisper": "Messaggio per l'agente della chiamata",
    "disableVoicemailDetect": "Disabilita il rilevamento della segreteria telefonica",
    "eventName": "Nome evento",
    "timeoutSeconds": "Timeout (secondi)",
    "editCall": "Modifica chiamata",
    "callWillPatchInstantly": "La chiamata verrà collegata immediatamente, non ascolteremo per vedere se la segreteria telefonica ha risposto dal lato dei potenziali clienti. Questo significa che la chiamata verrà contrassegnata come Con risposta anche se si è attivata la segreteria telefonica.",
    "thisIsTheMessage": "Questo è il messaggio che vuoi che la persona che risponde al telefono ascolti; puoi usare variabili personalizzate per personalizzarlo.",
    "pleaseCheckTheLinks": "Controlla i link in cui è presente un valore personalizzato. C'è un \"%20\" in più tra il {{ e i valori_personalizzati.",
    "anErrorOcurredPlease": "Si è verificato un errore. Riprova.",
    "pleaseInsertATo": "Inserisci un indirizzo destinatario.",
    "pickEmailTemplate": "Scegli un modello di email",
    "sendTest": "Invia test",
    "composeEmail": "Componi email",
    "composeEmailTemplate": "Componi modello di email",
    "toAddress": "Indirizzo destinatario",
    "addFileThroughUrl": "Aggiungi file tramite URL",
    "appCharacters": "Caratteri dell'app:",
    "approximateCost": "Costo approssimativo:",
    "estimatedCostForUs": "Costo stimato solo per gli SMS dagli Stati Uniti agli Stati Uniti.",
    "mobilePhoneNumber": "Numero di cellulare",
    "numSegments": "Num. di segmenti",
    "pickMessageTemplate": "Scegli un modello di messaggio",
    "pleaseProvideAPhone": "Fornisci un numero di telefono a cui inviare il test.",
    "composeEventtype": "Componi {eventType}",
    "composeEventtypeTextTemplate": "Componi il modello di testo di {eventType}",
    "unsupportedSmsContentType": "Tipo di contenuto SMS non supportato: {fileType}",
    "countOfTheProvided": "{count} degli allegati URL forniti non {plural} un'immagine. Questo può causare errori in Twilio. Vuoi comunque salvare?",
    "dropFileHereOr": "Rilascia il file qui oppure fai clic per caricarlo",
    "ifYouHaveAdditional": "Se hai altre domande, consulta le FAQ sugli invii diretti della segreteria telefonica nella sezione dedicata all'assistenza.",
    "editVoicemail": "Modifica segreteria telefonica",
    "selectAMp3Or": "Seleziona un file mp3 o wav, non supportiamo altri formati.",
    "voicemailFile": "File di segreteria telefonica",
    "warningVoicemailDropsAre": "Attenzione: gli invii diretti in segreteria telefonica rappresentano un sistema di tentativo migliore e funzionano circa il 70% delle volte.",
    "youNeedToPick": "Devi selezionare almeno 1 giorno",
    "editWait": "Modifica attesa",
    "url": "URL",
    "customTime": "Orario personalizzato",
    "executeThisActionIf": "Esegui questa azione se l'ora corrente rientra in questa finestra; se l'ora corrente è al di fuori di questa finestra, salta questo passaggio e passa all'azione successiva.",
    "pickDays": "Seleziona giorni",
    "pickTime": "Seleziona un orario",
    "noRecordsFound1": "Nessun record trovato.",
    "formAnalyze": "Analisi del modulo",
    "totalSubmission": "Invio totale",
    "forgotPassword": "Hai dimenticato la password?",
    "orContinueWith": "Oppure continua con",
    "signIn": "Accedi",
    "signIntoYourAccount": "Accedi al tuo account",
    "thePasswordYouPicked": "La password che hai scelto",
    "yourEmailAddress": "Il tuo indirizzo email",
    "newEmailFrom": "Nuova email da",
    "newMessageFrom": "Nuovo messaggio da",
    "hasLeftANew": "ha lasciato una nuova recensione.",
    "repliedToTheReview": "ha risposto alla recensione.",
    "loaded": "Caricato",
    "snapshot": "Snapshot",
    "appointment": "Appuntamento",
    "appointmentDueInMinutes": "Appuntamento per {contactName} in scadenza tra {minutes} minuti",
    "appointmentReminder": "Promemoria appuntamento",
    "completedCount": "Completate: {count}",
    "conversation": "Conversazione",
    "facebookReview": "Recensione Facebook",
    "failedCount": "Operazione non riuscita: {count}",
    "googleReview": "Recensione Google",
    "internalChatMessage": "Messaggio nella chat interna",
    "usernameMentionedYouIn": "{userName} ti ha menzionato in una conversazione con {contactName}",
    "newAppointmentAssigned": "Nuovo appuntamento assegnato",
    "aNewAppointmentWith": "Ti è stato assegnato un nuovo appuntamento con {contactName}.",
    "newAppointmentBooked": "Nuovo appuntamento prenotato",
    "youHaveNewAppointment": "Hai prenotato un nuovo appuntamento con {contactName}",
    "newCall": "Nuova chiamata",
    "aNewChatWith": "Ti è stata assegnata una nuova chat con {contactName}.",
    "newEmail": "Nuova email",
    "newMention": "Nuova menzione",
    "newReviewReceivedFrom": "Nuova recensione ricevuta da {contactName}",
    "aNewTypeIs": "{contactName} ha ricevuto un nuovo {type}",
    "notification": {
      "noRecentActivity": "Nessuna attività recente"
    },
    "subAccount": "Account secondario",
    "subaccount1": "Account secondario:",
    "titleOnDateAt": "{title} per giorno {date} alle ore {time} per {contactName}",
    "titleDueInDuetime": "{title} in scadenza tra {dueTime} {unitOfTime} per {contactName}",
    "taskReminder": "Promemoria attività",
    "youHaveCountTasks": "Hai {count} attività in scadenza oggi",
    "youHaveCountTasks1": "Hai {count} attività scadute fino ad ora",
    "droppedVoicemailTo": "Segreteria telefonica inviata a",
    "errorWhileCloningProduct": "Errore durante la clonazione del prodotto.",
    "productName": "Nome del prodotto",
    "selectLocations": "Seleziona i luoghi",
    "selectUptoMaxselectablelocatio": "Seleziona fino a {maxSelectableLocations} luoghi",
    "highlevelInc": "HighLevel Inc.",
    "CountMore": "+ altri {count}",
    "emails": "Email",
    "accountNotification": "Notifica account",
    "customerCare": "Assistenza clienti",
    "deliveryNotification": "Notifica di consegna",
    "fraudAlertMessaging": "Messaggi di allerta frode",
    "higherEducation": "Istruzione superiore",
    "lowVolumeMixedRecommended": "Misto a basso volume (consigliato)",
    "mixed": "Misto",
    "pollingAndVoting": "Sondaggi e votazioni",
    "publicServiceAnnouncement": "Avviso di servizio pubblico",
    "securityAlert": "Avviso di sicurezza",
    "mixedRecommended": "Misto (consigliato)",
    "australiaCompanyNumberFrom": "Australia: numero di impresa ASIC (ACN)",
    "canadaCanadianBusinessNumber": "Canada: numero di impresa canadese (CBN)",
    "indiaCorporateIdentityNumber": "India: numero di identità aziendale",
    "greatBritainCompanyNumber": "Gran Bretagna: numero di impresa",
    "usaEmployerIdentificationNumbe": "USA: numero di identificazione del datore di lavoro (EIN)",
    "other": "Altro",
    "israelRegistrationNumber": "Israele: numero di registrazione",
    "estoniaVatNumber": "Estonia: numero IVA",
    "cooperative": "Cooperativa",
    "corporation": "Società",
    "limitedLiabilityCompanyOr": "Società a responsabilità limitata o ditta individuale",
    "nonprofitCorporation": "Società non profit",
    "partnership": "Partnership",
    "ceo": "CEO",
    "cfo": "CFO",
    "director": "Direttore",
    "generalCounsel": "Consulente legale generale",
    "onlineTrainingEducation": "Istruzione e formazione online",
    "financialServices": "Servizi finanziari",
    "fitnessLifestyle": "Fitness e lifestyle",
    "healthMedical": "Salute e medicina",
    "homeServices": "Servizi per la casa",
    "legalServices": "Servizi legali",
    "marketingAdvertising": "Marketing e pubblicità",
    "others": "Altri",
    "realEstate": "Servizi immobiliari",
    "restaurants": "Ristoranti",
    "retailEcommerce": "Vendita al dettaglio ed e-commerce",
    "yourInformationHasBeen": "Le tue informazioni sono state inviate correttamente.",
    "somethingWentWrong1": "Qualcosa è andato storto",
    "newPassword": "Nuova password",
    "proceedToLogin": "Procedi all'accesso",
    "anyTime": "in qualsiasi momento.",
    "callUsHighlevelSupport": "Chiama l'assistenza HighLevel al numero",
    "troubleLoggingIn": "Hai problemi ad accedere?",
    "sendSecurityCode": "Invia codice di sicurezza",
    "sendCodeToEmail": "Invia il codice per email",
    "verifySecurityCode": "Verifica il codice di sicurezza",
    "privacyPolicy": "Informativa sulla privacy",
    "businessProfile": "Profilo aziendale",
    "reserveWithGoogleIntegration": "Integrazione Prenota con Google",
    "friendlyName": "Nome semplice",
    "updateCallerId": "Aggiorna ID chiamante",
    "internationalFormat": "Formato internazionale",
    "localFormat": "Formato locale",
    "poolNumbers": "Numeri del pool",
    "swappingNumbers": "Numeri di scambio",
    "selectField": "Seleziona campo",
    "surveyAnalyze": "Analisi del sondaggio",
    "locationIsRequired": "Il luogo è obbligatorio.",
    "newSurveyName": "Nuovo nome del sondaggio",
    "copySurvey": "Copia sondaggio",
    "primaryCalendar": "Calendario primario",
    "cloneEntityname": "Clona {entityName}",
    "youHaveSuccessfullySubmitted": "Hai inviato i documenti correttamente",
    "addCustomValue": "Aggiungi valore personalizzato",
    "value": "Valore",
    "youHaveSuccessfullyDeleted": "Hai eliminato il pacchetto correttamente.",
    "bundleDeletedSuccessfully": "Pacchetto eliminato correttamente",
    "thereIsAnIssue": "C'è un problema con uno dei tuoi documenti di supporto. Controlla i documenti di supporto e il motivo del rifiuto.",
    "connect1": "Collega!",
    "itSeemsEitherThe": "Sembra che il collegamento a Google si sia interrotto oppure che non si riesca a stabilire una connessione nel luogo attuale. Controlla le impostazioni delle integrazioni ed effettua nuovamente l'integrazione se il collegamento esiste già.",
    "selectPage": "Seleziona pagina",
    "somethingWentWrongPlease": "qualcosa è andato storto, riprova",
    "accept": "Accetta",
    "moreThan1Phone": "Sono consentiti più numeri di telefono",
    "byContinuingToUse": "Continuando a utilizzare la Piattaforma HighLevel, accetti questi nuovi {termsLink} e la nuova {privacyLink}.",
    "byContinuingToUse1": "Continuando a utilizzare la Piattaforma HighLevel, accetti questi nuovi",
    "termsOfService": "Termini di servizio",
    "weHaveUpdatedOur": "Abbiamo aggiornato i nostri Termini di servizio e l'Informativa sulla privacy, non scordare di consultarli!",
    "newTriggerName": "Nome del nuovo trigger",
    "triggerName": "Nome trigger",
    "disableDndForSpecific": "Disabilita DND per canali specifici",
    "selectAdAccount": "Seleziona account pubblicitario",
    "selectAppointmentStatus": "Seleziona lo stato dell'appuntamento",
    "below1": "qui sotto.",
    "Required": "* obbligatorio",
    "whenYouGetA": "Quando riceverai una nuova recensione, la pubblicheremo automaticamente sulla tua pagina Facebook. Ricorda che la buona pratica è di pubblicare non più di 3 recensioni al giorno sul tuo account.",
    "skip": "Salta",
    "copyShareLink": "Copia link di condivisione",
    "agencyRelationshipNumbers": "Numeri di relazione con l'agenzia",
    "alteast1AgencyRelationship": "È richiesto almeno 1 numero di relazione con l'agenzia.",
    "alteast1SubaccountId": "È richiesto almeno 1 ID account secondario.",
    "somethingWentWrongWhile": "Qualcosa è andato storto durante il salvataggio, riprova più tardi.",
    "5PerPage": "5 per pagina",
    "10PerPage": "10 per pagina",
    "amountMustGreaterOr": "L'importo deve essere maggiore o uguale a 1 dollaro AUD.",
    "regions": {
      "africa": "Africa",
      "asia_pacific": "Asia / Pacifico",
      "europe": "Europa",
      "latin_america": "America Latina",
      "usa_and_canada": "USA e Canada",
      "asia": "Asia",
      "latinAmerica": "America Latina",
      "usaCanada": "USA e Canada"
    },
    "expandIcon": "►",
    "noEntriesToShow": "Nessuna voce da mostrare",
    "clear": "Rimuovi",
    "filter": "Filtra",
    "test": "Test",
    "createNewTwilioSubAccountText": "Dovrai creare un nuovo account Twilio, aggiornare le credenziali di questo account nelle impostazioni di Twilio e trasferire i numeri di telefono prima di abilitare la rifatturazione.",
    "viewing": "Visualizzazione",
    "makeSmsCompliantByAddingASenderInformation": "Rispetta gli standard di conformità per gli SMS aggiungendo le informazioni del mittente.",
    "makeEmailCompliantByAddingAnUnsubscribeLinkInYourEmail": "Rispetta gli standard di conformità per le email aggiungendo un link per annullare l'iscrizione",
    "enableMissedCallTextBack": "Abilita i messaggi di risposta automatica per le chiamate perse",
    "productInventory": "Inventario dei prodotti",
    "viewProductVariants": "Visualizza le varianti del prodotto",
    "smtpSettings": "Impostazioni SMTP",
    "locationOPMTrafficStatis": "Statistiche sul traffico di Location OPM",
    "locationGPMTrafficStatis": "Statistiche sul traffico GPM per luogo",
    "blacklistMonitorReports": "Report di monitoraggio della blacklist",
    "twoFactorAuthentication": "Autenticazione a due fattori (2FA)",
    "recent": "Recente",
    "noPermission": "Non ha l'autorizzazione per gestire i modelli per questo prodotto. Reindirizzamento alla dashboard in corso.",
    "tasksNowHave": "Le attività ora dispongono di",
    "option": "Opzione",
    "facebookAdsReporting": "Report di Facebook Ads",
    "googleAdsReporting": "Report di Google Ads",
    "adsDatePicker": "Selettore di date per Ads",
    "feedbackSubmitBtn": "Pulsante di invio del feedback",
    "ifYouThinkMistakePleaseContact": "Se ritieni che si tratti di un errore, contatta",
    "forResolution": "per risolvere il problema.",
    "live": "Live",
    "payouts": "Pagamenti",
    "greatChoice": "Ottima scelta!",
    "toNavigate": "navigare",
    "teams": "Team",
    "role": "Ruolo",
    "searchAccounts": "Cerca account",
    "searchByNameEmailPhone": "Cerca per nome, email o telefono",
    "addEmployee": "Aggiungi Dipendente",
    "removeFromLocation": "Rimuovi da luogo",
    "knowMore": "Saperne di più",
    "usingNumberPool": "Utilizzo del pool di numeri",
    "numbers": {
      "zero": "0",
      "one": "1"
    },
    "multiplier": "x",
    "reviewer": "Revisore",
    "cancel1": "Annulla",
    "delete1": "Elimina",
    "call1": "Chiamata",
    "message1": "Messaggio",
    "name1": "Nome",
    "voicemail1": "Segreteria telefonica",
    "title1": "Titolo",
    "choose_one": "Scegli uno",
    "select_page": "Seleziona pagina",
    "confirm1": "Conferma",
    "conversations1": "Conversazioni",
    "copied1": "Copiato",
    "timeOfDay": {
      "am": "AM",
      "pm": "PM"
    },
    "back1": "Indietro",
    "details1": "Dettagli",
    "month1": "/mese",
    "select1": "Seleziona",
    "share1": "Condividi",
    "facebook1": "Facebook",
    "sidebar": {
      "blacklistMonitorReports": "Report di monitoraggio della blacklist",
      "domainPurchase": "Acquisto del dominio"
    },
    "confirmDelete": "Vuoi davvero eliminare {name}?",
    "clicked1": "Cliccato",
    "delivered1": "Consegnato",
    "invalid1": "Non valido",
    "open_options": "Apri opzioni",
    "_add_account": "Aggiungi account",
    "setTimezoneWarning": "Imposta il fuso orario per la tua posizione per ottenere fasce orarie gratuite adeguate.",
    "save1": "Salva",
    "action1": "Azione",
    "actions1": "Azioni",
    "all1": "Tutto",
    "previous1": "Precedente",
    "results1": "Risultati",
    "next1": "Successivo",
    "payments1": "Pagamenti",
    "settings1": "Impostazioni",
    "total_js_heap": "Heap JS totale",
    "table": {
      "pagination": {
        "previous": "Precedente",
        "next": "Successivo"
      },
      "rowsSelected": "{count} righe selezionate",
      "cantRearrange": "{type} non può essere riorganizzato"
    },
    "ivrCall": "Chiamata IVR",
    "sms": "SMS",
    "username": "Nome utente",
    "stay": "Resta",
    "placeholders": {
      "selectCountry": "Seleziona il tuo paese",
      "nameOfBusiness": "Nome dell'azienda",
      "line1": "Riga 1",
      "line2": "Riga 2",
      "enterState": "Inserisci lo stato",
      "enterCity": "Inserisci una città",
      "enterPostalCode": "Inserisci il codice postale",
      "chooseCountry": "Scegli il paese..."
    },
    "addressLine1": "Riga indirizzo 1",
    "addressLine2": "Riga indirizzo 2",
    "postalCode": "Codice postale",
    "nameOfBusiness": "Nome dell'azienda",
    "dispute_this_review": "Contesta questa recensione",
    "story_mention": "Menzione nella storia",
    "story_reply": "Risposta alla storia",
    "no": "No",
    "yes": "Sì",
    "annual": "annuale",
    "plan": "Piano",
    "errors": {
      "somethingWrong": "Qualcosa è andato storto"
    },
    "zero": "0",
    "perMonth": "al mese",
    "emailCheckLinks": "Controlla i link in cui è presente un valore personalizzato. C'è un \"%20\" in più tra il {{ e i valori_personalizzati.",
    "fileSizeTooLarge": "La dimensione del file è superiore a 5 MB",
    "fileSizeTooLargeDescription": "Il file che stai tentando di caricare è troppo grande. Prova con un file di dimensioni inferiori",
    "minMaxLength40Characters2048Characters": "Lunghezza minima: 40 caratteri. Lunghezza massima: 2048 caratteri.",
    "sampleMessage2": "Messaggio di esempio #2*",
    "pleaseSelectWorkflow": "Seleziona un flusso di lavoro",
    "childrens": "Bambini",
    "brandAndCampaignRegistration": "Registrazione di brand e campagna una tantum; verranno addebitati 20,95 $. Si applicherà una commissione aggiuntiva di fino a 2,25 $ al mese in conformità con il regolamento di TCR.",
    "einRequiredForRegistration": "EIN obbligatorio per la registrazione",
    "changed_props": "Proprietà modificate",
    "total_memory": "Memoria Totale",
    "total_store_size": "Dimensione totale del negozio",
    "total_watchers": "Totale Osservatori",
    "update_count": "Aggiorna numero"
  },
  "contacts": {
    "bulkRequests": {
      "bulkActions": "Azioni in blocco",
      "clickHere": "Fai clic qui per visualizzare l'elenco delle azioni in blocco.",
      "mergedMessage": "Questa pagina è stata unita all'elenco delle azioni in blocco.",
      "title": "Richieste di Contatto"
    }
  },
  "conversations": {
    "noConversationsFound": "Nessuna conversazione {status} trovata",
    "create_new": "Crea nuovo messaggio​",
    "validations": {
      "minCharsRequired": "Sono richiesti minimo 3 caratteri",
      "twoMoreCharsRequired": "Sono richiesti altri 2 caratteri",
      "oneMoreCharRequired": "È richiesto un altro carattere"
    },
    "sortLabels": {
      "latestAllMessages": "Più recente - Tutti i messaggi",
      "oldestAllMessages": "Più vecchio - Tutti i messaggi",
      "latestManualMessages": "Più recente - Messaggi manuali",
      "oldestManualMessages": "Più vecchio - Messaggi manuali",
      "latestAll": "Più recente - Tutti",
      "oldestAll": "Più vecchio - Tutti",
      "latestManual": "Più recente - Manuale",
      "oldestManual": "Più vecchio - Manuale",
      "highToLow": "{name} (dal più alto al più basso)",
      "manualMessagesTooltip": "L'opzione di ordinamento sarà applicabile ai messaggi dopo il 18 maggio 2023."
    },
    "deleteConversation": {
      "title": "Conferma",
      "confirmWithName": "Vuoi davvero eliminare definitivamente questa conversazione con {name}? Questa azione non può essere annullata.",
      "confirmWithoutName": "Vuoi davvero eliminare definitivamente questa conversazione? Questa azione non può essere annullata."
    },
    "makeCall": {
      "enterPhoneNumber": "Per effettuare una chiamata, inserisci un numero di telefono in questo campo.",
      "invalidPhoneNumber": "Twilio Lookup ha contrassegnato questo numero di telefono come \"non valido\"."
    },
    "actions": {
      "markAsStarred": "Contrassegna con la stella",
      "unarchive": "Ripristina",
      "unmarkAsStarred": "Annulla contrassegno con la stella"
    },
    "send": {
      "perMonthPerIp": "/ mese / IP",
      "perIp": "/ IP",
      "replyingTo": "In risposta a",
      "requestClientsPaymentDetails": "Richiedi i dettagli di pagamento del cliente",
      "saasModeCreditCardRequired": "La modalità SaaS richiede che il cliente abbia una carta di credito in archivio.",
      "please": "Per favore",
      "firstBeforeEnablingSaaS": "prima di abilitare la modalità SaaS.",
      "shareALink": "Condividi link",
      "shareLinkInstructions": "Condividi un link con il tuo cliente per raccogliere i dati di pagamento",
      "requestViaEmail": "Richiesta tramite email",
      "twilioRebillingDescription": "Rifattura i costi di Twilio ({twilioCopy}) ai tuoi clienti e includi un markup",
      "seeHow": "Scopri come",
      "phoneRebillingCardInfoRequired": "La rifatturazione telefonica richiede che le informazioni sulla carta del cliente siano in archivio.",
      "clientsCompanyBillingPage": "pagina di fatturazione dell'azienda del cliente",
      "ifYouPayForTwilioKeepUsing": "Se paga per Twilio, continui a usare lo stesso account Twilio",
      "ifClientPaysForTwilioCreateNew": "Se il cliente paga per Twilio, crei un nuovo account Twilio",
      "learnHow": "Scopri come",
      "createNewTwilioAccountInstructions": "Crea un nuovo account Twilio per questo luogo",
      "learnHowToMovePhoneNumbers": "Scopri come trasferire i numeri di telefono",
      "thisIsMyClientsTwilioCreateNew": "Questo è il Twilio del mio cliente, crea un nuovo account",
      "featureUnderDevelopment": "Questa funzione è in fase di sviluppo",
      "emailRebillingDescription": "Rifattura i costi delle email ai tuoi clienti e includi un markup",
      "emailRebillingCardInfoRequired": "La rifatturazione delle email richiede che le informazioni sulla carta del cliente siano in archivio.",
      "emailRebillingMarginsDescription": "Si tratta di margini che vengono fatturati ai tuoi clienti in aggiunta al costo delle email",
      "provider": "Provider",
      "morePlanCustomizationsAvailable": "Sono disponibili ulteriori personalizzazioni del piano",
      "plansAndPricing": "Piani e prezzi",
      "connectYourStripeAccountFirst": "Collega prima il tuo account Stripe",
      "createRecommendedPlansOnStripe": "Crea piani consigliati su Stripe",
      "createdPlanInStripe": "Piano creato su Stripe",
      "customizeYourSaasPlans": "Personalizzi i Suoi piani SaaS",
      "youCanOfferRecommendedPlansOrBuildYourOwn": "Puoi offrire piani consigliati oppure creare i tuoi",
      "trialPeriod": "Periodo di prova",
      "enterNumberOfDaysForTrial": "Inserisci il numero di giorni per la prova",
      "nameCantBeEmpty": "Il nome non può essere vuoto",
      "showStripeProductDetails": "Mostra i dettagli del prodotto Stripe",
      "addEmail": "Aggiungi email",
      "resetMountCounts": "Reimposta numeri di montaggi",
      "connectReconnectGoogleForGbp": "Collega o ricollega Google per GBP",
      "downloadFile": "Scarica file",
      "showOnlySlowQueries": "Mostra solo le query lente",
      "gmbMessagingAvailable": "La messaggistica GMB è ora disponibile",
      "reconnectGbpPageToEnable": "Ricollega la tua pagina GBP per abilitare la messaggistica",
      "failedPaymentsCheckBilling": "Sono stati rilevati pagamenti non andati a buon fine. Controlla la fatturazione.",
      "onlyAgencyAdminsCanSeeWarning": "Solo gli amministratori dell'agenzia possono vedere questo avviso.",
      "filter": "Filtra",
      "stopDeleteOperation": "Interrompi operazione di eliminazione",
      "summary": "Riepilogo",
      "enableTracking": "Abilita il monitoraggio",
      "exportAll": "Esporta tutti",
      "newConversationStarted": "Inizia una nuova conversazione",
      "startNewConversation": "Inizia una nuova conversazione",
      "subAccountScheduledForDeletion": "Account secondario programmato per l'eliminazione",
      "deleteSubAccountOnScheduledTime": "Elimina l'account secondario in base all'orario programmato",
      "componentUpdatesDebuggerAlpha": "Debugger degli aggiornamenti dei componenti (Alpha)",
      "componentUpdateTrackingDisabled": "Il tracciamento degli aggiornamenti dei componenti è disattivato",
      "deleteSubAccount": "Elimina account secondario",
      "subAccountHasNumbersAndCampaigns": "Questo account secondario ha {phoneNumberCount} numero/i di telefono e {campaignsCount} campagna/e.",
      "subAccountNoNumbersOrCampaigns": "Questo account secondario non ha numeri di telefono o campagne.",
      "areYouSureDeleteSubAccount": "Vuoi davvero eliminare questo account secondario?",
      "confirmDiscussedWithClient": "Confermo di averne parlato con il mio cliente",
      "understandActionIrreversible": "Comprendo che questa azione è irreversibile",
      "confirmDisconnectCloseLcPhone": "Confermo di voler scollegare e chiudere l'account LC Phone",
      "choosingNotDeleteLcPhoneWarning": "Attenzione: se scegli di non eliminare l'account LC Phone, continuerai a ricevere addebiti per i numeri di telefono associati a questo account secondario.",
      "deleteAccount": "Elimina account",
      "send": "Invia",
      "typeMessage": "Digita messaggio",
      "requestPayment": "Richiedi pagamento",
      "reply": "Risposta",
      "retry": "Riprova",
      "analyzeMemory": "Analizza memoria",
      "memoryAnalysisApproximate": "🚧 L'analisi della memoria è approssimativa e non è accurata al 100%.",
      "subAccountScheduledForDeletionItWillBeDeleted": "L'eliminazione di questo account secondario è stata pianificata. Verrà eliminato entro",
      "youCanChangeYourMindBeforeThisTime": "Puoi cambiare idea prima di questo momento.",
      "sms": {
        "errors": {
          "skipStayPrompt": "Salta",
          "cannotIdentifyContact": "Impossibile identificare il contatto e il suo luogo.",
          "contactNotSelected": "Il contatto non è stato selezionato.",
          "messageRequired": "Assicurati di aver inserito un messaggio o un modello selezionato.",
          "noPhoneNumber": "Il contatto non ha un numero di telefono.",
          "genericError": "{message}",
          "stayPrompt": "Resta"
        },
        "scheduledSuccess": "Email programmata con successo",
        "confirmDelete": "Vuoi davvero eliminare {name}?"
      },
      "clear": "Rimuovi",
      "edit": "Modifica",
      "sendNow": "Invia ora",
      "schedule": "Programma",
      "useTemplate": "Utilizza un modello (Frammento)",
      "mergeFields": "Unisci campi",
      "customVariablesError": "Ci sono problemi nelle tue variabili personalizzate, correggile prima di inviarle.",
      "sendLater": "Invia più tardi",
      "scheduledFor": "Programmato per {date}",
      "call": "Chiamata",
      "leftVoicemail": "Ha lasciato un messaggio nella segreteria telefonica",
      "pleaseSelectCampaign": "Seleziona una campagna",
      "whatsapp": {
        "no24HourMessage": "Puoi inviare messaggi di modello solo al di fuori della finestra di 24 ore. Seleziona un modello da inviare."
      },
      "attachFile": "Allega file",
      "email": {
        "fromEmail": "Email mittente",
        "fromName": "Nome mittente",
        "smtpWarning": "I provider SMTP hanno alcune limitazioni. Fai clic qui per saperne di più.",
        "subject": "Oggetto",
        "errors": {
          "cannotIdentifyContact": "Impossibile identificare il contatto e il suo luogo.",
          "contactNotSelected": "Il contatto non è stato selezionato.",
          "genericError": "{message}",
          "bodyRequired": "L'email richiede un testo nel corpo per poter essere inviata.",
          "noEmailAddress": "Il contatto non ha un indirizzo email."
        },
        "scheduledSuccess": "Email programmata con successo"
      },
      "addCalendarToSchedule": "Devi aggiungere un calendario per iniziare a pianificare gli appuntamenti.",
      "slotRequired": "La fascia oraria è obbligatoria",
      "teamMemberRequired": "Il membro del team è obbligatorio."
    },
    "added": "aggiunto",
    "loadMore": "Carica di più",
    "admin": "Amministratore",
    "aiEmployee": {
      "popupBlockedAlert": "Hai disabilitato il popup. Consenti ai popup di questo sito di reindirizzare automaticamente alla chiamata Zoom. Clicca su Partecipa per un reindirizzamento diretto alla chiamata Zoom."
    },
    "alsoCloseAssociatedSubAccount": "Inoltre chiudi gli",
    "analyzeMemory": "Analizza Memoria",
    "announcements": "Annunci",
    "apply": "Applica",
    "appointment": {
      "pickDay": "Seleziona un giorno",
      "pickSlot": "Seleziona una fascia oraria per l'appuntamento",
      "selectDate": "Seleziona data",
      "selectSlot": "Seleziona una fascia oraria",
      "slot": "Fascia oraria",
      "day": "Giorno"
    },
    "areYouReallySureDeleteSubAccount": "Vuoi davvero eliminare questo account secondario?",
    "areYouSureDeleteSubAccount": "Vuoi davvero eliminare questo account secondario?",
    "assignedContactOwner": "Assegnato (titolare del {contact})",
    "assignedToMe": "Assegnato a me",
    "audio": {
      "browserNotSupported": "Il browser non supporta l'elemento audio.",
      "loadingTranscription": "Caricamento della trascrizione in corso...",
      "viewTranscript": "Visualizza trascrizione",
      "stop": "Interrompi",
      "playPause": "Riproduci/Metti in pausa",
      "timePlayed": "Tempo di gioco : Tempo totale",
      "mute": "Disattiva il microfono",
      "playbackSpeed": "Velocità di riproduzione",
      "download": "Scarica",
      "remove": "Rimuovi"
    },
    "automated": "Automatizzato",
    "avatar": {
      "aiGenerated": "Questo messaggio è stato generato da Conversation AI",
      "messengerAutomation": "Automazione Messenger",
      "workflowGenerated": "Questo messaggio è stato generato dall'azione del flusso di lavoro Conversation AI",
      "messageByAI": "Questo messaggio è stato generato da Conversation AI",
      "messageByWorkflow": "Questo messaggio è stato generato dall'azione del flusso di lavoro Conversation AI",
      "agentPrefix": "E-",
      "unknownFallback": "?"
    },
    "bePartOfFastestGrowingCommunity": "Entra a far parte della community in più rapida crescita.",
    "callHighlevelAt": "Chiama HighLevel al numero +1(888)732-4197",
    "callQueueTooltip": "Questa chiamata è nella coda delle chiamate dell'utente in attesa di essere eseguita.",
    "callTranscript": "Trascrizione della chiamata",
    "clearFilters": "Rimuovi filtri",
    "clientsCompanyBillingPage": "pagina di fatturazione dell'azienda del cliente",
    "closeChat": "Chiudi chat",
    "closeConversation": "Chiudi conversazione",
    "component": {
      "dismissMessage": "IGNORA QUESTO MESSAGGIO",
      "unblock": "Sblocca",
      "inboundDndActive": "La funzione DND in entrata è stata attivata per questo contatto",
      "fetchOlderMessages": "Recupera i messaggi più vecchi",
      "conversationBegan": "La conversazione è iniziata",
      "celebrationTitle": "Evviva! Ora le conversazioni scorrono alla grande",
      "celebrationBody": "Siamo solo all'inizio, esploriamo come GHL può aiutarti a far crescere la tua azienda.<br />Nel frattempo, puoi continuare a inviare messaggi senza limiti"
    },
    "componentUpdateTrackingDisabled": "Il tracciamento degli aggiornamenti dei componenti è attualmente disabilitato",
    "componentUpdatesDebuggerAlpha": "🚧 Debugger degli aggiornamenti dei componenti (Alpha) - Lavoro in corso",
    "confirmDelete": "Eliminare la/le conversazione/i?",
    "confirmDeleteTextLine11": "Vuoi davvero eliminare questa conversazione? Questa azione è irreversibile.",
    "confirmDeleteTextLine12": "conversazioni selezionate",
    "confirmDeleteTextLine21": "Questa azione è irreversibile. Vuoi comunque procedere?",
    "confirmDisconnectedAllIntegrations": "Confermo di aver disconnesso tutte le integrazioni come twilio, mailgun, gmb, domini, facebook, zoom, ecc.",
    "confirmStoppedAllAutomations": "Confermo di aver interrotto tutte le automazioni in questo account secondario",
    "connectReconnectGoogleForGbp": "Collega/Ricollega il tuo account Google per ottenere la messaggistica GBP!",
    "connectWithCertifiedAdmin": "Entra in contatto con un amministratore certificato",
    "connectWithTeamForHelp": "Parla con il nostro team per ricevere assistenza tramite una videochiamata in tempo reale!",
    "connectWithUs": "Connettiti con noi",
    "connectZoomAccount": "Collega l'account Zoom",
    "contactEngagementScore": "Punteggio di coinvolgimento del {contact}",
    "dailyBrainstormingSessions": "Sessioni quotidiane di brainstorming con HighLevel",
    "deleteAccount": "Elimina account",
    "deleteSubAccountOnScheduledTime": "Elimina l'account secondario in base all'orario programmato",
    "disableSaasMode": "Disabilita modalità SaaS",
    "dnd": {
      "configure": "CONFIGURA",
      "status": {
        "on": "Attivo",
        "partial": "Parziale"
      }
    },
    "editAppointment": {
      "updateButton": "Aggiorna appuntamento",
      "scheduleAppointment": "Programma un appuntamento",
      "editAppointment": "Modifica appuntamento",
      "calendar": "Calendario",
      "selectCalendar": "Seleziona calendario",
      "roundRobin": "A rotazione",
      "pickTeamMember": "Scegli membro del team",
      "selectTeamMember": "Seleziona membro del team",
      "teamMemberRequired": "Il membro del team è obbligatorio.",
      "slotRequired": "La fascia oraria è obbligatoria",
      "appointmentTitle": "Titolo dell'appuntamento",
      "appointmentTitleTooltip": "Puoi anche lasciare il campo vuoto, se scegli di utilizzare il titolo dell'appuntamento preconfigurato",
      "contactName": "Nome del contatto",
      "name": "Nome",
      "nameRequired": "Il nome è obbligatorio",
      "emailAddress": "Indirizzo email",
      "phoneNumber": "Numero di telefono",
      "phoneNumbers": "Numeri di telefono",
      "dateOfBirth": "Data di nascita",
      "contactTimezone": "Fuso orario del contatto (utilizzato per il promemoria)",
      "chooseOne": "Scegline uno.",
      "meetingLocation": "Luogo dell'incontro",
      "meetingLocationTooltip": "Puoi anche lasciare il campo vuoto, se scegli di utilizzare il luogo dell'incontro preconfigurato",
      "status": "Stato",
      "appointmentStatus": "Stato dell'appuntamento",
      "additionalNotes": "Note aggiuntive",
      "notes": "Note",
      "actionRequired": "Azione richiesta",
      "confirmed": "Confermato",
      "invalid": "Non valido",
      "cancelled": "Annullato",
      "showed": "Presentazione",
      "noShow": "Mancata presentazione",
      "busy": "Occupata",
      "free": "Libera",
      "noCalendarMessage": "Per iniziare a pianificare gli appuntamenti, devi aggiungere un calendario."
    },
    "email": {
      "errors": {
        "bodyRequired": "L'email richiede un testo nel corpo per poter essere inviata.",
        "cannotIdentifyContact": "Impossibile identificare il contatto e il suo luogo.",
        "contactNotSelected": "Il contatto non è stato selezionato.",
        "noEmailAddress": "Il contatto non ha un indirizzo email."
      },
      "thread": {
        "failedToFetch": "Recupero del contenuto dell'email non riuscito",
        "forward": "Inoltra"
      },
      "reply": "Rispondi",
      "share": "Condividi",
      "facebook": "Facebook",
      "twitter": "Twitter",
      "addAccount": "+ Aggiungi account",
      "respond": "Rispondi",
      "retry": "Riprova",
      "moreEmailsInThread": "Altre {count} email nel thread",
      "fromName": "Nome mittente",
      "fromEmail": "Email mittente",
      "subject": "Oggetto",
      "attachFile": "Allega file",
      "useTemplate": "Utilizza un modello (Frammento)",
      "requestPayment": "Richiedi pagamento",
      "clear": "Rimuovi",
      "sendNow": "Invia ora",
      "schedule": "Programma",
      "send": "Invia",
      "smtpWarning": "I provider SMTP hanno alcune limitazioni. Fai clic qui per saperne di più.",
      "chooseOne": "Scegline uno.",
      "deliveredCount": "Consegne completate: {delivered}/{total}",
      "typeMessage": "Digita messaggio",
      "sendLater": "Invia più tardi",
      "scheduledFor": "Programmato per {date}"
    },
    "emailRebillingCardInfoRequired": "Per attivare la rifatturazione email, devi inserire le informazioni della carta del tuo cliente sulla",
    "emailRebillingDescription": "Ciò ti consente di rifatturare i costi delle email ai tuoi clienti e includere un markup.",
    "emailRebillingMarginsDescription": "Si tratta di margini che vengono fatturati ai tuoi clienti in aggiunta al costo delle email da te sostenuto",
    "enableTracking": "Abilita il monitoraggio",
    "exploreHighlevelExperts": "Scopri gli esperti di HighLevel che possono aiutarti a configurare il tuo sistema, automatizzare i flussi di lavoro o personalizzare il tuo progetto.",
    "exportAll": "Esporta tutti",
    "facebook": {
      "errors": {
        "generalError": "Si è verificato un errore. Riprova o controlla l'integrazione con Facebook. Messaggio di errore:",
        "noFacebookId": "Il contatto non ha un ID Facebook."
      }
    },
    "failedPaymentsCheckBilling": "Hai uno o più pagamenti non riusciti. Controlla la cronologia delle tue fatture.",
    "fbMessengerDM": "DM su FB Messenger",
    "filters": {
      "above": "Sopra",
      "aiActionLogs": "Registri delle azioni AI",
      "inRange": "Nell'intervallo",
      "invoice": "Fattura",
      "messageDirectionTooltip": "Il filtro sarà applicabile ai messaggi dopo il 9 maggio 2023",
      "appointments": "Appuntamenti"
    },
    "followed": "Seguito da",
    "followedByMe": "Seguito da me",
    "followedBySpecificUser": "Seguito da un utente specifico",
    "follower": "Follower",
    "followerAssignmentContact": "Follower (Assegnazione del {contact})",
    "gbp": {
      "errors": {
        "generalError": "Si è verificato un errore. Riprova o controlla l'integrazione con Google Business Profile. Messaggio di errore:",
        "noGBPId": "Il contatto non ha un ID GBP."
      }
    },
    "gbpChatNoLongerAvailable": "La chat di Google Business Profile non è più disponibile",
    "getAccessToHighlevelWelcomeCourse": "Accedi al corso di benvenuto HighLevel",
    "getPriorityTroubleshooting": "Ricevi assistenza in via prioritaria in caso di problemi, fatti aiutare da esperti e consulta direttamente il nostro team tecnico tramite Slack.",
    "gmbMessagingAvailable": "Google Business Messaging è disponibile per il Suo account.",
    "googleMeet": "Google Meet",
    "googleReview": {
      "rating": "Valutazione:",
      "replyDate": "Data di risposta:",
      "replyFrom": "Risposta da:",
      "review": "Recensione",
      "reviewDate": "Data della recensione:",
      "reviewFrom": "Recensione da parte di:"
    },
    "highlevelEvents": "Eventi di HighLevel",
    "igMessengerDM": "IG Messenger DM",
    "includeSignatureBeforeQuotedText": "Includi questa firma prima del testo citato nelle risposte",
    "instagram": {
      "errors": {
        "generalError": "Si è verificato un errore. Riprova o controlla l'integrazione con Instagram. Messaggio di errore:",
        "noInstagramId": "Il contatto non ha un ID Instagram."
      }
    },
    "joinOurFacebookGroup": "Unisciti al nostro gruppo Facebook",
    "keepUpToDateWithLatestNews": "Scopri in anteprima tutte le ultime notizie e release!",
    "lastMessageChannel": "Canale dell'ultimo messaggio",
    "lastMessageDirection": "Direzione dell'ultimo messaggio",
    "lastOutboundMessageType": "Tipo dell'ultimo messaggio in uscita",
    "learnHow": "Scopri come",
    "leftComment": "ha lasciato un commento",
    "leftPanel": {
      "recents": "Recenti",
      "unread": "Non letto",
      "createNewMessage": "Crea nuovo messaggio",
      "minCharsRequired": "Sono richiesti minimo 3 caratteri",
      "twoMoreCharsRequired": "Sono richiesti altri 2 caratteri",
      "oneMoreCharRequired": "È richiesto un altro carattere"
    },
    "liveChat": {
      "endLiveChat": "Chiudi Live Chat",
      "errors": {
        "generalError": "Si è verificato un errore. Riprova o controlla l'integrazione con Google My Business. Messaggio di errore:"
      },
      "requestContact": "Richiedi contatto"
    },
    "live_chat_message": "Messaggio di Live Chat",
    "made": "fatto",
    "memoryAnalysisApproximate": "🚧 L'analisi della memoria è approssimativa e non è accurata al 100%.",
    "mentioned": "Menzione di",
    "mentions": "Menzioni",
    "mentionsOfMe": "Menzioni su di me",
    "mentionsOfSpecificUser": "Menzioni di un utente specifico",
    "message": {
      "replyAll": "Rispondi a tutti",
      "details": "Dettagli",
      "reply": "Rispondi",
      "unsuccessful": "Non riuscito",
      "pending": "In sospeso",
      "inboundCall": "Chiamata in entrata",
      "outboundCall": "Chiamata in uscita",
      "ivrCall": "Chiamata IVR",
      "leftVoicemail": "Ha lasciato un messaggio nella segreteria telefonica",
      "storyReply": "Risposta alla storia",
      "storyMention": "Menzione nella storia",
      "replyAsDM": "Rispondi nei DM",
      "newCommentOnPost": "Nuovo commento al post di {pageName}.",
      "goToPost": "Vai al post",
      "replyNotAvailable": "La risposta in DM privato non è disponibile per i commenti più vecchi di 7 giorni.",
      "addToDocuments": "Aggiungi ai documenti",
      "attachmentsAddedSuccess": "Allegati aggiunti correttamente ai documenti",
      "attachmentsAddedFailed": "Aggiunta degli allegati ai documenti non riuscita",
      "reportFeedbackForAI": "Segnala feedback per l'AI",
      "sms": "SMS"
    },
    "messageDetails": {
      "bcc": "CCN",
      "cancelScheduleConfirm": "Vuoi davvero annullare questa programmazione?",
      "cancelScheduledMessage": "Annullare il messaggio programmato?",
      "cancelSend": "Annulla invio",
      "cancelScheduledSuccess": "Messaggio programmato annullato correttamente",
      "cancelScheduledError": "Si è verificato un errore durante l'annullamento del messaggio programmato",
      "cc": "CC",
      "channel": "Canale",
      "createdBy": "Creato da",
      "direction": "Direzione",
      "emailCampaign": "Campagna email",
      "facebookMessage": "Messaggio Facebook",
      "instagramMessage": "Messaggio Instagram",
      "messageId": "ID messaggio",
      "messageIdLabel": "ID messaggio: ",
      "trigger": "Trigger",
      "unanswered": "Senza risposta",
      "yes": "Sì",
      "messageDetails": "Informazioni sul messaggio",
      "from": "Da",
      "fromLabel": "Da:",
      "to": "A",
      "toLabel": "A:",
      "unknown": "Sconosciuto",
      "unknownFrom": "Sconosciuto da",
      "unknownTo": "Sconosciuto a",
      "unknownDirection": "Direzione sconosciuta",
      "dateUnknown": "Data sconosciuta",
      "emailFromUnknown": "Email da Sconosciuto",
      "smsFromUnknown": "SMS da sconosciuto",
      "callFromUnknown": "Chiamata da sconosciuto",
      "voicemailFromUnknown": "Messaggio in segreteria telefonica da numero sconosciuto",
      "emailToUnknown": "Email a sconosciuto",
      "smsToUnknown": "SMS a Sconosciuto",
      "callToUnknown": "Chiamata a sconosciuto",
      "voicemailToUnknown": "Messaggio in segreteria telefonica a numero sconosciuto",
      "failed": "Non riuscito",
      "datetime": "Data e ora",
      "manual": "Manuale",
      "automation": "Automazione",
      "workflow": "Flusso di lavoro",
      "campaign": "Campagna",
      "bulkRequest": "Richiesta in blocco",
      "delivered": "Consegnato",
      "bounced": "Respinto",
      "opened": "Aperto",
      "sent": "Inviato",
      "scheduled": "Programmato",
      "pageName": "Nome della pagina",
      "gbpMessage": "Messaggio GBP",
      "no": "No",
      "eventsTrackedForContactOnly": "Gli eventi vengono attualmente acquisiti solo per l'indirizzo email del contatto.",
      "completed": "Completato",
      "voicemail": "Segreteria telefonica",
      "busy": "Occupato",
      "pending": "In sospeso",
      "read": "Letto",
      "nativeIntegrations": "Integrazioni native",
      "smtp": "SMTP",
      "twilio": "Twilio",
      "leadConnector": "LeadConnector",
      "email": "Email",
      "sms": "SMS",
      "phoneCall": "Chiamata telefonica",
      "voiceMail": "Messaggio vocale",
      "facebookMessenger": "Facebook Messenger",
      "instagramMessenger": "Instagram Messenger",
      "gbpMessenger": "GBP Messenger",
      "reviews": "Recensioni",
      "others": "Altri",
      "partialDetailsWarning": "Dettagli parziali saranno disponibili per i messaggi precedenti al 15 luglio 2022.",
      "agencySystem": "Sistema agenzia",
      "reply": "Rispondi"
    },
    "multiplePhone": {
      "chooseNumber": "Scegli un numero per iniziare la conversazione:",
      "continue": "Continua",
      "noPhones": "Nessun numero di telefono disponibile"
    },
    "myChat": "La mia chat",
    "myInbox": "La mia casella di posta",
    "newConversationStarted": "Inizia una nuova conversazione",
    "newMessage": {
      "title": "Nuovo messaggio:",
      "errors": {
        "phoneRequired": "Il numero di telefono è obbligatorio"
      }
    },
    "noConversationSelected": "Nessuna conversazione selezionata",
    "noResultsToShow": "Nessun risultato da mostrare",
    "onboardingVideoTutorials": "Video tutorial di onboarding",
    "onlyAgencyAdminsCanSeeWarning": "Solo gli amministratori dell'agenzia possono vedere questo avviso. Per ulteriori informazioni",
    "onlyVisibleToUsers": "Visibile solo agli utenti",
    "perMonthPerIp": "/ mese / IP",
    "phone": {
      "call": "Chiama {name}",
      "callingOptions": "{count} opzioni di chiamata",
      "phoneNumbers": "Numeri di telefono",
      "callOptions": "{count} opzioni di chiamata",
      "dndActive": "La funzione DND è attiva per le chiamate",
      "primary": "Primario"
    },
    "pleaseDisableSaasMode": "Disabilita la modalità SaaS per questo account secondario",
    "pleaseSelectCampaign": "Seleziona una campagna",
    "premiumSupport": "Supporto Premium",
    "quickFilters": "Filtri rapidi",
    "reconnectGbpPageToEnable": "Ricollega la tua pagina GBP per abilitarla.",
    "replyAsDMTooltip": "Rispondi a questo commento con un DM privato.",
    "replyingTo": "In risposta a",
    "resetMountCounts": "Reimposta numeri di montaggi",
    "review": {
      "errors": {
        "generalError": "Si è verificato un errore. Messaggio di errore:",
        "googleIntegrationError": "Non è stato possibile rispondere a quella recensione. Sembra che ci sia un errore con l'integrazione Google. Ripristina il collegamento in Impostazioni -> Integrazioni.",
        "noReviewId": "La conversazione non ha un ID recensione."
      },
      "reviewPostTo": "Controlla il post su {network}",
      "sharedOn": "Recensione condivisa su {network}",
      "disputeReview": "Contesta questa recensione",
      "learnHow": "(Scopri come)",
      "seeOnGBP": "Vedi questa recensione su GBP",
      "alreadyShared": "Questa recensione è già stata pubblicata su {network}. Vuoi davvero ripubblicarla?"
    },
    "reviewId": "ID recensione",
    "schedule": {
      "sendSchedule": "Invia programma",
      "timezone": "Fuso orario ({heading})",
      "title": "Programma {type}"
    },
    "scheduling": "Programmazione...",
    "seeHow": "Scopri come",
    "selectFilter": "Seleziona filtro",
    "selected": "selezionati",
    "sendEmail": {
      "recipientPlaceholder": "recipient{'@'}example.com",
      "subject": "Oggetto:",
      "subjectPlaceholder": "Oggetto dell'email",
      "to": "A:",
      "sending": "Invio in corso...",
      "sendButton": "Invia email"
    },
    "setupAccountWithFreeTutorials": "Configura il tuo account, con tutorial gratis",
    "showOnlySlowQueries": "Mostra solo le query lente (>{threshold}ms)",
    "sms": {
      "confirmSending": "Conferma l'invio del messaggio",
      "editModal": {
        "compose": "Componi SMS"
      },
      "errors": {
        "customVariablesIssue": "Ci sono problemi nelle tue variabili personalizzate, correggile prima di procedere con l'invio.",
        "messageOrTemplateRequired": "Assicurati di aver inserito un messaggio o un modello selezionato.",
        "noPhoneNumber": "Il contatto non ha un numero di telefono."
      },
      "scheduledSuccessfully": "SMS programmato correttamente",
      "sendAnyway": "Invia comunque",
      "spamWarning": "Il contenuto dei tuoi SMS potrebbe includere riferimenti a cannabis, SHAFT, vaporizzatori o altri temi proibiti. L'invio di tali contenuti tramite SMS è severamente vietato e può comportare restrizioni sull'account. Rivedi attentamente i tuoi contenuti prima di procedere.",
      "send": "Invia"
    },
    "startNewConversation": "Inizia una nuova conversazione",
    "subAccountAndDeleteAllPhoneNumbers": "account secondari associati ed elimina tutti i numeri di telefono",
    "subAccountScheduledForDeletion": "Questo account secondario è programmato per l'eliminazione",
    "subAccountScheduledForDeletionItWillBeDeleted": "L'eliminazione di questo account secondario è stata pianificata. Verrà eliminato entro",
    "teamInbox": "Casella di posta del team",
    "threshold": "Soglia",
    "understandActionIrreversible": "Comprendo che questa azione è irreversibile e che tutti i dati all'interno di questo account secondario andranno persi",
    "unstarred": "Stella rimossa",
    "use_a_template": "Utilizza un modello",
    "userAvailability": "Disponibilità utente",
    "userCalendarConfiguration": "Configurazione del Calendario Utente",
    "userInfo": "Informazioni Utente",
    "userRoles": "Ruoli utente",
    "viewSupportTickets": "Visualizza i tuoi ticket di assistenza, i nostri articoli di supporto e le utili FAQ!",
    "visitOurHelpCenter": "Visita il nostro Centro assistenza",
    "welcomeCourse": "Corso di benvenuto",
    "whatsapp_logo": "WhatsApp Logo",
    "youCanChangeYourMindBeforeThisTime": "Puoi cambiare idea prima di questo momento.",
    "zoomAccount": "Zoom Account",
    "deleteEmails": "Elimina {count} email",
    "fileAttachment": {
      "urlNotFound": "L'URL non è stato trovato",
      "unsupportedAttachment": "Questi allegati potrebbero non essere più supportati.",
      "downloadFile": "Scarica file"
    },
    "composer": {
      "internalComment": "Commento interno"
    },
    "dropdown": {
      "openOptions": "Apri opzioni",
      "messageDetails": "Informazioni sul messaggio"
    },
    "respond": "Rispondi",
    "selectTemplate": "Seleziona un modello",
    "settings": {
      "aiEmployeePromo": {
        "popupBlockedMessage": "Hai disabilitato il popup. Consenti ai popup di questo sito di reindirizzare automaticamente alla chiamata Zoom. Clicca su Partecipa per un reindirizzamento diretto alla chiamata Zoom.",
        "helpAndSupport": "Aiuto e supporto",
        "summerOfAI": "Summer of AI"
      }
    },
    "celebration": {
      "dismiss": "Scarta",
      "body": "Siamo solo all'inizio, esploriamo come GHL può aiutarti a far crescere la tua azienda.\nNel frattempo, puoi continuare a inviare messaggi senza limiti",
      "title": "Evviva! Ora le conversazioni scorrono alla grande"
    }
  },
  "cookies": {
    "thirdPartyWarning": {
      "helpArticle": "articolo di supporto qui",
      "message": "Abilita i cookie di terze parti per visualizzare correttamente questa pagina. Puoi fare riferimento al nostro",
      "ok": "OK",
      "title": "I cookie di terze parti non funzionano"
    }
  },
  "crash": {
    "message": "Ci dispiace, ma si è verificato qualcosa di inaspettato. Prova ad aggiornare la pagina.",
    "refresh": "Ricarica pagina",
    "title": "Ops! Qualcosa è andato storto"
  },
  "deleteLocation": {
    "abortModal": {
      "abortingDeletion": "Interruzione dell'eliminazione per {name}",
      "confirmAbort": "Sì, annulla",
      "keepDeleting": "No, procedi con l'eliminazione",
      "message": "Vuoi davvero annullare?",
      "scheduledForDeletion": "L'eliminazione di questo luogo è programmata per la seguente data: {date}",
      "title": "Annulla eliminazione",
      "warning": "Nota: il luogo verrà eliminato nella data programmata, a meno che non annulli l'eliminazione."
    }
  },
  "fileUpload": {
    "dropzone": {
      "defaultMessage": "Rilascia qui i file per caricarli",
      "uploadError": "Errore di rete: non è stato possibile inviare richieste ad AWS. (Probabile errore CORS)"
    }
  },
  "funnel": {
    "acceptShare": {
      "add": "Aggiungi {entityName}",
      "clonedMessage": "Clonazione di {entityName} riuscita! Passa a un account in cui l'elemento è stato clonato e trovalo nella scheda {entityName}.",
      "errorGettingDetails": "Sembra che si sia verificato un errore durante l'acquisizione dei dettagli di {entityName}. Controlla l'URL o riprova!",
      "permissionError": "Errore di autorizzazione: questo è un funnel protetto e non può essere creato qui."
    }
  },
  "integrations": {
    "googleCalendar": {
      "logo": "GoogleCalendar Logo"
    },
    "printful": {
      "logo": "Logo Printful",
      "title": "Printful: stampa su richiesta"
    },
    "printify": {
      "logo": "Logo Printify",
      "title": "Printify: POD"
    },
    "shipStation": {
      "logo": "Logo di ShipStation",
      "title": "ShipStation"
    },
    "shippo": {
      "logo": "Logo Shippo",
      "title": "Shippo: Integrazione di spedizione"
    },
    "tikTok": {
      "accountNotConnected": "Account non collegato",
      "accountNotConnectedMessage": "Il tuo account non è collegato con l'account pubblicitario di TikTok. Integrazione completa per visualizzare i moduli e mappare i campi.",
      "advertiserId": "ID inserzionista",
      "companyFields": "Campi {companyName}",
      "editFields": "Modifica campi",
      "errorSubscribing": "Errore durante l'iscrizione alla pagina.",
      "formsNotAvailable": "Moduli non disponibili",
      "mandatoryFieldsNote": "Nota: mappa uno qualsiasi dei campi obbligatori seguenti per ricevere correttamente i lead nel tuo account. Campi: Nome, Cognome, Email, Numero di telefono",
      "noFormsMessage": "Attualmente non hai creato alcun modulo di generazione di lead nel tuo account pubblicitario di TikTok. Visita il tuo account pubblicitario di TikTok e creane uno per iniziare.",
      "pageId": "ID pagina",
      "selectAdvertiserAccount": "Seleziona l'account inserzionista"
    }
  },
  "launchpad": {
    "duda": "Duda",
    "joomla": "Joomla",
    "otherOrIDontKnow": "Altro / Non so",
    "shopify": "Shopify",
    "squarespace": "SquareSpace",
    "weebly": "Weebly",
    "wordpress": "WordPress"
  },
  "location": {
    "suspend": {
      "instructionText": "Per sospendere questo account secondario, devi completare alcuni semplici passaggi"
    },
    "transfer": {
      "chooseDescription": "Scegli il tuo metodo di trasferimento",
      "chooseMethod": "Trasferisci questo account secondario",
      "eject": {
        "description": "Guadagna il 40% di commissioni ricorrenti sull'abbonamento del nuovo account.",
        "title": "Espelli come nuovo account"
      },
      "modal": {
        "confirmDetails": "Conferma i dettagli prima del trasferimento",
        "confirmNomineePrefix": "Nomina il titolare per",
        "confirmTransfer": "Conferma trasferimento",
        "consentText": "Ho letto e compreso la guida di cui sopra e acconsento a tutte le limitazioni",
        "ejectErrorTitle": "Impossibile espellere l'account secondario.",
        "ejectGenericError": "L'account secondario che stai cercando di espellere non può essere espulso. Contatta l'assistenza.",
        "ejectGuidelines": "Linee guida per l'espulsione degli account secondari",
        "ejectSubject": "L'espulsione dell'account secondario è soggetta all'accettazione, da parte dell'utente, della richiesta di creazione di una nuova agenzia.",
        "ejectSuccessTitle": "Richiesta di espulsione dell'account secondario inviata all'utente selezionato",
        "enterPassword": "Inserisci la tua password per confermare",
        "genericError": "L'account secondario che stai tentando di trasferire non può essere trasferito. Contatta l'assistenza.",
        "guidelines": "Linee guida per il trasferimento di account secondari",
        "guidelinesConsent": "Leggi e acconsenti a",
        "hipaaDisclaimer": "Esclusione di responsabilità",
        "hipaaText": "Potresti voler informare questo account secondario che attualmente ha copertura HIPAA ma potrebbe non avere la stessa copertura con l'agenzia a cui viene trasferito.",
        "noUsersDescription": "Non ci sono utenti associati a questo account secondario. Aggiungi un utente con account secondario e poi continua.",
        "noUsersSearch": "Nessun utente trovato.",
        "noUsersTitle": "Nessun utente trovato",
        "nomineeInstructions": "La persona che nomini riceverà un link per iscriversi a HighLevel",
        "passwordError": "Password non valida",
        "passwordErrorDescription": "La password inserita non è corretta. Riprova.",
        "relationshipError": "Inserisci il numero di relazione corretto",
        "relationshipNumber": "Numero di relazione dell'agenzia ricevente",
        "relationshipPlaceholder": "0-123-456",
        "requestTransfer": "Richiedi trasferimento",
        "seeAllRequests": "Visualizza tutte le richieste",
        "successMessage": "Il tuo account secondario verrà trasferito una volta che l'agenzia ricevente avrà accettato la tua richiesta di trasferimento.",
        "successTitle": "Richiesta di trasferimento dell'account secondario inviata all'agenzia ricevente",
        "title": "Carica Account secondario",
        "transferSubject": "Il trasferimento dell'account secondario è subordinato all'accettazione da parte dell'agenzia ricevente sul proprio account.",
        "confirmNomineeSuffix": " a "
      },
      "transferExisting": {
        "description": "Trasferisci l'intero account secondario a un altro account.",
        "title": "Trasferisci su un account esistente"
      }
    }
  },
  "marketing": {
    "bulkRequests": {
      "nextExecution": "Prossima esecuzione",
      "title": "Richieste in blocco"
    },
    "campaign": {
      "account": "Account",
      "accountBuffer": "Buffer dell'account",
      "accountBufferDescription": "Non c'è limite al numero di destinatari aggiunti a questa campagna ogni giorno (da un elenco).",
      "accounts": "Account",
      "activity": "Attività",
      "acquire": "Acquisisci",
      "acquisitionDescription": "Le campagne di acquisizione clienti ti aiutano a generare un maggior numero di lead di vendita \"caldi\", pronti a interagire.",
      "addEvent": "Aggiungi evento",
      "addUser": "Aggiungi utente",
      "allMarket": "Tutti i mercati",
      "allowMultiple": "Consenti multipli",
      "assignedToTooltip": "Quando questa campagna è iniziata, questo contatto è stato assegnato a questo utente. Le modifiche nel campo \"Assegnato a\" del contatto si rifletteranno sugli eventi, ma non cambieranno questo valore iniziale.",
      "atLeastOneEvent": "È obbligatorio almeno un evento.",
      "automations": "Automazioni",
      "automationsPlaceholder": "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quas quaerat pariatur consequatur rerum neque a, id, nam nostrum iure accusantium magnam nemo perferendis eveniet quos perspiciatis molestiae explicabo reprehenderit nesciunt recusandae, quod distinctio vero et quia omnis? Corporis omnis, ipsa in, quae iste libero minus, voluptatem perferendis molestiae consectetur nam odio eligendi enim consequuntur! Quis ratione iure modi eos quaerat facere molestiae. Quaerat voluptatibus distinctio sed nisi aliquam, laboriosam laudantium fugiat dolores. Corporis suscipit modi corrupti. Delectus assumenda perspiciatis asperiores porro ipsam quaerat nesciunt provident sit non distinctio veritatis tempora omnis fugit dicta minima nisi aliquam ducimus rem, nobis cum.",
      "bounced": "Respinta",
      "buffering": "In buffer",
      "campaignActivity": "Attività di campagna",
      "campaignConfiguration": "Configurazione della campagna",
      "campaignConfigurationWarning": "La configurazione della campagna riguarda tutti i mercati. Assicurati di dover apportare modifiche a queste impostazioni.",
      "campaignCreation": "Creazione della campagna",
      "campaignId": "ID campagna",
      "campaignStatusByRecipients": "Stato della campagna per destinatario",
      "clickThroughRate": "Click-Through Rate",
      "clickedThrough": "Cliccata",
      "conditionIfExplanation": "Esegui questa campagna o evento se l'ora corrente rientra in questa finestra; se l'ora corrente è al di fuori di questa finestra, salta la campagna o l'evento e passa all'elemento successivo.",
      "conditionWhenExplanation": "Esegui gli eventi di questa campagna quando l'ora corrente rientra in questa finestra; altrimenti, attendi la prossima finestra per eseguire gli eventi.",
      "createCampaign": " Crea campagna",
      "ctr": "CTR",
      "customerAcquisition": "Acquisizione clienti",
      "dateAdded": "Data di aggiunta",
      "dateAddedTooltip": "La data e l'ora esatte in cui il contatto è stato aggiunto a questa campagna. L'ora di inizio del primo evento può variare a seconda delle configurazioni.",
      "deletedRestorePrompt": "Questa campagna è stata eliminata! Vuoi ripristinarla?",
      "delivered": "Consegnata",
      "deliveryRate": "Frequenza di consegna",
      "draftMode": "Modalità Bozza",
      "draftModeDescription": "Questa campagna è una bozza. Non può essere utilizzata finché non viene pubblicata.",
      "dropped": "Interrotta",
      "emailActivity": "Attività Email",
      "emailActivityFilterExample": "Attività email: cliccata",
      "event": "Evento",
      "eventFilterExample": "Evento: 10X Email 4 (distribuzione delle inserzioni)",
      "filters": "Filtri",
      "emailPerformanceByAccount": "Prestazioni email per account",
      "emailsNotSentOnDays": "Le email non saranno inviate sabato o domenica.",
      "emailsSentOnDays": "Le email saranno inviate lunedì, martedì, mercoledì, giovedì e venerdì.",
      "eventStartDate": "Data di inizio dell'evento",
      "exampleAddress": "801 7th Avenue North, Saskatoon, SK",
      "exampleCompanyName": "City Perks Coffehouse",
      "exampleDate": "8 maggio 2017 13:27",
      "exampleEmail": "dstumph{'@'}vendasta.com",
      "exampleEmailDescription": "Assicurati che i dati non siano più vecchi di 30 giorni",
      "exampleEventName": "10X Email 4 (distribuzione delle inserzioni)",
      "getMoreCustomers": "Ottieni più clienti",
      "inProgress": "In corso",
      "includedDays": "Giorni Inclusi",
      "internalSource": "Fonte interna",
      "lastUpdate": "Ultimo aggiornamento",
      "leadValuePlaceholder": "Valore in dollari di lead",
      "loopDetected": "Questa campagna è stata bloccata in stato di bozza perché sta causando un ciclo. Per attivare questa campagna, contatta l'assistenza.",
      "market": "Mercato",
      "moreDetails": "Maggiori dettagli",
      "myCampaigns": "Le mie Campagne",
      "na": "N/A",
      "newFolder": " Nuova cartella",
      "nextCampaign": "Campagna successiva",
      "nextExecutionTime": "Ora della prossima esecuzione",
      "opened": "Aperta",
      "openRate": "Tasso di apertura",
      "option2": "Opzione 2",
      "option3": "Opzione 3",
      "pageNavigation": "Esempio di navigazione della pagina",
      "processed": "Elaborazione eseguita",
      "published": "Pubblicata",
      "recipient": "Destinatario",
      "recipients": "Destinatari",
      "sampleCampaign": "Campagna di esempio ",
      "scheduling": "Programmazione",
      "seeHotLeads": "Visualizza lead caldi",
      "selectDateRange": "Seleziona l'intervallo di date",
      "selectTimeZone": "Seleziona fuso orario",
      "separator": " / ",
      "showingCount": "Mostra {current} di {total}",
      "spamReport": "Segnalazione spam",
      "startByAddingEvent": "Inizia aggiungendo un evento a questa campagna.",
      "stopOnResponse": "Interrompi alla risposta",
      "stopped": "Fermata",
      "time": "Ora",
      "timeConditionNote": "Nota: se il primo passaggio nelle campagne è impostato su \"Immediatamente\", allora la condizione di tempo non si applica per quel primo passaggio.",
      "timeZoneDescription": "Questa impostazione influenzerà il momento in cui il tuo contenuto verrà inviato.",
      "totalLeads": "Totale lead",
      "undeliverable": "Non consegnabile",
      "unsubscribe": "Annulla iscrizione",
      "upNext": "In arrivo",
      "utc": "UTC",
      "window": "Finestra"
    },
    "embed": {
      "copyLinkInstructions": "Copia il link qui sotto e condividilo facilmente ovunque desideri.",
      "embed": "Incorpora",
      "iframeEmbed": "Incorporamento Iframe",
      "integrateInstructions": "Usa le seguenti opzioni per integrare il tuo modulo personalizzato nel tuo sito web",
      "integrateYourForm": "Integra il tuo modulo",
      "link": "Link",
      "saveAndExit": "Salva ed esci"
    },
    "jotbox": {
      "deleteSubmission": "Elimina invio",
      "downloadPdf": "Scarica PDF",
      "ofSubmissions": " di {total} invii",
      "pages": "pagine",
      "records": "record",
      "searchPlaceholder": "Cerca per nome, email, telefono e ID contatto",
      "selectYourForm": "Seleziona il tuo modulo",
      "timeSigned": "Ora di firma:",
      "totals": "Totali:"
    },
    "survey": {
      "createNewSurvey": "Crea un nuovo sondaggio",
      "integrateYourSurvey": "Integra il tuo sondaggio",
      "noSurveysForAnalyze": "Non hai ancora nessun sondaggio. Crea prima un sondaggio per vedere l'analisi qui.",
      "noSurveysForSubmission": "Non hai ancora nessun sondaggio. Crea prima un sondaggio per vedere l'invio qui.",
      "noSurveysYet": "Non hai ancora nessun sondaggio.",
      "refreshData": "Aggiorna dati",
      "searchSurveys": "Cerca Sondaggi",
      "surveyBuilder": "Builder di sondaggi",
      "toCreateFirstSurvey": "per creare il tuo primo sondaggio."
    }
  },
  "membership": {
    "acceptShare": {
      "clonedMessage": "Prodotto clonato! Passa a un account in cui è stato clonato e trovalo nella scheda Iscrizione > Prodotti.",
      "errorGettingDetails": "Sembra che si sia verificato un errore durante l'acquisizione dei dettagli del prodotto. Controlla l'URL o riprova!"
    },
    "resetPassword": {
      "title": "Reimposta password",
      "button": "Reimposta password",
      "newPassword": "Nuova password",
      "generateStrongPassword": "Genera una password complessa",
      "sendEmailNotification": "Invia anche una notifica email.",
      "errorMessage": "Si è verificato un errore durante il ripristino della password. Riprova.",
      "updating": "Aggiornamento in corso..."
    }
  },
  "notifications": {
    "psBubble": {
      "byText": "⚡ da",
      "combo": {
        "signedUp": "iscritti a ProveSource nelle ultime 24 ore",
        "verifiedBy": "verificato da "
      },
      "conversions": {
        "recentlyBought": "ha acquistato questo di recente",
        "timeAgo": "negli ultimi 16 minuti ",
        "visitorsCount": "50 visitatori"
      },
      "pageVisits": {
        "description": "sembrano avere fame.",
        "timeAgo": "negli ultimi 21 minuti                        ",
        "title": "50 buongustai"
      },
      "proveSource": "ProveSource",
      "review": {
        "proofMessage": " ProofMessge",
        "rating": "valutazione a 5 stelle",
        "recently": "Recentemente",
        "reviewerName": "Varun Vairavan",
        "starIcon": "⚡"
      },
      "stream": {
        "action": "iscritto a ProveSource",
        "location": "(London, Regno Unito)",
        "name": "Mike ",
        "timeAgo": "40 minuti fa                        "
      },
      "visitors": {
        "description": "appassionati di musica online"
      }
    },
    "step1": {
      "combo": {
        "description": "Mostra il numero totale di persone che hanno compiuto un'azione specifica in 24 ore, 7 o 30 giorni.",
        "title": "Combinazione"
      },
      "conversions": {
        "description": "Crea convalida sociale mostrando quanti clienti hanno compiuto un'azione specifica."
      },
      "liveReviews": {
        "description": "Mostra ai tuoi visitatori recensioni in tempo reale da almeno 4 stelle degli ultimi 6 mesi."
      },
      "liveVisitors": {
        "beta": "Beta",
        "description": "Mostra quanti visitatori stanno attualmente visualizzando l'intero sito in tempo reale."
      },
      "pageVisits": {
        "description": "Mostra ai visitatori le visite recenti alle pagine per far capire che non sono soli."
      },
      "stream": {
        "description": "Cosa c'è di meglio che dare un volto a quella prova sociale? Mostra i tuoi clienti recenti e le loro azioni."
      }
    },
    "step2": {
      "captureDescription2": "Ogni URL di pagina deve avere un campo di modulo email",
      "captureDescription3": " e ProveSource installato. ",
      "comboType": "Tipo di combinazione",
      "connectAccounts": "Assicurati di collegare gli account da cui vuoi estrarre le recensioni",
      "connectGoogleAccount": "Collega l'account Google della tua posizione",
      "formSubmissions": "Invio di moduli",
      "googleAccount": "Account Google",
      "howToTrack": "Come tracciare",
      "howToTrackDescription": "Come desideri che tracciamo le tue conversioni?",
      "pageUrl": "URL della pagina",
      "productPurchase": "Acquisto del prodotto",
      "trackAllUrls": "Traccia tutti gli URL delle pagine che contengono la seguente espressione. ",
      "trackVisitors": "Traccia i visitatori",
      "trackVisits": "Tieni traccia delle visite",
      "urlTip": " Consideriamo http://, https://, www e non-www come versioni separate dell'URL e della pagina. ",
      "urlValidationError": "Devi aggiungere almeno un URL. L'URL non è valido. Assicurati di aggiungere http:// o https://",
      "userSignup": "Registrazione utente",
      "visits": " Visite",
      "webhookDescription": "Chiama il seguente endpoint per informarci di un evento o conversione avvenuto dalla tua parte e che è collegato a questa notifica, noi ci occuperemo del resto.",
      "webhookRequest": "Richiesta webhook",
      "whatToTrack": "Cosa desideri tracciare?",
      "whereToCapture": "Dove acquisire",
      "whereToCaptureDescription": "Dove stai tracciando le conversioni?",
      "whichPagesToTrack": "Quali pagine vorresti che tracciassimo?",
      "yourWebhookUrl": "Il tuo URL webhook"
    },
    "step3": {
      "allPages": " Tutti le Pagine",
      "displayOnAllPages": "Visualizza su tutti gli URL delle pagine che contengono la seguente espressione: ",
      "whereToDisplay": "Dove visualizzare",
      "whereToDisplayActivity": "Dove vorresti che mostriamo questa attività?"
    },
    "step4": {
      "icons8": "Icons8.com",
      "icons8Instructions": "per icone di buona qualità (clic destro su un'icona -> Copia l'indirizzo dell'immagine)",
      "messageSettings": "Impostazioni dei messaggi",
      "messageText": "Testo del messaggio",
      "referToVisitorsAs": "Riferisciti ai visitatori come",
      "visitIcons8": "Visita"
    },
    "step5": {
      "allowUsersToClose": " Consenti agli utenti di chiudere la notifica ",
      "behavior": "Comportamento",
      "bottomLeft": "In basso a sinistra",
      "bottomRight": "In basso a destra",
      "clickableNotification": " Notifica cliccabile ",
      "customizeDescription": "Modifica le seguenti impostazioni per controllare il comportamento e l'aspetto della notifica",
      "design": "Progettazione",
      "displayNotificationFor": "Mostra notifica per",
      "displayRules": "Regole di visualizzazione",
      "hideOnMobileScreens": " Nascondi sugli schermi dei dispositivi mobili ",
      "linkRelativeNote": " Se http:// viene omesso, il link si aprirà rispetto alla pagina visualizzata ",
      "minimumEventsToDisplay": "Eventi minimi da mostrare",
      "notificationLink": "Link di notifica",
      "notificationPosition": "Posizione delle notifiche",
      "openLinkInNewTab": "Apri link in una nuova scheda",
      "selectPosition": "Seleziona posizione",
      "showOnlyOncePerSession": " Mostra una sola volta per sessione ",
      "titleBackground": "Sfondo del titolo",
      "titleColor": "Colore del titolo",
      "topLeft": "In alto a sinistra",
      "topRight": "In alto a destra",
      "typeUrlHere": "Digita l'URL qui"
    },
    "step6": {
      "identifyNotification": "Identifica la tua notifica",
      "launchMessage": "Siamo pronti al lancio, accomodati e allacciati le cinture di sicurezza.",
      "notificationName": "Nome della notifica",
      "notificationNamePrompt": "Qual è il nome della tua notifica?",
      "wellDone": "Ottimo lavoro."
    },
    "wordpress": {
      "subscriptionCreatedSuccessfully": "Abbonamento creato correttamente",
      "youCanNowSetupWordPress": "Ora può configurare il suo sito WordPress",
      "subscriptionFailed": "Abbonamento non riuscito",
      "resubscriptionSuccessful": "Rinnovo dell'iscrizione riuscito",
      "successfullyReactivated": "Il tuo abbonamento WordPress è stato riattivato correttamente",
      "reactiveSub": "Impossibile riattivare l'abbonamento",
      "resubscriptionFailed": "Rinnovo dell'abbonamento non riuscito"
    },
    "v2": {
      "viewDetails": "Visualizza dettagli",
      "chatConversationAssigned": "Conversazione di chat assegnata",
      "internalChat": "Chat interna",
      "newTask": "Nuova attività",
      "appointmentReminder": "Promemoria appuntamento",
      "facebookReview": "Recensione Facebook",
      "googleReview": "Recensione Google",
      "internalChatMessage": "Messaggio nella chat interna",
      "newAppointmentAssigned": "Nuovo appuntamento assegnato",
      "newAppointmentBooked": "Nuovo appuntamento prenotato",
      "newCall": "Nuova chiamata",
      "newEmail": "Nuova email",
      "newMention": "Nuova menzione",
      "newReviewReceived": "Nuova recensione ricevuta da {contactName}",
      "taskReminder": "Promemoria attività",
      "completed": "completato",
      "failed": "non riuscito",
      "subAccount": "Account secondario",
      "newMessage": "Nuovo messaggio",
      "newAppointmentBookedWith": "Nuovo appuntamento prenotato con {contactName}",
      "newAppointmentAssignedTo": "Nuovo appuntamento assegnato a {contactName}",
      "appointmentDueIn": "Appuntamento in scadenza tra {minutes} minuti con {contactName}",
      "newTypeReceived": "Nuovo elemento ({type}) ricevuto da {contactName}",
      "newChatAssigned": "Nuova chat assegnata da {contactName}",
      "taskDueDate": "Attività \"{title}\" in scadenza il {date} alle {time} per {contactName}",
      "tasksDueToday": "{count} attività in scadenza oggi",
      "tasksOverdue": "{count} attività in ritardo",
      "taskDueIn": "Attività \"{title}\" in scadenza tra {dueTime} {unitOfTime} per {contactName}",
      "mentionedInConversation": "{userName} ti ha menzionato una conversazione con {contactName}",
      "now": "ora"
    }
  },
  "onboarding": {
    "landscapeMode": {
      "altTexts": {
        "logo": "Logo aziendale"
      },
      "bestExperience": "la migliore esperienza.",
      "optimizedFor": "Questa pagina è ottimizzata per",
      "portraitMode": "modalità ritratto",
      "toGiveYou": "per offrirti"
    }
  },
  "pagination": {
    "goToFirstPage": "Vai alla prima pagina.",
    "goToLastPage": "Vai all'ultima pagina",
    "goToNextPage": "Vai alla pagina successiva",
    "goToPreviousPage": "Vai alla pagina precedente",
    "itemsSelected": "{count} elementi selezionati",
    "showingEntries": "Mostra da {from} a {to} di {total} voci"
  },
  "pmd": {
    "0": "0",
    "10": "10",
    "_min": "/min",
    "_please_add_a_payment_method_for": "! Aggiungi un metodo di pagamento per",
    "_segment": "/ segmento",
    "ad_manager": "Gestione annunci",
    "add": "[AGGIUNGI:",
    "ai_employee": "AI Employee",
    "billing": {
      "incompleteBillingInfo": "Hai informazioni di fatturazione incomplete su questo account. Aggiornale immediatamente.",
      "updateNow": "Aggiorna adesso"
    },
    "charge": "Costo",
    "contactLimit": {
      "message": "Hai raggiunto il limite del piano attuale per l'aggiunta di {contact}. Per continuare, aggiorna il tuo piano e sblocca capacità aggiuntiva.",
      "upgradeNow": "Aggiorna ora",
      "warningMessage": "Hai {current} contatto/i, mentre il tuo piano ne permette solo fino a {limit}.",
      "warningTitle": "L'utilizzo dell'account è oltre il limite. Passa a un piano superiore per continuare a lavorare senza interruzioni."
    },
    "cost_borne_by_you": "ai costi sostenuti da te",
    "dedicated_ip": "IP dedicato",
    "electeditem": "Elemento selezionato",
    "feedback": "Feedback:",
    "hello": "Salve",
    "helpDrawer": {
      "aiSupportAssistant": "Assistente di supporto AI",
      "clickToCopy": "Fai clic per copiare il numero di relazione",
      "clickToCopyToClipboard": "Fai clic per copiare il numero di relazione negli appunti",
      "companyRelationshipNumber": "Numero di relazione dell'azienda",
      "hiImHighly": "Ciao, sono Highly!",
      "implementation": "Implementazione",
      "joinImplementationVideo": "Partecipa alla videochiamata di implementazione",
      "joinTrialZoom": "Partecipa alla chiamata Zoom di prova",
      "kickoff": "calcio d'inizio",
      "needHelpChatVideo": "Hai bisogno di aiuto? Inizia subito una chat o una videochiamata con noi!",
      "openAIAssistant": "Assistente di supporto Open AI",
      "premium": "Premium",
      "priority": "Priorità",
      "raiseSupportTicket": "Apri un ticket di supporto",
      "raiseTicket": "Apri un ticket",
      "relationshipNumber": "Numero di relazione",
      "startAISupportChat": "Avvia chat di supporto AI",
      "startAgentChatWait": "Avvia chat con un agente con 2-5 minuti di attesa",
      "startChatChoose": "Avvia chat: scegli tra supporto AI o chat con un agente",
      "startImplementationVideo": "Avvia videochiamata di implementazione",
      "startZoom": "Avvia Zoom",
      "startZoomCall": "Avvia chiamata Zoom",
      "subtitle": "Che tu voglia parlare con noi, interagire con la comunità o imparare in autonomia, abbiamo quello che fa per te!",
      "title": "Aiuto e supporto",
      "trialExperience": "Esperienza di prova",
      "useButtonsBelow": "Seleziona uno dei pulsanti qui sotto per ottenere aiuto!",
      "videoCallReward": "Partecipa a una videochiamata per creare il tuo account, e fatti accreditare {amount} nel portafoglio quando partecipi.",
      "videoCallType": "Partecipa a una videochiamata con me per la tua chiamata di tipo: {type}.",
      "yourPremiumSupportSpecialist": "Il tuo specialista dell'assistenza ({type})",
      "yourSpecialist": "Il tuo specialista ({type})",
      "yourSupportSpecialist": "Il tuo specialista dell'assistenza",
      "videoCall": "Videochiamata",
      "active": "Attivo",
      "announcementsAria": "Annunci - fai clic per aprire in una nuova scheda",
      "chat": "Chat",
      "accessWelcomeCourseAria": "Fai clic per accedere al corso di benvenuto HighLevel",
      "clickToUpgrade": "Fai clic per aggiornare",
      "connectCertifiedAdminAria": "Entra in contatto con un amministratore certificato - fai clic per aprire in una nuova scheda",
      "connectWithUsAria": "Entra in contatto con noi - avvia la chat dal vivo",
      "contactUsAria": "Contattaci - chiama HighLevel al numero +1(888)732-4197",
      "copied": "Copiato",
      "highlevelEventsAria": "Eventi di HighLevel - fai clic per aprire in una nuova scheda",
      "joinFacebookGroupAria": "Unisciti al nostro gruppo Facebook - fai clic per aprire in una nuova scheda",
      "onboardingVideoTutorialsAria": "Video tutorial di onboarding - fai clic per aprire in una nuova scheda",
      "recommended": "Consigliato",
      "visitHelpCenterAria": "Visita il nostro Centro assistenza - fai clic per aprire in una nuova scheda",
      "contactUs": "Contattaci",
      "agentChatWaitTime": "Chat con un agente (~ 2-5 minuti di attesa)",
      "aiSupportChat": "Chat di supporto AI",
      "startChat": "Avvia chat",
      "announcements": "Annunci",
      "fastestGrowingCommunity": "Entra a far parte della community in più rapida crescita.",
      "callHighlevelPhone": "Chiama HighLevel al numero +1(888)732-4197",
      "connectCertifiedAdmin": "Entra in contatto con un amministratore certificato",
      "connectTeamVideoCall": "Parla con il nostro team per ricevere assistenza tramite una videochiamata in tempo reale!",
      "connectWithUs": "Connettiti con noi",
      "dailyBrainstormingSessions": "Sessioni quotidiane di brainstorming con HighLevel",
      "certifiedAdminDescription": "Scopri gli esperti di HighLevel che possono aiutarti a configurare il tuo sistema, automatizzare i flussi di lavoro o personalizzare il tuo progetto.",
      "getAccessWelcomeCourse": "Accedi al corso di benvenuto HighLevel",
      "premiumSupportDescription": "Ricevi assistenza in via prioritaria in caso di problemi, fatti aiutare da esperti e consulta direttamente il nostro team tecnico tramite Slack.",
      "highlevelEvents": "Eventi di HighLevel",
      "joinFacebookGroup": "Unisciti al nostro gruppo Facebook",
      "onboardingVideoTutorials": "Video tutorial di onboarding",
      "premiumSupport": "Supporto Premium",
      "setupAccountFreeTutorials": "Configura il tuo account, con tutorial gratis",
      "viewSupportTicketsArticles": "Visualizza i tuoi ticket di assistenza, i nostri articoli di supporto e le utili FAQ!",
      "visitHelpCenter": "Visita il nostro Centro assistenza",
      "welcomeCourse": "Corso di benvenuto",
      "beta": "Beta",
      "closeHelpSupportDrawer": "Chiudi il pannello Aiuto e supporto",
      "upgradePlanToEnable": "Devi aggiornare il tuo piano per abilitare questa funzionalità",
      "premiumSupportActive": "Il tuo supporto premium è attivo",
      "premiumSupportClickUpgrade": "Supporto Premium - Fai clic per aggiornare il tuo piano",
      "premiumSupportActiveAria": "Supporto Premium - Il tuo supporto premium è attivo",
      "keepUpToDateNews": "Scopri in anteprima tutte le ultime notizie e release!"
    },
    "hi": "Salve",
    "is_scheduled_for_deletion_on": "è programmato per l'eliminazione il",
    "k": "K",
    "limit_updated_from": "limite aggiornato da",
    "minimum_must_be": "Il minimo deve essere",
    "more_emails_in_thread": "altre email nel thread",
    "multipleUsers": {
      "chooseAccount": "Seleziona un account per continuare"
    },
    "must_be_in_range_of_0": "Deve essere compreso tra 0 e",
    "numbers_and": "numero/i e",
    "premiumSupport": {
      "assigningManager": "Assegnazione del responsabile tecnico dell'account...",
      "bookCall": "Prenota una chiamata",
      "hiIm": "Ciao, sono {name}",
      "joinZoomNow": "Partecipa ora alla chiamata Zoom",
      "quickActions": "Azioni di supporto rapido",
      "quickLinks": "Link rapidi",
      "raiseFeatureRequest": "Invia richiesta di funzionalità",
      "slackChannelCreating": "Manca poco: il tuo canale Slack premium si sta avviando! 🚀",
      "technicalAccountManager": "Responsabile tecnico dell'account",
      "viewRoadmap": "Visualizza la roadmap del prodotto"
    },
    "prospecting": "Prospezione",
    "reloadPopup": {
      "message": "Abbiamo notato che non aggiorni la pagina da un po'. Ricarica la pagina per ottenere la migliore esperienza dall'app.",
      "refreshNow": "Aggiorna adesso"
    },
    "resell_settings": "Impostazioni di rivendita",
    "row": "riga",
    "select_upto": "Seleziona fino a",
    "seo": "SEO",
    "supportCalendar": {
      "description": "Ricevi supporto dedicato nel momento a te più comodo.",
      "title": "Programma una chiamata con il supporto Highlevel"
    },
    "these_are_margins_that_are_billed_to_your_clients_": "Si tratta di margini che vengono fatturati ai tuoi clienti in aggiunta",
    "twilioSetup": {
      "autoSetup": {
        "benefit1": "Lasciaci gestire Twilio per te senza problemi",
        "benefit2": "Il nostro team di supporto si occupa dei tuoi problemi con Twilio",
        "button": "Lo faccia per me",
        "drawback": "Paga {price} in più per i servizi a valore aggiunto rispetto a farlo autonomamente",
        "title": "Lo faremo noi per te"
      },
      "lowCreditsMessage": "Devi collegare un account Twilio per gestire chiamate e messaggi, che vengono inviati/ricevuti su HighLevel.",
      "lowCreditsTitle": "Hai pochi crediti gratuiti su Twilio ma noi ti copriamo le spalle!",
      "selfSetup": {
        "benefit1": "Gestisci le tue spese",
        "benefit2": "Ottieni un maggiore controllo sul tuo servizio Twilio",
        "button": "Me ne occuperò",
        "drawback1": "Assumi qualcuno per gestire il servizio Twilio",
        "drawback2": "Contatta il supporto di Twilio quando qualcosa non funziona.",
        "title": "Fai da te"
      },
      "wip": {
        "button": "Configura Twilio ora",
        "fallback": "Per ora, dovrai gestire il tuo account Twilio.",
        "message": "Grazie per averci scelto, stiamo ancora lavorando allo sviluppo di questa funzionalità. Ti avviseremo non appena sarà disponibile per il tuo account.",
        "title": "Ci stiamo ancora lavorando!"
      }
    },
    "uiComponents": {
      "loadingMoreOptions": "Caricamento di più opzioni...",
      "noElementsFound": "Ops! Nessun elemento trovato. Valuta la possibilità di cambiare la query di ricerca.",
      "noLocationsFound": "Nessun luogo trovato. Prova una ricerca diversa.",
      "typeToSearch": "Digita per cercare",
      "enterUserEmail": "Inserisca l'email dell'utente"
    },
    "updating": "Aggiornamento",
    "usd": "USD",
    "useTemplate": {
      "useTemplate": "Utilizza modello"
    },
    "validEmail": {
      "andYouCan": "E puoi",
      "as": "come",
      "canReverify": "Puoi verificare nuovamente la tua email",
      "emailIs": "Questa email è",
      "emailMarkedAs": "Questa email è contrassegnata come",
      "markedAsInvalid": "Questa email è contrassegnata come",
      "notVerified": "Non verificato",
      "reverifyHere": "Verifica di nuovo qui",
      "verifyHere": "Verifica qui"
    },
    "will_give_you_about": "avrai circa",
    "checkout": {
      "confirm": "Conferma",
      "cardInformation": "Informazioni sulla carta",
      "cardNumberInvalid": "Il numero della tua carta non è valido.",
      "commitment": "impegno",
      "paymentConsent": "Confermando, autorizzi LeadConnector ad addebitare sulla tua carta questo pagamento.",
      "subscriptionConsent": "Confermando l'abbonamento, autorizzi LeadConnector ad addebitare sulla tua carta questo pagamento e i pagamenti futuri per questo abbonamento",
      "endingIn": "termina con",
      "month": "mese",
      "pay": "Paga",
      "payWithCard": "paga con carta",
      "paymentBeingProcessed": "Il pagamento è in fase di elaborazione. Non ricaricare la pagina o premere il pulsante Indietro",
      "proceedWithExistingCard": "Procedi con la carta esistente",
      "proceedWithNewCard": "Procedi con una nuova carta",
      "purchase": "acquista",
      "subscribe": "Abbonati",
      "subscribeTo": "Abbonati a",
      "pleaseUpdateCardDetails": "Aggiorna le informazioni della carta",
      "zip": "CAP",
      "retry": "riprova",
      "initialChargesProrated": "I primi addebiti sono calcolati in proporzione e la fatturazione regolare inizierà dal",
      "youWillBeChargedFor": "Le verrà addebitato",
      "days": "giorni",
      "rightNowForPeriodTill": "adesso per il periodo fino al",
      "startGettingChargedFullAmount": "e inizierà a vedersi addebitare l'intero importo di",
      "perMonthStartingFrom": "/mese a partire da",
      "nameOnCard": "Nome sulla carta",
      "somethingWentWrong": "Qualcosa è andato storto",
      "errorImg": "errore immagine",
      "networkError": "Errore di rete, riprova più tardi",
      "paymentCouldNotBeProcessed": "Non è stato possibile elaborare il pagamento. Prova ad aggiungere di nuovo una carta."
    },
    "deleteLocation": {
      "back": "Indietro",
      "delete": "Elimina",
      "completeStepsToDelete": "Devi completare alcuni semplici passaggi per eliminare questo luogo",
      "alsoCloseAssociated": "Inoltre chiudi gli",
      "scheduling": "Programmazione...",
      "subAccountAndDeletePhoneNumbers": "account secondari associati ed elimina tutti i numeri di telefono",
      "somethingWentWrongTryAgain": "Qualcosa è andato storto... Riprova più tardi.",
      "deleteSubAccount": "Elimina account secondario",
      "scheduleForDeletion": "Programma per l'eliminazione"
    },
    "productRebilling": {
      "enableRebilling": "Abilita rifatturazione",
      "ratesMayDifferUK": "Le tariffe possono variare a seconda della regione. I calcoli mostrati sono basati sulle tariffe per il Regno Unito,",
      "examplePricingGpt4oMini": "Esempio di prezzi - GPT-4o Mini",
      "input": "Input",
      "output": "Output",
      "supportDoc": "documentazione di supporto",
      "unsavedChanges": "Modifiche non salvate",
      "to": "a",
      "chargedToCustomerLower": "Addebitato al cliente",
      "model": "Modello",
      "profit": "Profitto",
      "saving": "Salvataggio in corso...",
      "type": "Tipo",
      "updating": "Aggiornamento in corso...",
      "clickHere": "Fai clic qui",
      "chargedToCustomer": "Addebitato al cliente",
      "enabling": "Abilitazione in corso...",
      "forMoreDetails": "per ulteriori dettagli.",
      "tenDollarsWillGive": "Con 10 $ avrai circa",
      "yourCost": "Il tuo costo",
      "seeHow": "Scopri come",
      "clientCompanyBillingPage": "pagina di fatturazione dell'azienda del cliente",
      "connectStripeToEnable": "Per attivare la rifatturazione, è necessario collegare Stripe sulla",
      "companyStripeIntegrationPage": "pagina di integrazione Stripe dell'azienda",
      "enterClientCardInfo": "Per attivare la rifatturazione, devi inserire le informazioni della carta del tuo cliente sulla",
      "gpt4oMini": "GPT-4o-mini",
      "for750kWords": "(per 750.000 parole)",
      "words": "parole",
      "yourCostLower": "Il Suo costo",
      "and": "e",
      "or": "o",
      "minimumMustBeBetween": "Il minimo deve essere compreso tra",
      "upgradeToAgencyPro": "passa al piano Agency Pro",
      "planToSetMargins": "pianificare di impostare i margini"
    },
    "m": "m",
    "label": "Etichetta",
    "company_email_": "Email aziendale (",
    "me_": "Io (",
    "automation_type": "Tipo di automazione",
    "calendar_groups": "Gruppi di calendari",
    "length_": ".length }}"
  },
  "products": {
    "noProducts": "Nessun prodotto disponibile",
    "selectProduct": "Seleziona un prodotto"
  },
  "reselling": {
    "common": {
      "additionalMessagesInfo": ". I messaggi {product} aggiuntivi non verranno addebitati ai luoghi. Per rifatturare al cliente, abilita la modalità SaaS e la rifatturazione.",
      "agreementPrefix": "Accetto di abilitare",
      "agreementSuffix": "per questo cliente senza rivendere e riconosco che mi verrà addebitato il costo",
      "buildResellerOffer": "Crea la tua offerta di rivendita",
      "deployDirectlyDescription": "Utilizza questa opzione se offri {product} come parte dell'offerta o se desideri fatturare al cliente esternamente",
      "deployPrefix": "Implementa",
      "directlySuffix": "Direttamente",
      "learnMore": "Scopri di più.",
      "offerPrefix": "Offerta",
      "resellPrefix": "Rivendi",
      "resellingPrefix": "Rivendita",
      "subscriptionRestriction": "Non è possibile modificare la configurazione poiché il luogo è già iscritto",
      "zero": "0",
      "highlevelPrice": "Prezzo di HighLevel",
      "howDoesItWork": "Come funziona?",
      "payNowButton": "Paga ora",
      "priceValidationError": "Il prezzo deve essere maggiore o uguale al prezzo di HighLevel",
      "saving": "Salvataggio",
      "yourPrice": "Il tuo prezzo",
      "yourProfit": "Il tuo profitto"
    },
    "whatsapp": {
      "inboundMessagesInfo": "Ricevere messaggi in entrata e rispondere utilizzando testo libero nella finestra di conversazione è gratuito. Saranno applicati costi aggiuntivi di passaggio per i messaggi di modello in uscita, qualora vengano inviati.",
      "whatsappLocation": "Luogo WhatsApp"
    },
    "agencyResellingPage": {
      "seo": {
        "subscriptionRestriction": "Non è possibile modificare la configurazione poiché il luogo è già iscritto",
        "offerPrefix": "Offerta ",
        "poweredByPrefix": " (Sviluppato da Search Atlas)",
        "toggleTooltipDisable": "Questa azione disabiliterà lo strumento SEO per tutti gli account secondari.",
        "toggleTooltipEnable": "Questa azione abiliterà lo strumento SEO per tutti gli account secondari.",
        "resellPrefix": "Rivendi ",
        "howDoesItWork": "Come funziona?",
        "buildResellerOffer": "Crea la tua offerta di rivendita",
        "yourPrice": "Il tuo prezzo",
        "highlevelPrice": "Prezzo di HighLevel",
        "yourProfit": "Il tuo profitto",
        "priceValidationError": "Il prezzo deve essere maggiore o uguale al prezzo di HighLevel",
        "saving": "Salvataggio",
        "save": "Salva",
        "deployPrefix": "Implementa ",
        "directlySuffix": "Direttamente",
        "deployDirectlyDescription": "Utilizza questa opzione se offri SEO come parte dell'offerta o se desideri fatturare al cliente esternamente",
        "agreementPrefix": "Accetto di abilitare ",
        "agreementSuffix": " per questo cliente senza rivendere e riconosco che mi verrà addebitato il costo",
        "payNowButton": "Paga ora",
        "subscriptionCreating": "L'abbonamento è in fase di creazione.<br/>Non ricaricare la pagina o premere il pulsante Indietro",
        "subscriptionCreated": "Abbonamento creato correttamente. Attendi...",
        "subscriptionError": "Non è stato possibile creare l'abbonamento, contatta l'assistenza"
      },
      "adManager": {
        "subscriptionRestriction": "Non è possibile modificare la configurazione poiché il luogo è già iscritto",
        "offerPrefix": "Offerta ",
        "resellingPrefix": "Rivendita",
        "resellPrefix": "Rivendi ",
        "howDoesItWork": "Come funziona?",
        "bookACall": "Prenota una chiamata",
        "bookCallTooltip": "Prenoti una chiamata con il nostro team per saperne di più su Ad Manager",
        "buildResellerOffer": "Crea la tua offerta di rivendita",
        "yourPrice": "Il tuo prezzo",
        "highlevelPrice": "Prezzo di HighLevel",
        "yourProfit": "Il tuo profitto",
        "priceValidationError": "Il prezzo deve essere maggiore o uguale al prezzo di HighLevel",
        "loading": "Caricamento...",
        "save": "Salva",
        "deployPrefix": "Implementa ",
        "directlySuffix": "Direttamente",
        "deployDirectlyDescription": "Utilizza questa opzione se offri Gestione annunci come parte dell'offerta o se desideri fatturare al cliente esternamente",
        "agreementPrefix": "Accetto di abilitare ",
        "agreementMiddle": " per questo cliente senza rivendere e riconosco che mi verrà addebitato il costo",
        "agreementSuffix": " al mese",
        "stripeNotConnectedLocationWarning": "Stripe non è collegato per questo luogo. Collega Stripe per abilitare questa funzionalità.",
        "stripeNotConnectedAgencyWarning": "Stripe non è collegato per questa agenzia. Collega Stripe per abilitare questa funzionalità.",
        "underSubAccountReselling": "al mese per la rivendita di account secondari"
      },
      "dedicatedIp": {
        "description": "Ciò ti consente di rifatturare l'IP dedicato (utilizzato per l'invio di email in uscita) per i costi ai tuoi clienti e includere un markup",
        "numberOfIps": "Numero di IP:",
        "yourCost": "Il tuo costo:",
        "chargedToCustomer": "Addebitato al cliente:",
        "profit": "Profitto:",
        "monthlyProfit": "Profitto mensile:",
        "loading": "Caricamento...",
        "save": "Salva",
        "revokeDedication": "Revoca IP dedicati",
        "revokeDescription": "Utilizza questa opzione per interrompere l'offerta di nuovi IP dedicati al tuo cliente senza addebitargli alcun costo",
        "existingSubscriptionsNote": "Gli abbonamenti IP attuali non saranno influenzati",
        "revoke": "Revoca",
        "provideDirectlyTitle": "Fornisci direttamente l'IP dedicato per l'email",
        "provideDirectlyDescription": "Utilizza questa opzione per assegnare un IP dedicato al tuo cliente senza addebitargli alcun prezzo",
        "agreeToProvideText": "Accetto di fornire l'IP per questo cliente senza upselling",
        "acknowledgeChargeText": "Riconosco che mi verranno addebitati 59 $ al mese/IP",
        "agree": "Accetto",
        "yourMonthlyCost": "Il tuo costo mensile per IP:",
        "monthlyChargeToCustomer": "Costo mensile al cliente:",
        "resellingSettingsSuffix": " Impostazioni di rivendita",
        "ipRebillingAmount": "Importo di rifatturazione IP"
      }
    }
  },
  "saas": {
    "disable": {
      "complianceModal": {
        "clientApproval": "Confermo di averne discusso con il mio cliente e di avere la sua approvazione",
        "confirmQuestion": "Vuoi davvero disabilitare la modalità SaaS per questo luogo?",
        "dataLossAck": "Riconosco che tutti i dati di rifatturazione, i dati dell'abbonamento SaaS e il registro delle transazioni andranno persi",
        "disableSaas": "Disabilita modalità SaaS",
        "irreversibleAck": "Comprendo che questa azione è irreversibile"
      },
      "confirmationModal": {
        "cancelSubscription": "Annulla anche l'abbonamento SaaS associato",
        "confirmDisable": "Conferma la disabilitazione",
        "confirmQuestion": "Vuoi davvero disabilitare la modalità SaaS?",
        "somethingWentWrong": "Qualcosa è andato storto... Riprova più tardi."
      },
      "processingModal": {
        "closeNow": "Chiudi ora",
        "closeWindowInstructions": "Puoi chiudere questa finestra, ti informeremo via email una volta terminato il processo",
        "title": "La modalità SaaS verrà presto disabilitata per questo luogo.",
        "typicalTime": "Questa operazione richiede in genere 10 minuti o meno."
      }
    }
  },
  "settings": {
    "customFields": {
      "addCustomField": "Aggiungi campo personalizzato",
      "fieldKey": "Chiave del campo",
      "fieldName": "Nome del campo",
      "idWillBeAdded": "L'ID verrà aggiunto dopo la creazione del motivo della perdita",
      "lostReasonID": "ID motivo della perdita",
      "placeholder": "Segnaposto"
    },
    "locationMailGun": {
      "bccAddress": "Indirizzo CCN",
      "clearError": "Rimuovi l'errore",
      "deleteConfirmationMessage": "Questa azione rimuoverà il collegamento a Mailgun.",
      "deleteConnection": "Elimina connessione",
      "domain": "Dominio",
      "domainsAvailable": "Disponibili: {count}",
      "invalidApiKey": "API Key non valida",
      "selectDomain": "Seleziona dominio"
    },
    "locationWallet": {
      "fetchTransactionDetailsError": "Errore durante il recupero dei dettagli della transazione",
      "transactions": "Transazioni"
    },
    "noShowSMS": {
      "smsWithImage": "SMS di mancata presentazione con immagine",
      "title": "Personalizza SMS di recensione"
    },
    "optOut": {
      "addKeywords": "Aggiungi una delle seguenti parole chiave per l'annullamento dell'iscrizione: STOP, STOPALL, UNSUBSCRIBE, CANCEL, END o QUIT.",
      "customizeTitle": "Personalizza il messaggio di annullamento dell'iscrizione",
      "disableConfirm": "Confermi di voler disabilitare il messaggio di annullamento dell'iscrizione?",
      "disableOptOut": "Disabilita l'annullamento dell'iscrizione",
      "disableTitle": "Vuoi disabilitare il messaggio di annullamento dell'iscrizione?",
      "optInConfirmClient": "Confermo che mi assicurerò che gli SMS siano inviati solo ai contatti che hanno scelto di riceverli.",
      "quickTipMessage": "Il messaggio iniziale che invii a un individuo deve includere una delle seguenti parole chiave standard per l'annullamento dell'iscrizione: STOP, STOPALL, UNSUBSCRIBE, CANCEL, END o QUIT.",
      "reallyDisableConfirm": "Vuoi davvero disattivare il messaggio di annullamento dell'iscrizione?"
    },
    "payments": {
      "logViewer": {
        "requestPostBody": "Corpo del POST della richiesta",
        "requestQueryParameters": "Parametri di query della richiesta",
        "responseBody": "Corpo della risposta"
      },
      "logs": "Registri",
      "logsPage": {
        "clearAll": "Rimuovi tutto",
        "loadMore": "Carica altro",
        "price": "Prezzo",
        "product": "Prodotto",
        "tabsAriaLabel": "Schede dei registri dei pagamenti"
      }
    },
    "senderInfo": {
      "addGeneralTextAt": "Aggiungi un testo generale a:",
      "beginning": "Inizio",
      "complianceConfirm": "Confermo che mi assicurerò che tutti gli SMS inviati da questo account siano conformi alle politiche attuali",
      "customizeTitle": "Personalizza il testo generale",
      "disableConfirm": "Confermi di voler disabilitare l'ID mittente?",
      "disableSenderID": "Disabilita ID mittente",
      "disableTitle": "Vuoi disabilitare l'ID mittente?",
      "end": "Fine",
      "pleaseAdd": "Includi {text} come indicato nel suggerimento rapido.",
      "quickTipMessage": "Il messaggio iniziale che invii a un individuo deve includere i dati identificativi del mittente. Includi {text} nella casella di testo generale.",
      "reallyDisableConfirm": "Vuoi davvero disabilitare l'ID mittente?",
      "senderID": "ID mittente"
    },
    "shopify": {
      "adminApiAccessToken": "Token di accesso all'API Admin",
      "apiTokenRequired": "Il token di accesso API è obbligatorio",
      "checkDocumentation": "Per ulteriori informazioni, consulta questa documentazione",
      "checkmark": "✓",
      "cross": "✗",
      "customAppApiAccessToken": "Token di accesso personalizzato all'API dell'app",
      "deleteWarning": "L'eliminazione rimuoverà il collegamento esistente.",
      "existStoreAlertTitle": "L'integrazione del negozio Shopify esiste già",
      "integration": "Integrazione Shopify",
      "integrationHealth": "Stato dell'integrazione",
      "orders": "Ordini",
      "scopePermissionsWarning": "Controlla che alla tua app siano concesse le autorizzazioni contrassegnate con una croce rossa",
      "scopes": "Ambiti",
      "scopesDescription": "Sono necessari gli ambiti di autorizzazione per accedere alle informazioni di Shopify. Per via delle recenti modifiche in Shopify, ora la lettura dei clienti deve ottenere tutte le informazioni dai clienti, per via dei dati dei clienti protetti da Shopify.",
      "storeConnectedMessage": "Il negozio Shopify è già collegato con l'account secondario {locationName}",
      "storeNameHelp": "Il nome del tuo negozio si trova nell'URL del tuo account Shopify, dopo https:// e prima di .myshopify.",
      "storeNameLabel": "Nome del tuo negozio Shopify",
      "storeNamePlaceholder": "nome del negozio",
      "storeNameRequired": "Il nome del negozio è obbligatorio",
      "typeRemoveConfirm": "Digita \"REMOVE\" per confermare",
      "webhooks": "Webhook",
      "webhooksDescription": "Per ricevere tutti gli eventi da Shopify, dobbiamo registrare questi webhook Shopify durante il processo di integrazione. Questi webhook sono essenziali per garantire il corretto funzionamento delle funzionalità di Shopify."
    },
    "slack": {
      "accountConnected": "account collegato",
      "accountsConnected": "account collegati",
      "accountsList": "Elenco di tutti gli account Slack",
      "added": "Data di aggiunta: {date}",
      "connectChannel": "Collega il tuo canale Slack",
      "description": "Ricevi notifiche istantanee sul tuo canale Slack. Fai clic su \"Collega\" per aggiungere un canale Slack.",
      "manage": "Gestisci",
      "manageAccounts": "Gestisci gli account Slack",
      "noIntegrations": "Nessuna integrazione Slack trovata."
    },
    "smtpService": {
      "addFirstService": "Aggiungi il tuo primo servizio SMTP.",
      "addService": "Aggiungi servizio",
      "bccEmails": "Email in CCN",
      "cannotDeleteDefaultProvider": "Non è possibile eliminare il provider predefinito.",
      "contactDeveloper": "Contatta lo sviluppatore di questa app.",
      "customProvider": "Provider personalizzato",
      "defaultProvider": "Provider predefinito",
      "defaultProviderUpdated": "Il provider predefinito è stato aggiornato con successo!",
      "emailDomain": "Email / Dominio",
      "emailService": "EMAIL Service",
      "enableReplyTracking": "Abilita tracciamento delle risposte",
      "forwardToAssignedUser": "Inoltra all'utente assegnato",
      "providerType": "Tipo di provider",
      "smtpConnectionIssue": "C'è un problema con questa connessione SMTP. Ricollega questa integrazione.",
      "useLcEmailMessage": "Usa LC Email per inviare email per la tua agenzia e i tuoi clienti."
    },
    "socialPosting": {
      "automaticPostingEnabled": "Pubblicazione automatica abilitata",
      "dailyPostLimit": "Limite di post al giorno",
      "directoriesDescription": "Quando riceverai una nuova recensione, la pubblicheremo automaticamente su oltre 80 directory online che aiutano automaticamente a far crescere il tuo brand e la tua SEO.",
      "directoriesTitle": "80+ Directory e Siti web",
      "fivePosts": "5 post",
      "fiveStars": "5 stelle",
      "fourPosts": "4 post",
      "fourStars": "4 stelle",
      "googlePlus": "Google +",
      "manageSettingsDescription": "Personalizza come e quando le tue recensioni vengono automaticamente pubblicate su ciascuno dei tuoi social network.",
      "manageSettingsTitle": "Gestisci le impostazioni di pubblicazione sui social",
      "postReviewsForRating": "Pubblica le recensioni con questa valutazione a stelle o una valutazione superiore.",
      "searchEngines": "Motori di ricerca",
      "threePosts": "3 post",
      "threeStars": "3 stelle",
      "title": "Pubblicazione Social"
    },
    "tags": {
      "addNewTag": "Aggiungi nuova etichetta",
      "allTags": "Tutti le etichette",
      "deletedTags": "Etichette eliminate",
      "here": "qui.",
      "newTag": "Nuova etichetta",
      "noTagsYet": "Non c'è ancora nessuna etichetta da mostrare",
      "searchTags": "Cerca etichette",
      "viewDeletedTags": "Puoi visualizzare e ripristinare le etichette eliminate nella pagina dei Registri di controllo"
    },
    "templateMessage": {
      "addEmailTemplate": "Aggiungi modello di email (Frammento)",
      "addTemplate": "Aggiungi modello (Frammento)",
      "addTextTemplate": "Aggiungi modello di messaggio (Frammento)",
      "body": "Corpo",
      "deleteTemplateConfirmation": "Vuoi davvero eliminare questo modello?",
      "templatesCount": "{count} modelli",
      "title": "Modelli di messaggi (Frammenti)"
    },
    "unsubscribe": {
      "content": "Contenuti",
      "contentTooltip": "Il contenuto di questo messaggio verrà automaticamente aggiunto a tutte le email.",
      "customizeTitle": "Personalizza i contenuti per l'annullamento dell'iscrizione",
      "disableConfirm": "Confermi di volere disabilitare il link di annullamento dell'iscrizione alle email?",
      "disableTitle": "Vuoi disabilitare il link di annullamento dell'iscrizione?",
      "disableUnsubscribe": "Disabilita l'opzione di annullamento dell'iscrizione",
      "pleaseAddTag": "Aggiungi l'etichetta /*annulla iscrizione*/",
      "reallyDisableConfirm": "Vuoi davvero disabilitare il link di annullamento dell'iscrizione alle email?",
      "subscribedConfirm": "Confermo che l'email verrà inviata solo ai contatti che hanno acconsentito a ricevere email.",
      "subscribedConfirmClient": "Confermo che mi assicurerò che le email vengano inviate solo ai contatti che hanno acconsentito a riceverle.",
      "suspensionWarning": "Un'attività non conforme agli standard può portare alla sospensione delle funzionalità del tuo account relative alle email.",
      "tagRequirement": "L'email iniziale che invii a un individuo deve includere l'etichetta /*annulla iscrizione*/"
    },
    "callAndVoicemailSettings": {
      "defaultVoicemailMessage": "Questo è il messaggio di segreteria telefonica predefinito per tutti i numeri di telefono in questo luogo, a meno che non venga personalizzato in",
      "forwardCallsToWebApp": "Inoltra le chiamate all'applicazione web",
      "forwardCallsToMobileApp": "Inoltra le chiamate all'app per dispositivi mobili",
      "dedicatedNumberRequiredInfo": "Questo è necessario solo se gli utenti necessitano di un numero dedicato. Non è necessario per la segreteria telefonica né per indirizzare la chiamata all'utente assegnato.",
      "voicemailMessageInfo": "Questo messaggio di segreteria telefonica verrà riprodotto al posto di quello fornito dall'operatore. Consigliamo un timeout di 20 secondi o meno.",
      "noTimeout": "Nessun timeout",
      "10Secs": "10 secondi",
      "20Secs": "20 secondi",
      "voicemailMessageDuration": " Registreremo un messaggio di segreteria telefonica se la chiamata non riceve risposta prima di questo lasso di tempo",
      "saveCallSettings": "Salva le impostazioni di chiamata"
    },
    "elizaFAQSetting": {
      "bypassElizaNote": "Quando questa etichetta è presente sul contatto, quei messaggi NON verranno recapitati a Eliza",
      "sendToElizaNote": "Per impostazione predefinita, tutte le conversazioni saranno consegnate a Eliza. Se questa etichetta è configurata, <br />le nuove conversazioni verranno inviate a Eliza solo quando questa etichetta è presente su un contatto.<br /> Se sono configurate sia l'etichetta di bypass Eliza che l'etichetta di invio a Eliza, verrà rispettata solo quella di invio",
      "permissionNote": "Le tue autorizzazioni utente non sono abilitate per questa pagina. <br />Parla con il tuo amministratore",
      "addFAQ": "Aggiungi FAQ"
    },
    "locationSettings": {
      "ownCardWarning": "Non aggiungere la tua carta agli account secondari!",
      "addClientCardWarning": "Aggiungi la carta del tuo cliente (account secondario) e non la tua, poiché questa carta verrà usata per fatturare il cliente per tuo conto.",
      "stripeConnectMissing": "Collegamento a Stripe mancante",
      "pleaseContactAgencyToAddPaymentMethods": "Si prega di contattare l'agenzia ({email}) per aggiungere metodi di pagamento"
    },
    "integrations": {
      "connectWaveAccount": "Collega l'account Wave della tua posizione",
      "connectXeroAccount": "Collega l'account Xero della tua posizione"
    },
    "gmbSettings": {
      "gbpCallTrackingEnabledOnAnotherSubAccount": "Il tracciamento delle chiamate nel profilo dell'attività su Google è abilitato su un altro account secondario. Il tracciamento delle chiamate può essere abilitato su un singolo account secondario alla volta.",
      "gbpCallTrackingEnabledOnAnotherPage": "Il tracciamento delle chiamate GBP è abilitato su un'altra pagina ({pageName}). Il tracciamento delle chiamate può essere abilitato su un singolo account secondario e una singola pagina per luogo alla volta.",
      "gbpCallsProperlySetup": "Le chiamate GBP sono configurate correttamente e stanno arrivando da",
      "tooManyEditsToPrimaryPhone": "Hai effettuato troppe modifiche al numero di telefono principale di questa azienda. Riprova più tardi.",
      "setupTwilioToStartCallTracking": "Configura Twilio per iniziare a tracciare le chiamate",
      "twoSecondaryNumbersSetupAlready": "Hai già configurato 2 numeri secondari, non puoi scambiare il numero",
      "yourAgentIDIs": "Il Suo ID agente è"
    },
    "numberPool": {
      "title": "Cosa tracciare",
      "tracking": {
        "percentComplete": "34% completo",
        "searchLower": "ricerca"
      },
      "create": {
        "title": "Crea numero di tracciamento"
      }
    },
    "phoneNumbers": {
      "title": "Cosa Tracciare",
      "tracking": {
        "percentComplete": "34% completo",
        "heading": "Crea numero di tracciamento"
      }
    }
  },
  "smartList": {
    "filterMultiInput": {
      "enterValue": "* Inserisci un valore",
      "selectOption": "* Seleziona un'opzione"
    },
    "filterMultiSelections": {
      "atLeastOneRequired": "* Almeno un {filterName} è obbligatorio",
      "select": "Seleziona {filterName}"
    },
    "newEmailStats": {
      "timeStamp": "Timestamp"
    },
    "recordsNav": {
      "clickToReloadList": "Fai clic per ricaricare l'elenco"
    },
    "reviewRequestActions": {
      "emailReviewReq": "Richiesta di recensione via email",
      "smsReviewReq": "Richiesta di recensione via SMS",
      "whatsappReviewReq": "Richiesta di recensione WhatsApp"
    },
    "smartListFilters": {
      "clearAllFilters": "Rimuovi tutti i filtri",
      "noneFound": "nessuno trovato",
      "saveChangesToList": "Salva le modifiche del filtro in questo elenco intelligente",
      "saveCombinationAsNew": "Salva la combinazione di filtri, colonne e ordinamento come nuovo elenco intelligente",
      "saveCurrentAsNew": "Salva i filtri attuali come nuovo elenco intelligente",
      "searchAndAddFilter": "Cerca e aggiungi un filtro",
      "searching": "ricerca in corso...",
      "undoUnsavedChanges": "Annulla le modifiche non salvate"
    },
    "smsStatsPanel": {
      "smsStats": "Statistiche SMS"
    },
    "manageDuplicates": "Gestisci i duplicati",
    "emailAction": {
      "attachFiles": "Allega file",
      "customValues": "Valori personalizzati",
      "triggerLinks": "Link di attivazione"
    },
    "atLeastOneRequired": "* Almeno un {filterName} è obbligatorio",
    "arrayInput": {
      "searchPlaceholder": "Cerca {filterName}",
      "searching": "Ricerca in corso..."
    }
  },
  "snapshots": {
    "common": {
      "errorWhileFetchingSnapshotContents": "Errore durante il recupero dei contenuti dello snapshot",
      "overwriteAll": "Sovrascrivi tutto",
      "skipAll": "Salta tutto",
      "somethingWentWrongWhileFindingConflicts": "Si è verificato un errore durante la ricerca dei conflitti",
      "step": "Passaggio"
    },
    "confirmOverwrite": {
      "confirmButton": "Conferma sovrascrittura",
      "description": "Questa azione è irreversibile e potrebbe modificare configurazioni di campagne, opportunità, funnel, ecc. Ti chiediamo di confermare la tua azione digitando il seguente input.",
      "title": "Vuoi davvero sovrascrivere i dati selezionati?"
    },
    "conflicts": {
      "noConflictsDetected": "Nessun conflitto rilevato",
      "overwrite": "Sovrascrivere"
    },
    "pushCloneAccount": {
      "assetsFoundLinked": "Risorse collegate trovate",
      "checkingConflicts": "Verifica dei conflitti",
      "chooseSnapshot": "Seleziona uno snapshot",
      "copyingDataNotification": "Copia dei dati nei luoghi selezionati. Attendi...",
      "linkedLocations": "Luoghi collegati",
      "noConflictsFound": "Nessun conflitto trovato",
      "notAuthorizedMessage": "Solo gli amministratori dell'agenzia possono eseguire questa azione",
      "overwriteConflicts": "Sovrascrivi conflitti",
      "pickSnapshot": "Seleziona uno snapshot",
      "response": "Risposta",
      "selectAssetsToPush": "Seleziona le risorse da inviare",
      "selectLocationsToUpdate": "Seleziona luoghi da aggiornare",
      "snapshotNotAuthorized": "Questo snapshot non è autorizzato per questo luogo",
      "snapshotNotSelected": "Snapshot non selezionato"
    },
    "share": {
      "agencyRestrictedLink": "Link riservato all'agenzia",
      "deleteShareLink": "Elimina link di condivisione",
      "editShareLink": "Modifica link di condivisione",
      "permanentLink": "Link permanente",
      "subaccountRestrictedLink": "Link riservato all'account secondario"
    },
    "shareSnapshot": {
      "addCommaAfterEach": "(Aggiungi una virgola (<span class='text-base font-bold'> , </span>) dopo ogni numero di relazione)",
      "addCommaAfterEachSubAccount": "(Aggiungi una virgola (<span class='text-base font-bold'> , </span>) dopo ogni ID account secondario)",
      "atLeast1EmailRequired": "È richiesta almeno 1 email.",
      "emailShareLink": "Link di condivisione email",
      "enterOnePerLine": "(Inseriscine uno per riga)",
      "errorGettingLink": "Qualcosa è andato storto durante l'ottenimento del link, riprova più tardi.",
      "getAgencyRestrictedLink": "Ottieni link riservato all'agenzia",
      "getLink": "Ottieni link",
      "getOneTimeLink": "Ottieni un link di condivisione monouso",
      "getPermanentLink": "Ottieni link permanente",
      "getSubAccountRestrictedLink": "Ottieni link riservato all'account secondario",
      "shareType": "Condividi tipo",
      "title": "Condividi snapshot"
    },
    "snapshot": {
      "copySnapshotID": "Copia ID snapshot",
      "deleteSnapshot": "Elimina snapshot",
      "editSnapshot": "Modifica snapshot",
      "pushUpdate": "Invia aggiornamento agli account collegati",
      "refreshSnapshot": "Aggiorna lo snapshot"
    },
    "updateShareLink": {
      "addCommaAfterEach": "(Aggiungere una virgola dopo ogni numero di relazione)",
      "addCommaAfterEachSubAccount": "(Aggiungi una virgola dopo ogni ID account secondario)",
      "title": "Aggiorna link di condivisione"
    }
  },
  "socialMedia": {
    "engagement": "Coinvolgimento",
    "potentialReach": "Portata potenziale",
    "storiesCreated": "Storie create",
    "recentPosts": "Post recenti",
    "notConnected": "Non collegato (collega ora!)",
    "totalAudience": "Pubblico Totale",
    "activeAudience": "Pubblico Attivo",
    "socialMediaOverview": "Panoramica dei social media"
  },
  "suspendModal": {
    "currentStatus": "Stato attuale dell'abbonamento: in pausa",
    "instructions": "Per {action} questo account secondario, devi completare alcuni semplici passaggi",
    "nextBillingDate": "Prossima data di fatturazione:",
    "noKeepCharging": "No, continua ad addebitare il cliente.",
    "pauseSubscriptionQuestion": "Vuoi mettere in pausa anche l'abbonamento con l'account secondario?",
    "resumeSubAccount": "Riprendi account secondario",
    "resuming": "Ripresa...",
    "saasSubscriptionActive": "Questo account secondario ha un abbonamento SaaS attivo.",
    "saasSubscriptionResumed": "L'abbonamento SaaS di questo account verrà ripreso.",
    "yesPause": "Sì, metti in pausa l'abbonamento"
  },
  "table": {
    "perPageOptions": {
      "5": "5 per pagina",
      "10": "10 per pagina",
      "15": "15 per pagina",
      "20": "20 per pagina",
      "25": "25 per pagina",
      "50": "50 per pagina",
      "100": "100 per pagina"
    },
    "filterPlaceholder": "Cerca...",
    "emptyText": "Nessun record trovato",
    "loading": "Caricamento in corso...",
    "showingEntries": "Mostra da {from} a {to} di {total} voci",
    "noEntriesToShow": "Nessuna voce da mostrare"
  },
  "templateLibrary": {
    "public": {
      "loadingAccountData": "Caricamento dei dati dell'account…",
      "toContinueWith": "per continuare con"
    },
    "switcherModal": {
      "comingSoon": "Prossimamente!",
      "multiLocationMessage": "Questa funzione è attualmente disponibile solo per account singoli. Stiamo lavorando duramente per portare presto questa funzionalità agli account con più luoghi."
    },
    "importedMessage": "Importazione di {productName} riuscita! Vai alla Libreria di modelli e trovalo nella scheda {productName}.",
    "permissionErrorMsg": "Questa opzione è disponibile solo nei piani superiori. Aggiorna ora per sbloccarla.",
    "errors": {
      "sourceDeleted": "Errore: il modello di origine è stato eliminato. Non è più disponibile. Controlla lo stato del modello o contatta la fonte per ricevere assistenza.",
      "sourceDraft": "Errore: il modello di origine è stato spostato in Bozza. Controlla lo stato del modello o contatta la fonte per ricevere assistenza.",
      "linkedDeleted": "Errore: il modello di origine, collegato al modello condiviso, è stato eliminato. Controlla lo stato del modello o contatta la fonte per ricevere assistenza.",
      "fetchError": "Sembra che si sia verificato un errore durante l'acquisizione dei dettagli di {productName}. Controlla l'URL o riprova!",
      "sameAgency": "Non è possibile condividere il modello all'interno della stessa agenzia"
    }
  },
  "triggers": {
    "addContactTagRequiresTag": "L'azione Aggiungi etichetta contatto richiede un'etichetta.",
    "addNotesRequiresData": "L'azione Aggiungi note richiede dati delle note.",
    "addTaskRequiresFields": "L'azione Aggiungi attività richiede un titolo e un giorno di scadenza.",
    "addToCampaignRequiresCampaign": "L'azione Aggiungi alla campagna richiede una campagna.",
    "addToCustomAudienceRequires": "L'azione Aggiungi al pubblico personalizzato richiede un account pubblicitario e un pubblico personalizzato.",
    "addTrigger": "Aggiungi trigger",
    "anyAction": "Qualsiasi azione",
    "anyCondition": "Qualsiasi condizione",
    "brokenCustomVariables": "Alcuni campi contengono variabili personalizzate errate, correggile prima di salvare.",
    "conditionCannotBeEmpty": "La condizione \"{condition}\" non può essere vuota",
    "confirmDeleteTrigger": "Vuoi davvero eliminare questo trigger?",
    "customDateFieldRequired": "Il filtro Campo data personalizzata è obbligatorio per il trigger Promemoria data personalizzata",
    "detailPage": {
      "chooseTriggerPlaceholder": "Seleziona un trigger",
      "lastUpdate": "Ultimo aggiornamento:",
      "loopIdentifiedWarning": "Questo trigger è stato bloccato in stato di bozza perché sta causando un ciclo. Per attivare questo trigger, contatta l'assistenza.",
      "ruleNotActiveWarning": "Questa regola non verrà eseguita finché non la attivi.",
      "triggerCreation": "Creazione del trigger:",
      "triggerDeletedPrompt": "Questo trigger è stato eliminato! Vuoi ripristinarlo?",
      "triggerRunDailyTooltip": "Esecuzione del trigger alle 8:00 tutti i giorni",
      "whatTriggersRule": "Cosa dovrebbe attivare questa regola?",
      "whichEventTriggersAutomation": "Quale evento dovrebbe attivare questa automazione?"
    },
    "dndContactRequiresState": "L'azione DND contatto richiede uno stato DND da impostare.",
    "emptyConditionNotAllowed": "Non sono ammesse condizioni vuote.",
    "emptyFieldNotAllowed": "Il campo vuoto non è consentito.",
    "executeWebhookRequiresUrl": "L'azione Esegui webhook richiede un URL webhook.",
    "fieldCannotBeEmpty": "{field} non può essere vuoto",
    "fillRequiredFields": "Compila tutti i campi obbligatori nelle azioni.",
    "googleAdwordsRequiresConversion": "L'azione Aggiungi a Google Ads richiede una conversione.",
    "googleAnalyticsRequiresFields": "L'azione Aggiungi a Google Analytics richiede un ID di tracciamento, un tipo di azione e una categoria di azione",
    "membershipGrantOfferRequiresOffer": "L'azione Concedi offerta di iscrizione richiede un'offerta.",
    "membershipRemoveOfferRequiresOffer": "L'azione Rimuovi offerta di iscrizione richiede un'offerta.",
    "newBasicRule": "Nuova regola semplice",
    "opportunitiesRequirePipeline": "Le azioni di opportunità richiedono di selezionare una sequenza.",
    "opportunityLoopWarning": "Questo trigger causerà un ciclo di creazione di opportunità. Rimuovi l'opzione Consenti duplicati delle opportunità o cambia la fase a cui fai riferimento.",
    "removeContactTagRequiresTag": "L'azione Rimuovi etichetta contatto richiede un'etichetta.",
    "removeFromCampaignRequiresCampaign": "L'azione Rimuovi dalla campagna richiede una campagna.",
    "removeFromCustomAudienceRequires": "L'azione Rimuovi dal pubblico personalizzato richiede un account pubblicitario e un pubblico personalizzato.",
    "rulesBasedOn": "regole basate su",
    "selectUserForNotification": "Seleziona l'utente per inviare la notifica.",
    "sendEmailRequiresFields": "L'azione Invia email richiede un'email mittente, un'email destinatario, un oggetto e un messaggio.",
    "sendNotificationRequiresFields": "L'azione Invia notifica richiede un titolo, un corpo e un tipo di utente per inviare la notifica.",
    "sendSmsRequiresFields": "L'azione Invia SMS richiede un numero e un messaggio.",
    "stripeMinAmountUSD": "L'importo deve essere maggiore o uguale a 50 centesimi USD.",
    "stripeRequiresFields": "L'azione Addebito una tantum Stripe richiede un ID cliente, un importo e una valuta",
    "thatWillFire": "che verrà attivato",
    "triggerCannotBeEmpty": "Il trigger non può essere vuoto",
    "updateContactFieldRequires": "Per l'azione Aggiorna campo di contatto ci dovrebbe essere almeno 1 campo impostato."
  },
  "workflow": {
    "resellPaywall": {
      "buttonText": "Paga ${amount} e abbonati",
      "commitment": "Nessun impegno, puoi annullare in qualsiasi momento",
      "features": {
        "billedOnUsage": "Fatturazione in base all'utilizzo dopo il superamento del limite",
        "externalAI": "Esclude le azioni del modello AI esterno, che saranno fatturate separatamente",
        "leadingPricing": "I migliori prezzi del settore!",
        "monthlyPurchase": "Valido per un Acquista al mese",
        "premiumActions": "Si applica ai trigger e alle azioni premium"
      },
      "planDetails": "Dettagli del piano",
      "subscribeAndSave": "Iscriviti e risparmia subito!",
      "title": "${amount} per {executions} esecuzioni al mese"
    }
  },
  "appointmentWidget": {
    "movedMessage": "Questa impostazione è stata spostata nella pagina dei calendari.",
    "toNavigate": "qui per navigare. Questa pagina sarà presto rimossa."
  },
  "attribution": {
    "description": "La prima interazione è semplicemente il primo punto di contatto che un utente ha stabilito. Quindi, se qualcuno ti scoprisse per la prima volta tramite una pubblicità a pagamento (PPC), quel canale riceverebbe il merito per la conversione. D'altra parte, l'ultima interazione sarebbe l'ultimo canale.",
    "firstInteraction": "Prima interazione",
    "lastInteraction": "Ultima interazione",
    "title": "Attribuzione"
  },
  "campaign": {
    "addEvent": "Aggiungi evento",
    "a2p": {
      "address": {
        "chooseState": "Scegli lo stato...",
        "city": "Città*",
        "postalCode": "Codice postale*",
        "streetAddress": "Indirizzo*",
        "streetAddressHelper": "Deve essere un indirizzo valido collegato alla tua azienda.",
        "title": "Indirizzo aziendale"
      },
      "addressError": {
        "title": "Invio dell'indirizzo non riuscito"
      },
      "authorizedRep": {
        "jobPosition": "Posizione lavorativa*",
        "jobTitle": "Titolo professionale*",
        "title": "Informazioni del rappresentante autorizzato"
      },
      "brandDetails": {
        "solePropBrand": {
          "heading": "Brand di ditta individuale",
          "point1": "È consentito un solo numero di telefono",
          "point2": "EIN/SSN/DUNS non obbligatorio"
        },
        "solePropCampaign": {
          "heading": "Campagna di ditta individuale",
          "point1": "È consentito collegare solo 1 numero a una campagna di una ditta individuale",
          "point2": "Una volta approvato, il tuo numero predefinito verrà collegato automaticamente",
          "infoText": "Può anche aggiornare il numero dopo l'approvazione",
          "warningText": "È consentito collegare solo 1 numero a una campagna di una ditta individuale. Una volta approvato, il tuo numero predefinito verrà collegato automaticamente; dopo l'approvazione potrai anche aggiornare il numero."
        },
        "solePropSubtitle": "Dettagli di campagna e brand di ditta individuale",
        "standardBrand": {
          "heading": "4,41 $ - Una tantum",
          "point1": "EIN/SSN/DUNS obbligatorio",
          "point2": "Sono consentiti più numeri di telefono"
        },
        "standardCampaign": {
          "heading": "16,54 $ - Una tantum",
          "point1": "È consentito collegare più di un numero a una campagna standard",
          "point2": "EIN/SSN/DUNS obbligatorio",
          "infoText": "Si applicherà una commissione aggiuntiva di fino a 12 $ al mese in conformità con il regolamento di TCR."
        },
        "standardSubtitle": "Dettagli di campagna e brand standard",
        "title": "Dettagli del brand e della campagna"
      },
      "businessInfo": {
        "soleProp": {
          "contactInfo": "Informazioni di contatto",
          "contactInfoSubtitle": "Può trattarsi di una qualsiasi persona in grado di rispondere alle domande su questo brand, se necessario. Tieni presente che non è possibile riutilizzare le informazioni di contatto per più brand. Ogni brand che crei deve avere informazioni di contatto univoche.",
          "emailHelper": "Non usare la stessa email per più di 5 brand.",
          "phoneNumberHelper": "Non usare lo stesso numero di telefono per più di 5 brand.",
          "profileName": "Il nome dell'azienda o il tuo nome e cognome*",
          "profileNameHelper": "Usa il nome legale dell'organizzazione che invia i messaggi, oppure il tuo nome se questo brand non è per un'organizzazione.",
          "nextLoading": "Successivo...",
          "invalidPhoneNumber": "Numero di telefono non valido",
          "phoneNumberWithCountryCode": "Numero di telefono (con prefisso internazionale)*",
          "phoneNumberRequired": "Il numero di telefono è obbligatorio.",
          "emailRequired": "L'email è obbligatoria.",
          "profileNameRequired": "Il nome del profilo è obbligatorio."
        },
        "standard": {
          "businessType": "Tipo di attività*",
          "legalBusinessName": "Ragione sociale*",
          "legalBusinessNameHelper": "Inserisci il nome esatto dell'azienda, come registrato presso il Governo e indicato nei tuoi documenti fiscali (CP 575). Ad esempio, Leadconnector LLC anziché Leadconnector.",
          "regionsOfOperations": "Aree geografiche in cui opera l'azienda*",
          "registrationNumber": "Numero di registrazione dell'attività*",
          "registrationNumberHelper": "Il numero usato per identificare la tua azienda. Nel caso dell'EIN statunitense, deve essere un numero di 9 cifre, ad esempio 12-3456789.",
          "registrationType": "Tipo di ID di registrazione dell'attività*",
          "website": "Sito web aziendale*"
        }
      },
      "businessProfileRegistration": {
        "stepProgress": "Passaggio {currentStep} di {businessInfoSteps}"
      },
      "businessProfileSuccess": {
        "message": "Il tuo profilo aziendale è stato inviato correttamente.",
        "startA2P": "Inizia la registrazione A2P",
        "title": "Profilo aziendale inviato correttamente",
        "tooltips": {
          "agency": "Gli utenti dell'agenzia possono avviare la registrazione A2P",
          "location": "Gli utenti della sede possono avviare la registrazione A2P"
        }
      },
      "campaign": {
        "endUserConsent": {
          "closeExample": "Chiudi esempio",
          "optInKeywords": "Parole chiave per l'iscrizione*",
          "optInKeywordsHelper": "Lunghezza massima: 255 caratteri.",
          "optInKeywordsPlaceholder": "Parole chiave separate tramite virgola; ad esempio: ISCRIVITI, INIZIA.",
          "optInMessage": "Messaggio per l'iscrizione*",
          "optInMessageInfo": "Deve contenere il nome dell'azienda e la parola chiave per annullare l'iscrizione",
          "optInMessagePlaceholder": "Esempio: Hai abilitato la ricezione di SMS di notifica e promozionali da parte di nome_azienda. Se in futuro desideri annullare l'iscrizione, rispondi STOP.",
          "placeholder": "Esempio: gli utenti finali si iscrivono visitando - https://www.lamiaazienda.com/prenotazione e inserendo i loro dati. Gli utenti selezionano una casella per ricevere notifiche e messaggi promozionali da noi per fornire il loro consenso. Inoltre, gli utenti finali possono anche inviare un SMS con scritto START al numero +1 (213) 725-2867.",
          "question": "Come fanno gli utenti finali a dare il consenso a ricevere messaggi?*",
          "seeExample": "Vedi esempio"
        },
        "messageDetails": {
          "embeddedLink": "Il messaggio includerà un link incorporato",
          "phoneNumbers": "I messaggi includeranno numeri di telefono",
          "sampleMessage1Placeholder": "Esempio: Ciao, Mario! Sono Paola di nome_azienda. Il nostro appuntamento del 20 luglio alle ore 11:00 è confermato. Contatta il numero +1(213) 725-2867 nel caso debba riprogrammarlo. Rispondi STOP per annullare l'iscrizione.",
          "sampleMessage2Placeholder": "Esempio: Ciao, Luca! Sono Paola di nome_azienda. Vedo che non sei riuscito a presentarti al nostro appuntamento. Vorresti riprogrammarlo? - https://www.lamiaazienda.com/prenotazione. Rispondi STOP per annullare l'iscrizione.",
          "sampleMessageInfo": "Devono includere il nome del lead, il tuo nome, il nome dell'azienda e la dicitura per l'annullamento dell'iscrizione",
          "subtitle": "Aggiungi messaggi di esempio"
        },
        "useCaseDetails": {
          "explainInDetail": "Fornisci una spiegazione dettagliata",
          "pickUseCase": "Seleziona il caso d'uso della campagna",
          "solePropLabel": "Ditta individuale",
          "subtitle": "Inserisci i dettagli e la descrizione della campagna",
          "useCase": "Caso d'uso della campagna*",
          "useCaseDescription": "Descrizione del caso d'uso*",
          "useCaseDescriptionPlaceholder": "Esempio: questa campagna invia informazioni sugli appuntamenti - messaggi di conferma e promemoria ai nostri clienti dopo che hanno prenotato un appuntamento con noi sul nostro sito web e hanno effettuato l'iscrizione per ricevere SMS promozionali e di notifica da parte nostra."
        }
      },
      "einModal": {
        "disableNoEINText": "Solo le aziende con indirizzo valido negli Stati Uniti o in Canada possono registrare un brand A2P senza un ID fiscale.",
        "hasEIN": "Sì, l'azienda che sto registrando ha un ID fiscale (ad esempio, EIN, CCN, ecc.).",
        "infoText": "Puoi trovare il tuo EIN statunitense sul modulo CP 575.",
        "noEIN": "No, l'azienda che sto registrando non ha un ID fiscale (ad esempio, EIN, CCN, ecc.).",
        "question": "L'azienda che stai registrando possiede un ID fiscale (ad esempio, EIN, CCN, ecc.)?*",
        "title": "Definisci le esigenze del brand A2P"
      },
      "exampleModal": {
        "examples": "Esempi"
      },
      "otpError": {
        "message": "Si è verificato un problema durante l'invio dell'OTP.",
        "title": "Rinvio dell'OTP non riuscito"
      },
      "otpSuccess": {
        "title": "Il tuo OTP è stato inviato con successo."
      },
      "validation": {
        "cityRequired": "La città è obbligatoria.",
        "countryRequired": "Il Paese è obbligatorio.",
        "invalidMobileNumber": "Numero di cellulare non valido",
        "postalCodeRequired": "Il codice postale / CAP è obbligatorio.",
        "stateRequired": "Lo stato è obbligatorio.",
        "streetAddressRequired": "L'indirizzo è obbligatorio."
      }
    },
    "affiliates": {
      "affiliateAboutIframe": "affiliate-about-iframe",
      "agencyOwner": "Titolare dell'agenzia",
      "agencyOwnerAndAdmins": "Titolare e amministratori dell'agenzia",
      "contactAgencyOwner": "Se hai bisogno di assistenza, contatta il tuo",
      "firstPromoterAccessMessage": "Questo report di FirstPromoter è accessibile solo",
      "firstPromoterIframe": "firstpromoter-iframe",
      "noPartnerFound": "Non è stato possibile trovare un partner corrispondente ai tuoi filtri. Fai clic",
      "paymentDetailsAccessMessage": "Questa sezione sui dati di pagamento è accessibile e modificabile solo da",
      "toApplyPartner": "per presentare la domanda per diventare partner."
    },
    "common": {
      "actions": {
        "googleDrive": "Google Drive"
      },
      "labels": {
        "doc": "Doc"
      },
      "loading": "Caricamento",
      "legalBusinessNameHelper": "Inserisci il nome esatto dell'azienda, come registrato presso il Governo e indicato nei tuoi documenti fiscali (CP 575). Ad esempio, Leadconnector LLC anziché Leadconnector."
    },
    "desktop": {
      "highlevel": {
        "logoAltText": "HighLevel Logo",
        "launchingDescription": "Fai clic su <span class='font-semibold'>Apri HighLevel</span> per aprire l'app desktop.<br>Non funziona? Puoi anche <a href=\"/\" class='!text-blue-700 hover:underline'>utilizzare HighLevel nel tuo browser</a>",
        "launchingTitle": "Avvio di HighLevel Desktop",
        "launchButtonText": "Apri HighLevel"
      },
      "leadconnector": {
        "logoAltText": "LeadConnector Logo",
        "launchingDescription": "Fai clic su <span class='font-semibold'>Apri LeadConnector</span> per aprire l'app desktop.<br>Non funziona? Puoi anche <a href=\"/\" class='!text-blue-700 hover:underline'>utilizzare LeadConnector nel tuo browser</a>",
        "launchingTitle": "Avvio di LeadConnector Desktop",
        "launchButtonText": "Apri LeadConnector"
      }
    },
    "email": {
      "actionCard": {
        "chooseAction": "Scegli un'azione",
        "destination": "Destinazione",
        "removeFromAllCampaigns": "Questa azione rimuoverà i potenziali clienti da tutte le campagne tranne quella attuale",
        "triggerLinks": "Link di attivazione"
      },
      "importTemplate": {
        "errorImporting": "Errore durante l'importazione del modello!",
        "importTemplate": "Importa modello",
        "importing": "Importazione",
        "title": "Importa il modello {entityName}",
        "unnamedEntity": "Copia {entityName} senza nome"
      },
      "lcEmail": {
        "migrationModal": {
          "below": "sotto",
          "confirmByTyping": "Si prega di confermare digitando",
          "confirmWord": "CONFIRM",
          "existingNotMoved": "Se il tuo cliente ha già configurato Mailgun o SMTP, non verrà trasferito",
          "notNow": "Non adesso",
          "pricingInfo": "LC Email è più economico di Mailgun e costerà circa 0,68 $ per 1000 email",
          "setAsDefault": "LC Email sarà impostato come provider predefinito per la tua agenzia e per i clienti che non hanno già Mailgun o SMTP",
          "thisWill": "Questo farà:",
          "title": "Stai passando a Lead Connector Email",
          "useLcEmail": "Usa LC Email"
        }
      },
      "newPostModal": {
        "dragDropMedia": "Trascina o rilascia qui i contenuti multimediali",
        "editPost": "Modifica post",
        "enterText": "Inserisci qui il testo",
        "exampleComment": "Fantastico! Non vedo l'ora!",
        "exampleName": "Test Tech",
        "hashtag1": "#hashtag",
        "hashtag2": "#awesome",
        "hashtag3": "#cool",
        "imagePlaceholder": "img(02).png",
        "needReview": "Hai bisogno di controllare?",
        "network": "Rete",
        "photo": "foto",
        "previewPost": "Anteprima del post",
        "selectNetwork": "Seleziona il social network",
        "sizeExample": "245kb",
        "textExample": "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
        "urlExample": "https://searchengineland.com/google-announces-new-features-for-retail-advertisers-at-smx-advanced-300001"
      },
      "numberPool": {
        "confirmation": {
          "createdMultiple": "Hai creato un pool di {count} numeri per monitorare i visitatori sul tuo sito web. <br />Le tue chiamate saranno inoltrate a",
          "createdSingle": "Hai creato {count} numero per monitorare i visitatori del tuo sito web. <br />Le tue chiamate saranno inoltrate a",
          "percentComplete": "100% completo"
        },
        "create": {
          "correctErrors": "Correggi quegli errori!",
          "forwardHelp": "Dicci quale telefono dovrebbe suonare quando il cliente chiama il tuo numero di tracciamento. In genere, si tratta del tuo numero di telefono aziendale principale. Esempio: 404-555-1212",
          "heading": "Pool di numeri e inoltro di chiamata",
          "nameHelp": "Il \"{name}\" è il modo in cui faremo riferimento a questo numero di tracciamento nel tuo account. Seleziona un nome breve e facile da ricordare.",
          "newTrackingNumbers": "nuovi numeri di tracciamento.",
          "nextTracking": "Passo successivo: opzioni di tracciamento",
          "percentComplete": "50% completo",
          "pleaseConfirm": "Conferma:",
          "poolSize": "Dimensione del pool",
          "poolSizeError": "Inserisci una dimensione del pool compresa tra 4 e 30 numeri di tracciamento.",
          "poolSizeHelp": "La dimensione del tuo pool di numeri determina quanti visitatori simultanei possiamo tracciare sul tuo sito web in un dato momento. La dimensione del tuo pool dovrebbe essere pari a un quarto del traffico orario di punta riportato da Google Analytics, con un minimo di 4 numeri.",
          "swappingHelp": "Dicci quale numero di telefono dovremmo scambiare sul sito web. Esempio: 404-555-1212",
          "swappingNumber": "Numero di scambio",
          "validationError": "Si è verificato un errore durante la convalida del modulo"
        },
        "features": {
          "activateNumber": "Attiva numero",
          "address": "Indirizzo {type}",
          "addressHelp": "Il numero di acquisto per alcuni paesi richiede l'indirizzo. Se hai bisogno di aiuto, contatta l'assistenza per sapere come aggiungere l'indirizzo.",
          "heading": "Funzionalità dei numeri",
          "leaveBlank": "Lascia il campo vuoto per non aggiungere nessun messaggio",
          "recordingDescription": "Attiva la registrazione delle chiamate e riproduci un breve messaggio per il chiamante.",
          "recordingHelp": "Alcune giurisdizioni richiedono l'approvazione di entrambe le parti per qualsiasi conversazione registrata. Per aiutare nel rispetto di queste leggi, puoi abilitare un saluto per informare il chiamante della possibilità che la chiamata venga registrata.",
          "whisperDescription": "Un breve messaggio che viene riprodotto prima della chiamata. Il chiamante non sente questo messaggio."
        },
        "tracking": {
          "heading": "Opzioni di tracciamento",
          "nextCreatePool": "Passo successivo: crea pool",
          "percentComplete": "34% completo",
          "searchLower": "ricerca"
        },
        "whatToTrack": {
          "heading": "Cosa vuoi monitorare sul tuo sito web?",
          "trackCampaign": "Monitora una campagna di marketing",
          "trackCampaignDescription": "Crea un numero di telefono che tenga traccia di tutti i chiamanti a una singola campagna di marketing.",
          "trackVisitor": "Traccia l'attività dei visitatori",
          "trackVisitorDescription": "Crea più numeri che correlano le chiamate ai visitatori del sito web, le parole chiave PPC e altro ancora."
        }
      }
    },
    "loader": {
      "clickHereToRefresh": "fai clic qui per aggiornare la pagina.",
      "issuesLoadingApp": "Se hai problemi a caricare l'app",
      "loadingFreshData": "Caricamento dei nuovi dati in corso...",
      "loadingNewSubAccountData": "Caricamento dei dati del nuovo account secondario..."
    },
    "login": {
      "bySigningInYouAgree": "Accedendo, accetti i nostri <a class='font-semibold text-curious-blue-500 hover:text-curious-blue-800' href='{termsConditionsURL}' target='_blank'>Termini e condizioni</a>",
      "newPasswordSent": "Una nuova password è stata inviata alla tua email."
    },
    "regulatoryBundle": {
      "a2p": {
        "activityHistory": {
          "by": "Di:"
        },
        "affiliates": {
          "partnerBadgeAlt": "Distintivo del partner"
        },
        "checkout": {
          "cardInformation": "Informazioni sulla carta",
          "cardNumberInvalid": "Il numero della tua carta non è valido.",
          "commitment": "impegno",
          "consentOneTime": "Confermando, autorizzi LeadConnector ad addebitare sulla tua carta questo pagamento.",
          "consentSubscription": "Confermando l'abbonamento, autorizzi LeadConnector ad addebitare sulla tua carta questo pagamento e i pagamenti futuri per questo abbonamento",
          "defaultIntervalCount": "1",
          "endingIn": "termina con",
          "errorImageAlt": "Illustrazione di errore",
          "intervalSuffix": "(s)",
          "month": "Mese",
          "pay": "Paga",
          "payWithCard": "paga con carta",
          "paymentProcessing": "Il pagamento è in fase di elaborazione. Non ricaricare la pagina o premere il pulsante Indietro",
          "proceedWithExistingCard": "Procedi con la carta esistente",
          "proceedWithNewCard": "Procedi con una nuova carta",
          "prorationDetails": "Ti verranno addebitati {days} giorni adesso per il periodo fino al {billingEnd}, e a partire dal {billingDate} inizierai a pagare l'importo completo di ${amount} al mese.",
          "prorationMessage": "I primi addebiti sono calcolati in proporzione e la fatturazione regolare inizierà dal {billingDate}",
          "purchase": "acquista",
          "subscribe": "Abbonati",
          "subscribeTo": "Abbonati a",
          "updateCardDetails": "Aggiorna le informazioni della carta",
          "zip": "CAP"
        },
        "options": {
          "jobPosition": {
            "gm": "GM",
            "vp": "VP"
          }
        },
        "registration": {
          "stepProgress": "Passaggio {currentStep} di 8",
          "successDescription": "Il tuo brand A2P e la tua campagna sono stati inviati.",
          "successMessage": "Nota: riceverai un messaggio OTP al numero di cellulare fornito per la verifica da parte di TCR. Rispondi \"Yes\" entro 24 ore dalla ricezione dell'SMS.",
          "successWaitDays": "7 giorni",
          "successWaitPrefix": "Potrebbe richiedere fino a ",
          "successWaitSuffix": " per l'approvazione del tuo brand e ulteriori 4-5 settimane per l'approvazione della campagna."
        },
        "reminder": {
          "noReplyYet": "Ancora nessuna risposta",
          "patientConfirmed": "Paziente confermato"
        },
        "sendGrid": {
          "apiKeyRequired": "API Key obbligatoria"
        },
        "update": {
          "brandNameHelper": "Usa il nome legale dell'organizzazione che invia i messaggi.",
          "businessVerticals": "Verticali di attività*",
          "resendOTP": "Rinvia OTP",
          "retryOTPTitle": "Riprova la verifica OTP"
        }
      },
      "addCustomEmailModal": {
        "title": "Aggiungi email personalizzata"
      },
      "addEditSMTPServiceModal": {
        "addProvider": "Aggiungi provider",
        "clickHereForInfo": "Fai clic qui per maggiori informazioni.",
        "clickHereToFindOut": "Fai clic qui per saperne di più.",
        "createProviderError": "Si è verificato un errore durante la creazione del provider!",
        "gmailLimitations": "Gmail presenta alcune limitazioni.",
        "needHelp": "Hai bisogno di aiuto per trovare il server SMTP e il numero di porta?",
        "port25NotSupported": "La porta 25 non è supportata! Utilizza invece la porta 2525",
        "providerExists": "Esiste già un provider con questo indirizzo email/nome utente.",
        "providerName": "Nome del provider",
        "selectProvider": "Seleziona provider",
        "smtpPortNumber": "Numero di porta SMTP",
        "smtpProvider": "Provider SMTP",
        "smtpServer": "Server SMTP",
        "username": "Nome utente",
        "usernameOrEmailRequired": "È richiesto il nome utente o l'email.",
        "verifySmtpAccount": "Verifica account SMTP"
      },
      "addTagModal": {
        "addTag": "Aggiungi etichetta",
        "editTag": "Modifica etichetta",
        "tagAlreadyExists": "L'etichetta {tag} esiste già"
      },
      "affiliates": {
        "firstPromoterAccessMessage": "Questo report di FirstPromoter è accessibile solo dal <strong>titolare e gli amministratori dell'agenzia</strong>. Se hai bisogno di assistenza, contatta il tuo <strong>titolare dell'agenzia ({agencyOwnerEmail})</strong>.",
        "firstPromoterIframeTitle": "Dashboard di FirstPromoter",
        "noPartnersFound": "Non è stato possibile trovare un partner corrispondente ai tuoi filtri. Fai clic <a href='javascript:void(0);'>qui</a> per presentare la domanda per diventare partner.",
        "paymentDetailsAccessMessage": "Questa sezione sui dati di pagamento è accessibile e modificabile solo dal <strong>titolare dell'agenzia</strong>. Se hai bisogno di assistenza, contatta il tuo <strong>titolare dell'agenzia ({agencyOwnerEmail})</strong>."
      },
      "appointmentDetails": {
        "title": "Dettagli dell'appuntamento"
      },
      "attachSnapshotToggle": {
        "loadSnapshot": "Carica snapshot:",
        "loadSnapshotWarning": "Vuoi caricare lo snapshot associato a questo piano? <br /> <strong class='text-danger'>I dati esistenti possono andare persi</strong>"
      },
      "auth": {
        "changePassword": {
          "changeButton": "Modifica password",
          "confirmPassword": "Conferma la nuova password",
          "expired": "Il link per la reimpostazione della password è scaduto.",
          "regenerateLink": "Rigenera link",
          "success": "Password modificata correttamente",
          "title": "Imposta una nuova password",
          "passwordMismatch": "Le password non coincidono"
        },
        "forgotPassword": {
          "contactAgency": "contatta la tua agenzia.",
          "contactSupport": "contatta l'assistenza HighLevel (disponibile 24 ore su 24, 7 giorni su 7) chiamando il numero",
          "supportMessage": "Se non hai accesso a quella casella email,",
          "successMessage": "È stato inviato un link per il ripristino della password al tuo indirizzo email.",
          "rateLimitError": "Troppe richieste di ripristino della password. Riprova più tardi."
        },
        "login": {
          "inactivityMsg": "Abbiamo notato la tua inattività per un certo periodo di tempo, quindi abbiamo effettuato la disconnessione per garantire la tua sicurezza.",
          "loginButton": "Accedi",
          "resetPasswordMsg": "Un link per la reimpostazione della password è stato inviato alla tua email.",
          "signInWithGoogle": "Accedi con Google",
          "contactHighLevelSupport": " contatta l'assistenza HighLevel (disponibile 24 ore su 24, 7 giorni su 7) chiamando il numero"
        },
        "logout": {
          "loggingOut": "Disconnessione in corso..."
        },
        "otp": {
          "enterBackupCode": "Inserisci il tuo codice di backup",
          "resend": "Invia di nuovo",
          "resendIn": "Invia di nuovo tra",
          "sendToPhone": "Invia il codice al telefono",
          "sending": "Invio",
          "useAuthenticator": "Usa l'app Authenticator",
          "useBackupCode": "Usa codice di backup",
          "verifyButton": "Verifica con codice di backup"
        },
        "sso": {
          "agreeTerms": "Accedendo, accetti i nostri <a class='font-semibold text-curious-blue-500 hover:text-curious-blue-800' href='{termsConditionsURL}' target='_blank'>Termini e condizioni</a>",
          "and": "e",
          "loginDifferentMethod": "Accedi con un metodo diverso",
          "loginSuccessRedirecting": "Accesso riuscito, reindirizzamento in corso...",
          "processing": "Elaborazione della tua richiesta in corso...",
          "redirecting": "Reindirizzamento in corso...",
          "redirectingToDashboard": "Reindirizzamento alla dashboard in corso...",
          "signedIn": "Accesso effettuato",
          "signingIn": "Accesso in corso...",
          "testFailedRedirecting": "Test non riuscito, reindirizzamento in corso...",
          "testSuccessRedirecting": "Test riuscito, reindirizzamento in corso..."
        }
      },
      "businessDetailModal": {
        "businessAddress": "Indirizzo aziendale: {address}",
        "businessDetailsText": "I seguenti dettagli aziendali saranno inviati a Google Local Services Ads per l'integrazione con Prenota con Google. Verifica e conferma o {link} per aggiornare il tuo profilo aziendale.",
        "businessInfoRequired": "Le informazioni aziendali sopra elencate sono richieste per l'integrazione, {link} per aggiornare i dettagli aziendali mancanti/errati.",
        "businessName": "Nome dell'azienda: {name}",
        "businessNiche": "Nicchia aziendale: {niche}",
        "city": "Città: {city}",
        "confirmDetails": "Confermo che i dettagli sopra menzionati sono corretti",
        "country": "Paese: {country}",
        "mustConfirmDetails": "È necessario confermare i dettagli sopra menzionati.",
        "phoneNumber": "Numero di telefono: {phone}",
        "state": "Stato: {state}",
        "zipCode": "Codice postale: {zipCode}"
      },
      "calendarHourRow": {
        "addHours": "Aggiungi Ore",
        "applyAll": "Applica tutto"
      },
      "campaign": {
        "callerIdVerificationModal": {
          "answerCall": "Rispondi alla chiamata e inserisci questo codice di verifica:",
          "leadConnectorCalling": "Lead Connector sta chiamando...",
          "title": "Aggiungi un ID chiamante tramite voce",
          "waitingForVerification": "In attesa della verifica..."
        },
        "callerIdVerificationStatus": {
          "failed": "Verifica dell'ID chiamante non riuscita. Riprova.",
          "success": "<strong>{contact}</strong> verificato correttamente"
        },
        "choosePhoneNumberModal": {
          "addExistingNumbers": "Aggiungi numero/i esistente/i",
          "areaCode": "Prefisso telefonico:",
          "checkAvailability": "Controlla la disponibilità",
          "checkingAvailability": "Verifica della disponibilità del numero.",
          "chooseAreaCode": "Seleziona un prefisso",
          "choosePhoneNumbers": "Scegli numero/i di telefono",
          "goBack": "Torna indietro",
          "localNumbers": "{type} locale/i",
          "nextNumberFeatures": "Successivo: caratteristiche dei numeri",
          "noExistingNumbers": "Nessun numero esistente da aggiungere",
          "noNumbersAvailable": "Nessun numero disponibile",
          "notEnoughNumbers": "Non ci sono abbastanza numeri disponibili",
          "numbersAvailable": "Numeri disponibili",
          "numbersDifferentArea": "Numeri con un prefisso diverso",
          "numbersLocalTo": "Numeri locali - <strong>{number}</strong>",
          "problemChecking": "Si è verificato un problema nel verificare la disponibilità del numero; controlla la connessione di rete o contatta l'assistenza.",
          "somethingWentWrong": "Qualcosa è andato storto. Verifica le credenziali del tuo account Twilio e contatta l'assistenza se il problema persiste.",
          "tollFreeNumbers": "Numeri verdi (supplemento di 2,00 $ per numero al mese)",
          "percentageComplete": "67% completo"
        },
        "deleteNumberPoolModal": {
          "confirmDelete": "Comprendo le conseguenze, elimina il pool",
          "confirmText": "Digita <b>{name}</b> per confermare",
          "title": "Elimina pool di numeri - <strong>{name}</strong>",
          "warning": "Questa azione non può essere annullata. Eliminerà permanentemente il/i numero/i dal tuo account Twilio e il pool di numeri dal nostro database. Se stai eliminando il pool di numeri perché hai un problema, contatta il nostro team di assistenza."
        },
        "editNumberFormatModal": {
          "description": "Puoi aggiornare la formattazione dei numeri di scambio e dei numeri pool in base alle tue esigenze. Assicurati che i numeri di scambio siano visualizzati sul sito come formattati.",
          "title": "Aggiorna formattazione numeri - <strong>{name}</strong>"
        },
        "editNumberPoolModal": {
          "addEditGroupId": "Aggiungi/Modifica ID gruppo",
          "callConnectTooltip": "Questa funzione richiede che il destinatario prema un tasto per connettere la chiamata, il che si traduce in una maggiore precisione nella segnalazione delle chiamate.",
          "createGroupIdDescription": "Crea/Aggiungi un ID gruppo univoco per utilizzare più pool di numeri con un singolo frammento javascript.",
          "enableCallConnect": "Abilita la funzione di connessione chiamata",
          "groupId": "ID gruppo",
          "outboundCallTimeout": "Timeout chiamata in uscita",
          "passCallerID": "Passa il numero chiamato come ID chiamante",
          "passCallerIDTooltip": "Per impostazione predefinita, il sistema passa il numero del chiamante, ma se desideri che l'ID chiamante sia invece il numero composto dal chiamante, abilita questa funzionalità",
          "selectCallerID": "Seleziona ID chiamante",
          "timeDuration": "Durata in secondi",
          "titleNumber": "Numero - <strong>{number}</strong>",
          "updateWhisperWarning": "Aggiorna il messaggio per l'agente, perché questa funzione richiede che il destinatario prema un tasto per connettere la chiamata.",
          "useVerifiedNumber": "Utilizza il tuo numero verificato come ID chiamante per le chiamate in uscita",
          "useVerifiedNumberTooltip": "Applicabile solo ai numeri di telefono verificati. Puoi verificare un numero di telefono in Impostazioni > Numeri di telefono > Aggiungi ID chiamante verificato"
        },
        "emailOTPModal": {
          "confirmCode": "Conferma il codice",
          "resendCode": "Se non hai ricevuto il codice, clicca qui per richiederne l'invio",
          "unexpectedIssue": "Si è verificato un problema imprevisto"
        },
        "facebookFieldMapModal": {
          "customFieldInfo": "Informazioni sul campo personalizzato",
          "customFieldTooltip": "Suggerimento per il campo personalizzato: {options}",
          "field": "Campo {companyName}",
          "trackingParameters": "Parametri di tracciamento",
          "zipCode": "CAP"
        },
        "howToUseNumberPoolModal": {
          "addSwappingNumbers": "Aggiungi numeri di scambio",
          "addingSnippets": "Aggiunta di frammenti Javascript",
          "groupSnippet": "Snippet gruppo \"{id}\"",
          "normalSnippet": "Frammento normale",
          "noswapDescription": "Se non vuoi che scambiamo il numero in un determinato punto, aggiungi una classe \"noswap\".",
          "notReplacing": "Non sostituire in un luogo specifico",
          "requiredSteps": "Passaggi obbligatori",
          "snippetsDescription": "Copia il frammento qui sotto e aggiungilo appena sopra il tag di chiusura del corpo di ogni pagina in cui desideri sostituire i numeri.",
          "swappingDescription": "Usa i numeri qui sotto per abilitare lo scambio di numeri di telefono. Seleziona un formato locale, internazionale o entrambi."
        },
        "newPhoneNumberModal": {
          "areaCode": "Prefisso telefonico",
          "availableNumbers": "Numeri disponibili",
          "bundle": "Pacchetto",
          "chooseAddress": "Scegli l'indirizzo...",
          "chooseBundle": "Seleziona il pacchetto...",
          "createRegulatory": "Crea qui un pacchetto/indirizzo normativo.",
          "monthlyFee": "Costo mensile",
          "noNumbersFound": "Nessun numero trovato, prova con un altro prefisso.",
          "selectAddress": "Seleziona \"Indirizzo\" per acquistare un numero.",
          "selectBundle": "Seleziona \"Pacchetto\" per acquistare un numero.",
          "title": "Aggiungi numero di telefono",
          "upgradeAccount": "Aggiorna il tuo account Twilio, in quanto solo gli account con l'upgrade possono acquistare numeri di telefono ed effettuare telefonate",
          "cardAuthenticationFailed": "Autenticazione della carta non riuscita!"
        },
        "reserveWithGoogleIntegration": {
          "agreeTerms": "Devi accettare i termini e le condizioni sulla privacy.",
          "clickingProceed": "Se fai clic su Procedi, si aprirà la pagina di link LSA in una nuova scheda",
          "configureCalendar": "Configura almeno un calendario per procedere con l'integrazione Prenota con Google",
          "configureCalendarBtn": "Configura calendario",
          "linkOneAccount": "Assicurati di collegare un solo account. Contatta l'assistenza se non riesci a visualizzare la pagina nello screenshot qui sopra.",
          "readInstructions": "Ho letto le suddette istruzioni"
        },
        "updateTrackingModal": {
          "title": "Aggiorna l'opzione di monitoraggio"
        },
        "usageSummary": {
          "agencyOnlyVisible": "(è visibile solo agli amministratori dell'agenzia)",
          "updatedEvery24Hours": "(aggiornato ogni 24 ore)"
        },
        "userCalendarConfiguration": {
          "calendarNotSelected": "Calendario non selezionato per la sincronizzazione",
          "check": "Controlla {email}",
          "checkForConflicts": "Controlla se ci sono conflitti",
          "checkForConflictsTooltip": "Configura il/i calendario/i per controllare la presenza di eventuali conflitti ed evitare prenotazioni doppie.",
          "contactCreationAllowed": "Creazione di contatti consentita",
          "googleCalendar": "Logo di Google Calendar",
          "noGoogleAccounts": "Nessun account Google/Outlook è stato ancora aggiunto nelle impostazioni delle Integrazioni",
          "noGoogleAccountsTeamMember": "Nessun account Google/Outlook aggiunto per questo membro del team nel luogo attuale. Chiedi al membro del team di effettuare l'accesso tramite il suo account e di aggiungere il collegamento a Google dalle impostazioni delle integrazioni.",
          "outlookCalendar": "Calendario utente di Outlook",
          "primaryCalendarTooltip": "Configura il calendario in cui desideri aggiungere i nuovi eventi quando vengono programmati.",
          "runTriggerAllowed": "Esecuzione del trigger consentita"
        },
        "warningModal": {
          "contactAgency": "Contatta la tua agenzia per modificare le impostazioni delle email.",
          "title": "Avvertimento"
        }
      },
      "checkout": {
        "prioritySupport": {
          "features": {
            "faster247Chat": "Supporto via chat più veloce, 24 ore su 24, 7 giorni su 7",
            "faster247Ticket": "Supporto tramite richiesta di assistenza più veloce, 24 ore su 24, 7 giorni su 7"
          },
          "highlight": {
            "description": "Lo capiamo: hai bisogno di andare più veloce. Quando hai una domanda o un problema, vuoi una risposta il prima possibile! Con il passaggio al supporto prioritario, salti la fila e le tue richieste arrivano subito in cima.",
            "heading": "Tutto pronto per il trattamento VIP?"
          },
          "name": "Supporto prioritario",
          "success": {
            "description": "Il supporto prioritario è stato attivato sul tuo account. Non devi più fare la fila.",
            "heading": "Ora sei un cliente prioritario!"
          }
        }
      },
      "cloneFunnel": {
        "cloneButton": "Clona {entityName}",
        "cloning": "Clonazione in corso...",
        "cloningLimit": "La clonazione è limitata a 3 luoghi alla volta",
        "error": "Errore durante la clonazione del funnel!",
        "locationsLabel": "Seleziona luoghi",
        "nameLabel": "Nome per il {entityName}clonato",
        "namePlaceholder": "Inserisci il nome per il clone di {entityName}",
        "selectUpTo": "Seleziona fino a {maxSelectableLocations} luoghi",
        "title": "Clona {entityName}"
      },
      "cnam": {
        "learnMore": {
          "description": "Con CNAM, il nome della tua azienda è visualizzato nell'ID del chiamante, il che rende le tue chiamate immediatamente riconoscibili e aumenta la fiducia. Fai sapere ai tuoi clienti che sei tu a chiamare, ogni volta.",
          "title": "Fai in modo che le tue chiamate si distinguano!"
        },
        "registration": {
          "characterLimit": "{count}/15",
          "confirm": "Conferma e registrati",
          "description": "Rendi il nome della tua azienda visibile ai destinatari delle chiamate per guadagnarti la loro fiducia e i tassi di risposta alle chiamate.",
          "title": "Aumenta la fiducia nelle tue chiamate con CNAM",
          "warning": "La visualizzazione del nome dell'azienda non è garantita, specialmente sui cellulari."
        },
        "submitted": {
          "checkStatus": "Controlla lo stato CNAM",
          "description": "Il nome della tua azienda dovrebbe essere iniziare a essere visualizzato dai contatti pertinenti tra circa 3-5 giorni.",
          "subtitle": "La tua richiesta per CNAM è stata inviata.",
          "title": "Congratulazioni!"
        }
      },
      "confirmMerchantDeleteModal": {
        "confirmDelete": "Conferma eliminazione",
        "confirmation": "Conferma"
      },
      "createAddress": {
        "successTitle": "Indirizzo inviato correttamente",
        "underReview": "L'indirizzo inviato è in fase di revisione"
      },
      "createEndUser": {
        "dateFormat": "Il formato della data deve essere AAAA-MM-GG.",
        "phoneExample": " Esempio: +14155552671",
        "title": "Dettagli aziendali:"
      },
      "customValueModal": {
        "changingNameWarning": "La modifica del nome non inciderà sulla chiave del campo.",
        "editCustomValue": "Modifica valore personalizzato",
        "fieldKeyCreatedWarning": "La chiave del campo sarà creata secondo il nome e non potrà essere modificata successivamente.",
        "nameRequired": "Il campo del nome è obbligatorio",
        "nameValidation": "Il nome deve essere alfanumerico e contenere almeno un carattere",
        "valueRequired": "Il campo del valore è obbligatorio"
      },
      "details": {
        "addressName": "Nome dell'indirizzo",
        "addressTitle": "Dettagli dell'indirizzo",
        "bundleName": "Nome del pacchetto",
        "bundleTitle": "Dettagli del pacchetto normativo",
        "countryFlag": "Bandiera {country}",
        "id": "ID",
        "organisation": "Organizzazione",
        "rejectionReason": "Motivo del rifiuto",
        "status": {
          "approved": "Approvato",
          "notValidated": "Non convalidato",
          "rejected": "Rifiutato",
          "validated": "Convalidato"
        },
        "typeOfNumber": "Tipo di numero"
      },
      "drChronoOfficeSelect": {
        "selectOffice": "Seleziona ufficio",
        "whichOffice": "A quale ufficio desideri collegare questo account?"
      },
      "editAddToCalendarModal": {
        "allowContactCreation": "Consenti la creazione di contatti:",
        "allowTrigger": "Consenti trigger:",
        "doNotSync": "Non sincronizzare i nuovi eventi con il calendario primario",
        "primaryCalendarTooltip": "Puoi selezionare solo un calendario con accesso in scrittura che non sia già stato selezionato per il controllo dei conflitti.",
        "selectDefaultCalendar": "Seleziona il calendario predefinito",
        "whichCalendar": "Quale calendario dobbiamo usare per la sincronizzazione (in lettura e scrittura) degli eventi?"
      },
      "editCheckForConflictsCalendarsModal": {
        "checkThesePlaces": "Controlla se ci sono conflitti per questi luoghi",
        "howToCheckConflicts": "Come desideri che controlliamo l'eventuale presenza di conflitti?"
      },
      "ejectModal": {
        "agencyClosing": "L'account dell'agenzia Elite Marketing presso Highlevel sta per essere chiuso. Per mantenere il tuo account, contatta {userName} per migrare direttamente l'account su Highlevel.",
        "cancelWarning": "Tieni presente che il tuo account sarà ufficialmente cancellato il 30 giugno 2025 e, se il trasferimento non sarà completato, non potremo recuperare i tuoi dati dopo questa data.",
        "contactEmail": "transfers{'@'}gohighlevel.com",
        "contactUs": "Se hai domande, contattaci:",
        "faqsUrl": "gohighlevel.com/getstartedtoday-em",
        "freeTransition": "Per supportarti nel corso di questa transizione gratuita, applichiamo {months} di accesso gratuito al tuo nuovo abbonamento.",
        "intro": "A causa di ripetute violazioni dei Termini di servizio di HighLevel, Elite Marketing Authority (EMA) è stata rimossa permanentemente dalla piattaforma HighLevel.",
        "platformCommitment": "Come piattaforma che supporta i servizi di EMA, HighLevel si impegna a mantenere un ambiente sicuro, conforme e affidabile per tutti gli utenti. Per evitare interruzioni al tuo account, siamo qui per aiutarti a effettuare la transizione senza problemi, sia verso un altro fornitore white-label sia direttamente a HighLevel.",
        "questions": "Se hai domande,",
        "retainAccess": "Per mantenere l'accesso ai tuoi dati e strumenti esistenti, fai clic sul pulsante qui sotto e segui le istruzioni per avviare il trasferimento.",
        "speakWithTeam": "per parlare con il nostro team.",
        "startTransfer": "Inizia il tuo trasferimento gratuito",
        "title": "Attenzione, clienti di Elite Marketing",
        "viewFaqs": "Consulta qui le FAQ:",
        "whiteLabel": "Se preferisci accedere a HighLevel tramite un altro provider white-label, saremo felici di accettare questa modifica tramite il nostro sistema di richieste di assistenza dopo che avrai trasferito direttamente il tuo account su HighLevel."
      },
      "emailTemplate": {
        "createdOn": "Data di creazione:",
        "updatedOn": "Data di aggiornamento:"
      },
      "error": {
        "title": "Invio del pacchetto normativo non riuscito"
      },
      "errors": {
        "funnel": {
          "multiplePages": "C'è già più di una pagina con questo URL; cambia il percorso di questa pagina per farla funzionare.",
          "urlNotFound": "Ops, non riusciamo a trovare l'URL che cercavi"
        },
        "productRebilling": {
          "requestFailed": "Richiesta non riuscita"
        },
        "template": {
          "categoryNotFound": "Ops, non riusciamo a trovare la categoria che cercavi.",
          "internalError": "Si è verificato un errore interno!"
        },
        "transfer": {
          "hipaaEnabled": {
            "message": "L'account secondario che stai tentando di trasferire è abilitato per la conformità alla normativa HIPAA e non può essere trasferito a un'agenzia non HIPAA."
          },
          "limitExceeded": {
            "message": "L'agenzia a cui stai cercando di trasferire l'account secondario ha raggiunto il limite di utilizzo e non può aggiungere altri account secondari.  Chiedile di eliminare un account secondario non in uso oppure di passare a un piano per agenzie superiore per aggiungere questo account secondario."
          },
          "pendingRequest": {
            "heading": "Per questo account secondario c'è già una richiesta di trasferimento in sospeso.",
            "message": "Prima di procedere con l'apertura di una nuova richiesta di trasferimento per questo account secondario, devi annullare quella già esistente."
          }
        }
      },
      "facebookPageSelect": {
        "cannotFind": "Non riesci a trovare la pagina che cerchi? Visita le impostazioni di Facebook e controlla che tutte le pagine siano selezionate.",
        "instagramAvailable": "Instagram è disponibile per questo account!",
        "noPages": "Non hai pagine in questo account.",
        "title": "Seleziona quale pagina Facebook desideri collegare a questo luogo"
      },
      "googleLocationSelect": {
        "closeButton": "Chiudi!",
        "enableCallTracking": "Abilita il tracciamento delle chiamate GBP",
        "noBusinesses": "Non hai alcuna attività commerciale collegata a questo account."
      },
      "importCustomers": {
        "newExperience": {
          "efficient": "Più efficiente",
          "faster": "Più veloce",
          "itsText": "È",
          "smoother": "Più agevole",
          "title": "È arrivata una nuova esperienza di importazione!",
          "warningMessage": "Abilitando la nuova esperienza di importazione, si attivano i laboratori per questo account secondario e la funzionalità Beta."
        },
        "validateEmails": "Vuoi convalidare le email?"
      },
      "initBundle": {
        "numberType": "Tipo di numeri che avevi intenzione di usare",
        "numberTypes": {
          "local": "Numeri locali",
          "mobile": "Mobile",
          "tollfree": "Numero verde"
        },
        "selectCountry": "Seleziona il tuo paese",
        "selectUserType": "Seleziona il tipo di utente",
        "userTypes": {
          "business": "Azienda",
          "individual": "Individuale"
        }
      },
      "manageLocationCredits": {
        "creditLastAddedOn": "Ultimo credito aggiunto il:",
        "currentBalance": "Saldo attuale",
        "debitBalance": "- Saldo a debito",
        "depositComplimentaryCreditsOf": "Deposita crediti gratuiti di",
        "manageBalance": "Gestisci saldo",
        "mustBeValidInteger": "Deve essere un numero intero valido",
        "nextDate": "Data successiva:",
        "perMonth": "al mese",
        "remainingWalletBalance": "Saldo rimanente del portafoglio di questo account secondario",
        "rolloverCredits": "Trasferisci crediti al mese successivo",
        "toManageMonthlyCredits": "Per gestire i crediti mensili,"
      },
      "manageLocationSubscriptionModal": {
        "addNewSubscription": "Aggiungi nuovo abbonamento"
      },
      "manualActions": {
        "confirmDelete": "Vuoi davvero eliminare questa azione?",
        "confirmDeleteAll": "Confermi di voler eliminare tutte le azioni manuali in questa pagina?"
      },
      "membership": {
        "resetPassword": {
          "generateStrongPassword": "Genera una password complessa",
          "sendEmailNotification": "Invia anche una notifica email."
        }
      },
      "modal": {
        "description": "È necessario completare alcuni semplici passaggi di conformità per utilizzare i sistemi telefonici",
        "submit": "Invia",
        "title": "Servizio telefonico Lead Connector"
      },
      "notifications": {
        "list": {
          "homePageVisitors": "Visitatori della home page",
          "launched": "Lanciato",
          "newNotification": "Nuova notifica",
          "startMessage": "Inizia ad aumentare le conversioni creando la tua prima notifica",
          "types": {
            "combination": "Combinazione"
          }
        },
        "page": {
          "createTitle": "Crea nuova notifica",
          "steps": {
            "display": "Visualizzazione",
            "track": "Traccia"
          }
        }
      },
      "opportunities": {
        "columns": {
          "additionalInfo": "Informazioni aggiuntive",
          "calendarEvent": "Evento del calendario",
          "hideAssignedTo": "Nascondi Assegnato a",
          "hideTags": "Nascondi etichette"
        },
        "filters": {
          "dateAddedAsc": "↑ Data di aggiunta (asc.)",
          "dateAddedDesc": "↓ Data di aggiunta (disc.)",
          "orderBy": "Ordina per"
        },
        "getStarted": "iniziare!",
        "noPipelines": "Ops! Sembra che non ci siano sequenze. Crea una nuova sequenza per"
      },
      "pages": {
        "pageMoved": {
          "title": "Le inserzioni online sono state spostate"
        }
      },
      "recentlyVisited": {
        "prices": "{count} prezzi"
      },
      "reminders": {
        "appointmentReminders": "Promemoria degli appuntamenti",
        "apptTime": "Ora di appuntamento",
        "defaultDateRange": "Dom, 1 apr 2018 - Lun, 30 apr 2018"
      },
      "saasAccountDetailsActiveSubscription": {
        "onHold": "In attesa",
        "rebillingOnHoldWarning": "Questo account ha già configurazioni di rifatturazione in attesa. Il piano SaaS può essere associato solo dopo che il cliente ha aggiunto un metodo di pagamento.",
        "subscriptionId": "ID abbonamento:"
      },
      "saasPricingTable": {
        "confirmAndProceed": "Conferma e procedi",
        "documents": {
          "acceptedDocuments": "Documenti accettati",
          "acceptedDocumentsLabel": "Documenti accettati:",
          "additionalInfo": "Informazioni aggiuntive:",
          "createAddressLink": "Crea indirizzo.",
          "createAddressPrompt": "Ti chiediamo di creare un indirizzo prima di procedere con la creazione del pacchetto.",
          "documentInfo": "PNG, JPG, PDF fino a 5 MB",
          "documentType": "Tipo di documento",
          "option": "Opzione {number}",
          "selectAddress": "Seleziona l'indirizzo:",
          "selectDocumentType": "Seleziona il tipo di documento:",
          "selectFile": "Seleziona file",
          "title": "Documenti obbligatori:",
          "updateDocuments": "Aggiorna i documenti"
        },
        "everythingIn": "Tutto in <b>{plan}+</b>",
        "noPaymentMethod": {
          "linkText": "aggiungi la carta di credito qui",
          "message": "Chiedi al tuo cliente di",
          "title": "Il luogo deve prima includere un metodo di pagamento."
        },
        "noSaasPlan": {
          "linkText": "crea i tuoi piani SaaS qui.",
          "message": "Per favore",
          "title": "Non hai alcun piano SaaS configurato."
        },
        "saasModeSetupPendingWarning": "Il piano SaaS verrà attivato dopo che il cliente avrà aggiunto un metodo di pagamento. Fino ad allora, l'accesso al suo account sarà limitato.",
        "skipForNow": "Salta per ora",
        "skipPlan": "Salta piano",
        "success": {
          "title": "Pacchetto normativo inviato correttamente",
          "underReview": "Pacchetto inviato in fase di revisione"
        }
      },
      "selectBundle": {
        "addressBundle": {
          "description": "Questa opzione aggiungerà un nuovo indirizzo al tuo account",
          "label": "Pacchetto indirizzi"
        },
        "regulatoryBundle": {
          "description": "Questa opzione ti aiuterà a creare un nuovo pacchetto normativo",
          "label": "Pacchetto normativo"
        },
        "title": "Scegli quale pacchetto desideri aggiungere"
      },
      "settings": {
        "billing": "Fatturazione",
        "calendars": "Calendari",
        "customEmails": "Email personalizzate",
        "domains": "Domini",
        "domainsAndUrlRedirects": "Domini e reindirizzamenti URL",
        "facebookFormFieldsMapping": "Mappatura dei campi del modulo Facebook",
        "groups": "Gruppi",
        "integrations": "Integrazioni",
        "labs": "Laboratori",
        "media": "Contenuti multimediali",
        "noShowSMS": "SMS di mancata presentazione",
        "pipelines": "Sequenze",
        "profile": "Profilo",
        "smtpAndMailGunService": "Servizio SMTP e MailGun",
        "templates": "Modelli",
        "urlRedirects": "Reindirizzamenti URL"
      },
      "shakenStir": {
        "confirmation": {
          "title": "Le tue chiamate sono ora verificate!"
        },
        "modal": {
          "andThe": " e il ",
          "certification": "Certifico che il profilo aziendale associato è l'origine delle chiamate telefoniche e certifico che mi impegnerò in iniziative di traceback, incluse quelle avviate da",
          "failedTitle": "Invio non riuscito",
          "friendlyNamePlaceholder": "Es: SHST 2022-11-24 alle 19:47:14",
          "linkInfo": {
            "description": "Tutti i numeri attualmente disponibili e quelli acquistati in futuro saranno automaticamente registrati con SHAKEN/STIR.",
            "title": "Tutti i numeri verranno collegati automaticamente"
          },
          "stiPa": "Secure Telephony Identity Policy Administrator (STI-PA)",
          "subtitle": "Inserisci i dettagli e la descrizione",
          "successMessage": "La tua richiesta di registrazione SHAKEN/STIR è stata inviata. Per la sua approvazione potrebbero essere necessari fino a <b>3-4 giorni</b>. Lo stato sarà aggiornato a breve.",
          "successTitle": "Chiamate attendibili SHAKEN/STIR abilitate.",
          "title": "Abilita le chiamate attendibili SHAKEN/STIR",
          "tracebackGroup": "US Telecom Traceback Group"
        },
        "withCnam": {
          "cnamPromo": "Vuoi fare un ulteriore passo avanti? Mostra il nome della tua azienda durante le chiamate con CNAM.",
          "registerCnam": "Registrati a CNAM",
          "title": "Guadagnati la fiducia dei clienti e incrementa i tassi di risposta alle chiamate"
        },
        "successMessage": "La tua richiesta di registrazione SHAKEN/STIR è stata inviata. Per la sua approvazione potrebbero essere necessari fino a <b>3-4 giorni</b>. Lo stato sarà aggiornato a breve."
      },
      "shopify": {
        "selectLocation": "Seleziona quale luogo vuoi collegare a questo negozio Shopify"
      },
      "signup": {
        "accountType": "Tipo di account",
        "agencyProAccount": "Account Agency Pro (497 $/mese)",
        "agencyTestAccount": "Account di test dell'agenzia",
        "freeTrialMessage": "Ottieni una prova <strong>gratuita</strong> di 14 giorni iscrivendoti subito.",
        "freelancerAccount": "Account Freelancer (297 $/mese)",
        "getStartedForFree": "Inizia gratis!",
        "pickPassword": "Seleziona una password",
        "signUp": "Registrati",
        "starterAccount": "Account Starter (97 $/mese)",
        "termsAndConditions": "Registrandoti, accetti i nostri <a href='https://www.gohighlevel.com/privacy' target='_blank'>Termini e condizioni</a>",
        "yourCompanyName": "Nome della tua impresa",
        "yourFullName": "Il tuo nome e cognome"
      },
      "standardPlan": {
        "description": "Abbiamo i seguenti piani per le registrazioni dei brand standard.",
        "plans": {
          "common": {
            "einRequiredForRegistration": "EIN obbligatorio per la registrazione",
            "moreThan1Phone": "Sono consentiti più numeri di telefono"
          },
          "highVolume": {
            "heading": "Standard ad alto volume",
            "point3": "Fino a 600.000 segmenti al giorno",
            "infoText": "Registrazione di brand e campagna una tantum; verranno addebitati 20,95 $. Si applicherà una commissione aggiuntiva di fino a 2,25 $ al mese in conformità con il regolamento di TCR.",
            "point2": "Invia fino a 3000 segmenti al giorno",
            "point1": "EIN obbligatorio per la registrazione"
          },
          "lowVolume": {
            "heading": "Standard a basso volume",
            "recommended": "Consigliato",
            "point3": "Fino a 6000 segmenti al giorno",
            "infoText": "Registrazione di brand e campagna una tantum; verranno addebitati 20,95 $. Si applicherà una commissione aggiuntiva di fino a 2,25 $ al mese in conformità con il regolamento di TCR.",
            "point2": "Invia fino a 3000 segmenti al giorno",
            "point1": "EIN obbligatorio per la registrazione"
          }
        },
        "title": "Seleziona il tuo piano per brand standard"
      },
      "submissionDetail": {
        "titles": {
          "bookingDetails": "Dettagli della prenotazione",
          "form": "Modulo",
          "quiz": "Quiz",
          "submissionDetail": "Dettagli dell'invio",
          "survey": "Sondaggio"
        }
      },
      "suspension": {
        "suspended": {
          "description": "Solo gli amministratori/utenti dell'agenzia hanno accesso a questo account secondario. Attualmente, tu e altri amministratori/utenti dell'account non avete accesso a questo account secondario.",
          "heading": "Questo account secondario è stato sospeso."
        },
        "temporarily": {
          "description": "Tutti i tuoi dati sono al sicuro e tutti i trigger/le campagne, ecc. riprenderanno a funzionare dopo l'attivazione.",
          "heading": " Il tuo account è stato sospeso temporaneamente."
        }
      },
      "triggers": {
        "assignUser": {
          "onlyUnassignedContacts": "Applica solo ai contatti non assegnati",
          "splitTraffic": "Dividi traffico",
          "trafficWeightage": "Peso del traffico",
          "userRequired": "L'utente deve essere selezionato",
          "weightage": "Peso"
        },
        "birthdayFilters": {
          "afterDays": "Dopo un certo numero di giorni",
          "beforeDays": "Prima di un certo numero di giorni",
          "dayIs": "Il giorno è",
          "daysInNumber": "Giorni in numero",
          "hasTag": "Ha un'etichetta",
          "monthIs": "Il mese è",
          "selectDay": "Seleziona giorno",
          "selectMonth": "Seleziona mese"
        },
        "botConversation": {
          "enterTimeout": "Inserisci un timeout (ore)",
          "selectEliza": "Seleziona Eliza",
          "selectThankyouTemplate": "Seleziona modello di ringraziamento",
          "selectWelcomeTemplate": "Seleziona modello di benvenuto"
        },
        "contactField": {
          "addField": "Aggiungi campo",
          "defineFilters": "Definisci filtri"
        },
        "copyModal": {
          "title": "Copia trigger"
        },
        "detailModal": {
          "actionsPerform": "Quali azioni dovremmo eseguire?",
          "campaignNameRequired": "Il campo Nome campagna è obbligatorio",
          "campaignsDeprecation": "Le campagne non sono più supportate. Per garantire una transizione fluida, ti preghiamo di convertire le tue campagne esistenti in flussi di lavoro.",
          "folderName": "Nome della cartella",
          "mustSelectFolder": "È necessario selezionare una cartella.",
          "newFolderName": "Nome della nuova cartella",
          "selectFolder": "Seleziona cartella",
          "triggerNameRequired": "Il campo Nome trigger è obbligatorio",
          "triggersDeprecation": "I trigger non sono più supportati. Per garantire una transizione fluida, ti preghiamo di convertire i tuoi trigger esistenti in flussi di lavoro.",
          "triggerName": "Nome trigger"
        },
        "dnd": {
          "disableAll": "Disabilita DND per tutti i canali",
          "disableSpecific": "Disabilita DND per canali specifici",
          "enableAll": "Abilita DND per tutti i canali",
          "enableSpecific": "Abilita DND per canali specifici",
          "selectAction": "Seleziona azione"
        },
        "email": {
          "sendTestEmail": "Invia email di test",
          "smtpWarning": "I provider SMTP hanno alcune limitazioni. Fai clic qui per saperne di più."
        },
        "facebook": {
          "avatarAlt": "Avatar di Facebook",
          "selectCustomAudience": "Seleziona pubblico personalizzato"
        },
        "googleAds": {
          "conversionName": "Nome della conversione",
          "conversionTooltip": "La fonte della conversione dovrebbe essere \"Importa da clic\" e la categoria dovrebbe essere \"Lead importato\" o \"Lead\"",
          "noConversions": "Nessuna conversione trovata",
          "selectConversion": "Seleziona conversione"
        },
        "googleAnalytics": {
          "eventAction": "Azione evento",
          "eventActionRequired": "L'azione evento è obbligatoria.",
          "eventCategory": "Categoria dell'evento",
          "eventCategoryRequired": "La categoria dell'evento è obbligatoria.",
          "eventLabel": "Etichetta dell'evento",
          "eventValue": "Valore dell'evento",
          "hitType": "Tipo di interazione",
          "hitTypeRequired": "Il tipo di interazione è obbligatorio.",
          "trackingId": "ID di tracciamento",
          "trackingIdRequired": "L'ID di tracciamento è obbligatorio."
        },
        "membershipOffer": {
          "selectOffer": "Seleziona l'offerta"
        },
        "notification": {
          "selectRedirectPage": "Seleziona la pagina di reindirizzamento",
          "selectUser": "Seleziona utente",
          "selectUserType": "Seleziona il tipo di utente"
        },
        "sms": {
          "sendTestSMS": "Invia SMS di prova"
        },
        "stripeCharge": {
          "customerId": "ID cliente Stripe",
          "enterAmount": "Inserisci importo",
          "selectCurrency": "Seleziona la valuta"
        },
        "webhook": {
          "webhookUrl": "URL webhook"
        }
      },
      "twilioReselling": {
        "transactions": {
          "fields": {
            "activityDate": "Data dell'attività",
            "balance": "Saldo",
            "id": "id"
          }
        },
        "upgradeBanner": {
          "subtitle": "Le agenzie con un piano pro guadagnano circa 363 $ al mese rifatturando i costi telefonici ai loro clienti",
          "title": "Vuoi rifatturare questo importo ai tuoi clienti?"
        }
      },
      "updateModals": {
        "error": {
          "title": "Invio del profilo non riuscito."
        },
        "success": {
          "message": "Il tuo brand A2P e la tua campagna sono stati inviati.<br/><br/><b>Nota:</b> <b>riceverai un messaggio OTP al numero di cellulare fornito per la verifica</b> da parte di TCR. <b>Rispondi &quot;Yes&quot; entro 24 ore</b> dalla ricezione dell'SMS."
        }
      },
      "usageLimit": {
        "contactLimit": "Limite di contatti",
        "maxContactsAllowed": "Numero massimo di contatti consentiti nell'account secondario",
        "maxUsersAllowed": "Numero massimo di utenti consentiti nell'account secondario",
        "unlimited": "Illimitato",
        "usageLimits": "Limiti di utilizzo",
        "userLimit": "Limite di utenti",
        "userLimitHelpMessage": "Solo gli utenti di livello account secondario vengono conteggiati per questo limite. Puoi comunque aggiungere agli account secondari tutti gli utenti agenzia che desideri"
      },
      "yext": {
        "reselling": {
          "agreeToEnable": "Accetto di abilitare le inserzioni per questo cliente senza l'upselling e sono consapevole del fatto che mi verrà addebitato il costo",
          "deployDirectly": "Implementa le inserzioni direttamente",
          "deployDirectlyDesc": "Utilizza questa opzione se offri le inserzioni come parte dell'offerta o se desideri fatturare al cliente esternamente",
          "minimumCommitment": "con un periodo di impegno minimo di 1 mese.",
          "offerListings": "Inserzioni di offerte",
          "resellListings": "Inserzioni di rivendita",
          "subscribedInfo": "{withoutUpsell} senza upselling, {withUpsell} con upselling e {withSaas} con il pacchetto SaaS",
          "subscriptionCreated": "Abbonamento creato correttamente. Attendi...",
          "subscriptionCreating": "L'abbonamento è in fase di creazione.<br/>Non ricaricare la pagina o premere il pulsante Indietro",
          "unableToCreate": "Non è stato possibile creare l'abbonamento, contatta l'assistenza",
          "unavailabilityForAgencyAdmin": "Yext non è disponibile in questo paese. Se pensi che sia un errore, richiedilo nella nostra roadmap:",
          "yourResellOffer": "La tua offerta di rivendita"
        }
      },
      "selectCountry": "Seleziona il tuo paese",
      "documents": {
        "additionalInfo": "Informazioni aggiuntive",
        "createAddressLink": "Crea indirizzo.",
        "createAddressPrompt": "Ti chiediamo di creare un indirizzo prima di procedere con la creazione del pacchetto.",
        "selectAddress": "Seleziona l'indirizzo:"
      }
    },
    "triggers": {
      "emptyTrigger": "Trigger vuoto"
    },
    "util": {
      "addFiles": "+ Aggiungi file",
      "fillValues": "Riempi i valori",
      "image": "img",
      "ok": "Ok",
      "pleaseTypeOrCancel": "Digiti {consentString} sopra o annulli questa azione.",
      "pressEnterToAddCustomOption": "Premi invio per aggiungere un'opzione personalizzata",
      "required": "* obbligatorio",
      "unsaved": "Non salvato"
    },
    "workflow": {
      "announcement": {
        "enableMessage": "Per abilitare il flusso di lavoro per un luogo, vai nella scheda Account, fai clic sull'icona dei tre punti a destra di un account secondario e seleziona <strong>Abilita builder di flussi di lavoro</strong>. Questo processo è temporaneo poiché i flussi di lavoro saranno attivi per tutte le sedi la prossima settimana."
      },
      "faq": "FAQ",
      "gotIt": "Capito",
      "workflowIsLive": "Il flusso di lavoro è attivo sul tuo account!"
    },
    "action": {
      "stats": {
        "bounced": "Respinta",
        "clicked": "Cliccata",
        "delivered": "Consegnata",
        "opened": "Aperta",
        "replied": "Con risposta",
        "unsubscribed": "Iscrizione annullata",
        "total": "Totale",
        "failed": "Non riuscita"
      },
      "actions": {
        "edit": "Modifica",
        "send": "Invia",
        "remove": "Rimuovi"
      },
      "timing": {
        "days": "Giorni",
        "immediately": "Immediatamente",
        "before": "Prima",
        "after": "Dopo",
        "minutes": "Minuti",
        "hours": "Ore"
      },
      "labels": {
        "template": "Modello",
        "manual": "Manuale"
      },
      "details": {
        "hideDetail": "Nascondi Dettagli",
        "showDetail": "Mostra dettagli"
      },
      "queue": {
        "people": "persone",
        "person": "persona",
        "queued": "in coda"
      },
      "tooltips": {
        "clickedHelp": "La precisione del tracciamento dei clic può variare in base alle impostazioni del client email e dell'utente.",
        "statsAccuracy": "La precisione delle statistiche può variare in base alle impostazioni del client email e dell'utente."
      }
    },
    "bulkRequest": {
      "list": {
        "confirmDelete": "Vuoi davvero eliminare questa richiesta in blocco?",
        "startImmediately": "Inizia immediatamente"
      },
      "modal": {
        "contactTypes": {
          "all": "Tutto",
          "leads": "Potenziali clienti",
          "customers": "Clienti"
        },
        "buttons": {
          "cancel": "Annulla",
          "update": "Aggiorna",
          "add": "Aggiungi"
        },
        "labels": {
          "name": "Nome",
          "contactType": "Tipo di contatto",
          "campaign": "Campagna",
          "scheduledDate": "Giorno di programmazione",
          "tag": "Etichetta"
        },
        "placeholders": {
          "tags": "Etichette",
          "selectCampaign": "Seleziona campagna",
          "pickType": "Scegli un tipo"
        },
        "sections": {
          "bulkRequest": "Richiesta in blocco",
          "whoShouldRun": "Per chi dovrebbe essere eseguito?"
        },
        "titleAdd": "Aggiungi una richiesta in blocco",
        "titleEdit": "Modifica Richiesta in Blocco",
        "validation": {
          "scheduledDateRequired": "La data di programmazione è obbligatoria"
        }
      }
    },
    "listFolder": {
      "expandIcon": "Espandi"
    },
    "list": {
      "confirmDeleteFolder": "Conferma l'eliminazione della cartella",
      "delete": "Elimina",
      "confirmDelete": "Vuoi davvero eliminare questa campagna?",
      "moveToFolder": "Sposta nella cartella",
      "pleaseRename": "rinomina",
      "removeFromFolder": "Rimuovi dalla cartella"
    },
    "copy": {
      "title": "Copia campagna",
      "newCampaignName": "Nome della nuova campagna",
      "locations": "Luoghi"
    }
  },
  "compliance": {
    "findOutMore": "Scopri di più",
    "gdprDescription": "Prendiamo molto sul serio la protezione dei tuoi dati personali e di quelli dei tuoi clienti, quindi li trattiamo in modo confidenziale e in conformità con le norme di legge sulla protezione dei dati e con la presente dichiarazione sulla protezione dei dati",
    "gdprTitle": "Conformità GDPR",
    "hipaaDescription": "Attiva i miglioramenti di sicurezza per garantire che i dati nel tuo account HighLevel siano protetti e soddisfino i requisiti della normativa HIPAA",
    "hipaaTitle": "Conformità HIPAA"
  },
  "customValues": {
    "key": "Chiave",
    "selectedItemsCountSingular": "{count} riga selezionata",
    "selectedItemsCountPlural": "{count} righe selezionate"
  },
  "facebookAdFields": {
    "checkIcon": "Modulo mappato correttamente",
    "errorMessage": "Il token di accesso alla pagina è scaduto o non ha autorizzazioni sufficienti. Controlla di avere accesso alle pagine come amministratore."
  },
  "fbLeadSync": {
    "confirmTitle": "Confermare la sincronizzazione dei lead di Facebook?",
    "impactMessage": "Prenditi il tempo di comprendere l'impatto della sincronizzazione dei lead di Facebook prima di procedere:",
    "observations": "1. Questo sincronizzerà i lead di Facebook e creerà nuovi contatti per ogni potenziale cliente generato negli ultimi {days} giorni e non esistente nel tuo elenco di contatti. <br>2. Se hai importato manualmente i lead mancanti tramite il CSV esportato da Facebook Ads Manager, disabilita &quot;Consenti duplicati dei contatti&quot; per impedire alla sincronizzazione di creare contatti duplicati. <br>3. Se hai dei flussi di lavoro che si attivano alla <b>creazione di un contatto</b> o all'<b>invio del modulo per lead di Facebook</b>, verranno attivati per ogni nuovo contatto creato. <br>4. I contatti esistenti creati tramite i lead di Facebook non saranno interessati. <br>5. L'orario di creazione del contatto registrato sarà quello attuale. <br>6. Il completamento della sincronizzazione potrebbe richiedere fino a un'ora, a seconda del numero di lead ancora da sincronizzare. <br>",
    "proceedQuestion": "Desideri procedere con la sincronizzazione dei lead di Facebook?"
  },
  "integrationAI": {
    "accountDisconnected": "Account disconnesso!",
    "appNotFound": "Configurazione dell'app non trovata. Utilizzo di dati di fallback.",
    "checkingConnection": "Controllo dello stato della connessione in corso...",
    "connecting": "Connessione in corso...",
    "disconnectApp": "Scollega app",
    "disconnecting": "Scollegamento in corso...",
    "loadingAppInfo": "Caricamento informazioni sull'app in corso...",
    "refreshConnection": "Aggiorna il collegamento",
    "refreshing": "Aggiornamento...",
    "svgNotAvailable": "SVG non disponibile"
  },
  "phoneSystem": {
    "additionalSettings": "Impostazioni aggiuntive",
    "messaging": "Messaggistica",
    "messagingAnalytics": "Analisi della messaggistica",
    "regulatoryBundles": "Pacchetti normativi",
    "title": "Sistema telefonico",
    "trustCenter": "Centro protezione",
    "voice": "Voce"
  },
  "demo": {
    "draggable": {
      "title": "Test del componente trascinabile",
      "usingVue3": "Utilizzo del componente trascinabile compatibile con Vue 3",
      "description": "Adesso questo componente utilizza il componente trascinabile compatibile con Vue 3 revisionato.",
      "buttons": {
        "resetAllLists": "Ripristina tutti gli elenchi",
        "clearLog": "Rimuovi registro",
        "stopLoading": "Interrompa il caricamento",
        "simulateLoading": "Simula il caricamento",
        "refreshData": "Aggiorna dati"
      },
      "examples": {
        "basicDraggable": "Componente trascinabile semplice",
        "draggableWithElement": "Componente trascinabile con elemento",
        "draggableWithTransitionGroup": "Componente trascinabile con gruppo di transizione",
        "draggableWithMoveFunction": "Componente trascinabile con funzione di spostamento"
      },
      "eventLog": "Registro eventi",
      "handle": "Soprannome",
      "name": "Nome",
      "cannotMove": "(non si può spostare)"
    },
    "tableDemo": {
      "title": "Demo di Vue 3 UIBTable",
      "basicControls": "Controlli di base",
      "labels": {
        "filter": "Filtra:",
        "sortBy": "Ordina per:",
        "sortDirection": "Direzione di ordinamento:",
        "perPage": "Per pagina:",
        "tableStyling": "Progettazione della tabella:"
      },
      "placeholders": {
        "typeToSearch": "Digita per cercare..."
      },
      "checkboxLabels": {
        "striped": "A righe",
        "bordered": "Con bordo",
        "hover": "Passa il mouse",
        "small": "Piccolo",
        "responsive": "Reattivo"
      },
      "fields": {
        "id": "ID",
        "name": "Nome",
        "email": "Email",
        "status": "Stato",
        "created": "Creato",
        "actions": "Azioni"
      },
      "statuses": {
        "active": "Attivo",
        "inactive": "Inattivo",
        "pending": "In sospeso",
        "banned": "Vietato"
      },
      "modal": {
        "title": "Informazioni sull'elemento",
        "close": "Chiudi"
      },
      "messages": {
        "confirmDelete": "Vuoi davvero eliminare {name}?",
        "editItem": "Modifica Oggetto {id}",
        "showingItems": "Mostra {count} di {total} elementi"
      }
    },
    "saasPricingTable": {
      "confirmAndProceed": "Conferma e procedi",
      "everythingIn": "Tutto in <b>{plan}+</b>",
      "noPaymentMethod": {
        "linkText": "aggiungi la carta di credito qui",
        "message": "Per favore chieda al suo cliente di",
        "title": "Il luogo deve prima includere un metodo di pagamento."
      },
      "noSaasPlan": {
        "linkText": "crea i tuoi piani SaaS qui.",
        "message": "Per favore",
        "title": "Non hai alcun piano SaaS configurato."
      },
      "saasModeSetupPendingWarning": "Il piano SaaS verrà attivato dopo che il cliente avrà aggiunto un metodo di pagamento. Fino ad allora, l'accesso al suo account sarà limitato.",
      "skipForNow": "Salta per ora",
      "skipPlan": "Salta piano"
    }
  },
  "isv": {
    "business_registration_id_type": "Tipo di ID di registrazione dell'attività",
    "business_registration_number": "Numero di registrazione dell'attività",
    "business_website": "Sito web aziendale",
    "enter_your_business_registration_id_type": "Inserisci il tipo di ID di registrazione dell'attività",
    "name_of_other_registration_id_type": "Nome di un altro tipo di ID di registrazione",
    "pick_business_industry": "Seleziona il settore di attività",
    "pick_business_registration_id_type": "Seleziona il tipo di ID di registrazione dell'attività",
    "emailWithStar": "Email*",
    "businessIndustry": "Settore di attività*",
    "businessType": "Tipo di attività*",
    "regionsOfOperations": "Aree geografiche in cui opera l'azienda*",
    "registrationNumber": "Numero di registrazione dell'attività*",
    "registrationNumberHelper": "Il numero usato per identificare la tua azienda. Nel caso dell'EIN statunitense, deve essere un numero di 9 cifre, ad esempio 12-3456789.",
    "businessWebsiteWithStar": "Sito web aziendale*",
    "businessTypeWithStar": "Tipo di azienda",
    "businessWebsite": "Sito web aziendale"
  },
  "aiProductRebilling": {
    "enableRebilling": "Abilita rifatturazione",
    "ratesMayDiffer": "Le tariffe possono variare a seconda della regione. I calcoli mostrati sono basati sulle tariffe per il Regno Unito,",
    "supportDoc": "documentazione di supporto",
    "cancel": "Annulla",
    "profit": "Profitto",
    "chargedToCustomer": "Addebitato al cliente",
    "enabling": "Abilitazione in corso...",
    "forMore": "per ulteriori dettagli.",
    "rebillAmount": "Importo di rifatturazione",
    "tenDollarsWillGive": "Con 10 $ avrai circa",
    "yourCost": "Il tuo costo",
    "clientBillingPage": "pagina di fatturazione dell'azienda del cliente",
    "needStripeConnection": "Per attivare la rifatturazione, è necessario collegare il tuo account Stripe sulla",
    "per1000Words": "per 1000 parole",
    "perImage": "per immagine",
    "perReviewResponse": "Per risposta alla recensione",
    "perFunnel": "per Funnel",
    "minimumBetween": "Il minimo deve essere compreso tra {min} e {max}",
    "images": "immagini",
    "reviewResponse": "risposta alla recensione",
    "funnel": "funnel",
    "pleaseCheckSupport": "controlla"
  },
  "a2p": {
    "otpSuccess": {
      "title": "Successo OTP",
      "message": "Messaggio di successo OTP"
    },
    "otpError": {
      "title": "Errore OTP",
      "message": "Messaggio di errore OTP"
    },
    "businessProfileError": {
      "title": "Errore nel profilo aziendale",
      "message": "Messaggio di errore nel profilo aziendale"
    },
    "addressError": {
      "title": "Errore di Indirizzo",
      "status": "Stato di errore dell'indirizzo"
    },
    "profileError": {
      "title": "Errore profilo A2P",
      "message": "Messaggio di errore del profilo A2P"
    },
    "address": {
      "country": "Paese",
      "state": "Stato",
      "chooseCountry": "Scegli il paese...",
      "statePlaceholder": "Inserisci lo stato",
      "chooseState": "Scegli lo stato...",
      "city": "Città*",
      "postalCode": "Codice postale*",
      "streetAddress": "Indirizzo*",
      "streetAddressHelper": "Deve essere un indirizzo valido collegato alla tua azienda.",
      "title": "Indirizzo aziendale"
    },
    "validation": {
      "brandNameRequired": "Il nome del brand è obbligatorio.",
      "businessVerticalRequired": "La verticale di attività è obbligatoria.",
      "cityRequired": "La città è obbligatoria.",
      "countryRequired": "Il Paese è obbligatorio.",
      "invalidMobileNumber": "Numero di cellulare non valido.",
      "mobileNumberRequired": "Il numero di cellulare è obbligatorio.",
      "postalCodeRequired": "Il codice postale / CAP è obbligatorio.",
      "stateRequired": "Lo stato è obbligatorio.",
      "streetAddressRequired": "L'indirizzo è obbligatorio."
    },
    "authorizedRep": {
      "email": "Email*",
      "firstName": "Nome*",
      "jobPosition": "Posizione lavorativa*",
      "jobTitle": "Titolo professionale*",
      "jobTitlePlaceholder": "Inserisci il titolo del lavoro",
      "lastName": "Cognome*",
      "phoneNumber": "Numero di telefono*",
      "phoneNumberPlaceholder": "Inserisci il numero di telefono",
      "pickJobPosition": "Seleziona una posizione lavorativa",
      "title": "Informazioni del rappresentante autorizzato"
    },
    "registration": {
      "stepProgress": "Passaggio {currentStep} di 8",
      "successTitle": "Il tuo brand A2P e la tua campagna sono stati inviati.",
      "successWaitDays": "7 giorni",
      "successWaitPrefix": "Potrebbe richiedere fino a ",
      "successWaitSuffix": " per l'approvazione del tuo brand e ulteriori 4-5 settimane per l'approvazione della campagna.",
      "otpNote": "Nota: riceverai un messaggio OTP al numero di cellulare fornito per la verifica da parte di TCR. Rispondi \"Yes\" entro 24 ore dalla ricezione dell'SMS."
    },
    "update": {
      "brandDetailsTitle": "Aggiorna le informazioni sul brand",
      "brandName": "Nome del brand*",
      "brandNameHelper": "Usa il nome legale dell'organizzazione che invia i messaggi, oppure il tuo nome se questo brand non è per un'organizzazione.",
      "businessVerticals": "Settore di attività*",
      "chooseVertical": "Scegli una verticale...",
      "mobileNumber": "Numero di cellulare per la verifica OTP (con prefisso paese)*",
      "mobileNumberHelper": "Fornisci un numero di cellulare a cui hai accesso per confermare la verifica OTP. Saranno accettati solo numeri degli USA o del Canada. Non puoi utilizzare un numero di telefono CPaaS come quello ottenuto da LeadConnector. Non puoi usare lo stesso numero di cellulare per registrare più di 3 brand di ditta individuale. Questo limite è gestito da TCR.",
      "updateButton": "Aggiorna",
      "retryOTPTitle": "Riprova OTP",
      "retryOTPMessage": "Fai clic sul pulsante qui sotto per reinviare il messaggio di verifica OTP.",
      "sending": "Invio in corso...",
      "resendOTP": "Rinvia OTP"
    },
    "einModal": {
      "title": "Hai un EIN?",
      "question": "Hai un numero di identificazione del datore di lavoro (EIN)?",
      "hasEIN": "Sì, ho un EIN",
      "noEIN": "No, non ho un EIN",
      "disableNoEINText": "L'EIN è richiesto per i luoghi al di fuori degli Stati Uniti e del Canada",
      "infoText": "Per le aziende negli Stati Uniti e in Canada è richiesto un EIN."
    },
    "brandDetails": {
      "brandHeading": "Informazioni sul brand",
      "brandName": "Nome del brand*",
      "brandNameHelper": "Usa il nome legale dell'organizzazione che invia i messaggi, oppure il tuo nome se questo brand non è per un'organizzazione.",
      "businessIndustry": "Settore di attività*",
      "chooseVertical": "Scegli una verticale...",
      "mobileNumber": "Numero di cellulare per la verifica OTP (con prefisso paese)*",
      "mobileNumberHelper": "Fornisci un numero di cellulare a cui hai accesso per confermare la verifica OTP. Saranno accettati solo numeri degli USA o del Canada. Non puoi utilizzare un numero di telefono CPaaS come quello ottenuto da LeadConnector. Non puoi usare lo stesso numero di cellulare per registrare più di 3 brand di ditta individuale. Questo limite è gestito da TCR.",
      "solePropBrand": {
        "heading": "Brand di ditta individuale",
        "point1": "È consentito un solo numero di telefono",
        "point2": "EIN/SSN/DUNS non obbligatorio",
        "subheading": "Registrazione del brand di ditta individuale"
      },
      "solePropCampaign": {
        "heading": "Campagna di Impresa Individuale",
        "point1": "È consentito collegare solo 1 numero a una campagna di una ditta individuale",
        "point2": "Una volta approvato, il tuo numero predefinito verrà collegato automaticamente",
        "infoText": "Puoi anche aggiornare il numero dopo l'approvazione",
        "warningText": "È consentito collegare solo 1 numero a una campagna di una ditta individuale. Una volta approvato, il tuo numero predefinito verrà collegato automaticamente; dopo l'approvazione potrai anche aggiornare il numero.",
        "subheading": "Registrazione della campagna di ditta individuale"
      },
      "solePropSubtitle": "Dettagli di campagna e brand di ditta individuale",
      "standardBrand": {
        "heading": "4,41 $ - Una tantum",
        "point1": "EIN/SSN/DUNS obbligatorio",
        "point2": "Sono consentiti più numeri di telefono",
        "subheading": "Registrazione del brand standard"
      },
      "standardCampaign": {
        "heading": "16,54 $ - Una tantum",
        "point1": "È consentito collegare più di un numero a una campagna standard",
        "point2": "EIN/SSN/DUNS obbligatorio",
        "infoText": "Si applicherà una commissione aggiuntiva di fino a 12 $ al mese in conformità con il regolamento di TCR.",
        "subheading": "Registrazione della campagna standard"
      },
      "standardSubtitle": "Dettagli di campagna e brand standard",
      "title": "Dettagli del brand e della campagna"
    },
    "campaign": {
      "useCaseDetails": {
        "title": "Dettagli dei casi d'uso della campagna",
        "subtitle": "Inserisca i dettagli e la descrizione della campagna",
        "useCase": "Caso d'uso della campagna*",
        "pickUseCase": "Seleziona il caso d'uso della campagna",
        "useCaseDescription": "Descrizione del caso d'uso*",
        "explainInDetail": "Fornisci una spiegazione dettagliata",
        "useCaseDescriptionPlaceholder": "Esempio: questa campagna invia informazioni sugli appuntamenti - messaggi di conferma e promemoria ai nostri clienti dopo che hanno prenotato un appuntamento con noi sul nostro sito web e hanno effettuato l'iscrizione per ricevere SMS promozionali e di notifica da parte nostra.",
        "useCaseDescriptionHelper": "Fornisci una descrizione dettagliata di come utilizzerai questa campagna.",
        "solePropLabel": "Ditta individuale",
        "seeExamples": "Vedi esempi",
        "closeExamples": "Chiudi esempi"
      }
    }
  },
  "opportunities": {
    "email": "Email",
    "phone": "Telefono",
    "status": "Stato",
    "contactType": "Tipo di contatto",
    "bulkOperation": "Operazione in blocco",
    "contactName": "Nome del contatto",
    "unassigned": "Non assegnato",
    "abandoned": "Abbandonato",
    "addOpportunityName": "Aggiungi nome opportunità",
    "companyName": "Nome dell'impresa",
    "contactInfo": "Informazioni di contatto",
    "enterValue": "Inserisci il valore",
    "lost": "Persa",
    "open": "Apri",
    "opportunityInfo": "Informazioni sull'opportunità",
    "opportunityName": "Nome opportunità",
    "opportunitySource": "Fonte dell'opportunità",
    "owner": "Titolare",
    "pipeline": "Sequenza",
    "selectPipeline": "Seleziona sequenza",
    "selectStage": "Seleziona fase",
    "stage": "Fase",
    "won": "Vinta",
    "createdOn": "Data di creazione:",
    "goToContactDetail": "Vai alla pagina dei dettagli del contatto",
    "leadValue": "Valore di lead",
    "removeOwner": "Rimuovi titolare",
    "createdBy": "Creato da",
    "notAllowedToChange": "Non le è consentito modificare questo contatto",
    "opportunityAlreadyExists": "Esiste già un'opportunità per questo contatto nella sequenza selezionata",
    "filters": {
      "all": "Tutto",
      "statuses": {
        "all": "Tutto",
        "open": "Apri",
        "won": "Conquistato",
        "lost": "Perso",
        "abandoned": "Abbandonato"
      },
      "search": "Cerca",
      "status": "Stato",
      "campaign": "Campagna",
      "owner": "Titolare",
      "pipeline": "Sequenza",
      "dateAddedAsc": "↑ Data di aggiunta (asc.)",
      "dateAddedDesc": "↓ Data di aggiunta (disc.)",
      "orderBy": "Ordina per"
    },
    "columns": {
      "note": "Nota",
      "task": "Attività",
      "companyName": "Nome dell'impresa",
      "additionalInfo": "Informazioni aggiuntive",
      "calendarEvent": "Evento del calendario",
      "hideAssignedTo": "Nascondi ciò che è assegnato a",
      "hideTags": "Nascondi etichette"
    },
    "buttons": {
      "new": "Nuovo"
    },
    "dragActions": {
      "abandoned": "Abbandonato",
      "lost": "Persa",
      "won": "Conquistato"
    },
    "getStarted": "iniziare!",
    "noPipelines": "Ops! Sembra che non ci siano sequenze. Crea una nuova sequenza per",
    "addTask": "Aggiungi attività",
    "tasksCount": "{count} attività"
  },
  "appointmentDetails": "Dettagli dell'appuntamento",
  "cloneFunnel": {
    "cloneButton": "Clona {entityName}",
    "cloning": "Clonazione in corso...",
    "cloningLimit": "La clonazione è limitata a 3 luoghi alla volta",
    "error": "Errore durante la clonazione del funnel!",
    "locationsLabel": "Seleziona luoghi",
    "nameLabel": "Nome per il clone di {entityName}",
    "namePlaceholder": "Inserisci il nome per il clone di {entityName}",
    "selectUpTo": "Seleziona fino a {maxSelectableLocations} luoghi",
    "title": "Clona {entityName}"
  },
  "errors": "Errori",
  "renderEmailAddress": "Visualizza indirizzo email",
  "noPaymentMethodWarning": "Avviso di assenza di metodo di pagamento",
  "pageDetail": "Dettagli della pagina",
  "activityHistory": "Cronologia Attività",
  "uiAlert": "Avviso UI",
  "eventModals": {
    "wait": {
      "save": "Salva",
      "days": "Giorni",
      "fri": "Ven",
      "mon": "Lun",
      "sat": "Sab",
      "sun": "Dom",
      "thu": "Gio",
      "tue": "Mar",
      "wed": "Mer",
      "wait": "Attendi",
      "minutes": "Minuti",
      "hours": "Ore",
      "title": "Modifica evento di attesa",
      "whichDaysResume": "In quali giorni dovremmo riprendere?",
      "pickDayError": "Selezioni almeno un giorno",
      "whatTimeResume": "A che ora dovremmo riprendere?"
    },
    "sms": {
      "send": "Invia",
      "name": "Nome",
      "attachFile": "Allega file",
      "learnMore": "Scopri di più",
      "sendTest": "Invia test",
      "title": "Modifica evento {eventType}",
      "titleTemplate": "Modifica modello {eventType}",
      "nameRequired": "Il nome è obbligatorio",
      "pickTemplate": "Scegli modello",
      "appCharacters": "Caratteri dell'app",
      "numSegments": "Num. di segmenti",
      "approximateCost": "Costo approssimativo",
      "costEstimateNote": "Nota di stima dei costi",
      "urlAttachmentAutocompleteToken": "Allegato URL",
      "addFileUrl": "Aggiungi URL del file",
      "urlImageAlt": "URL dell'immagine",
      "fileImageAlt": "Immagine del file",
      "enterMessage": "Inserisci messaggio",
      "mobilePhonePlaceholder": "Cellulare",
      "unsupportedContentType": "Tipo di contenuto non supportato: {fileType}",
      "urlAttachmentWarning": "Impossibile caricare {count} allegato/i URL. Vuoi continuare?",
      "provideMobileNumber": "Si prega di fornire il numero di cellulare"
    },
    "email": {
      "text": "Testo",
      "checkLinks": "Controlla i link in cui è presente un valore personalizzato. C'è un \"%20\" in più tra il {{ e i valori_personalizzati.",
      "errorOccurred": "Si è verificato un errore. Riprova.",
      "insertToAddress": "Inserisci un indirizzo destinatario."
    },
    "voicemail": {
      "save": "Salva",
      "dropFile": "Rilascia il file qui oppure fai clic per caricarlo",
      "faq": "FAQ",
      "title": "Modifica evento di segreteria telefonica",
      "voicemailFile": "File di segreteria telefonica",
      "warning": "Attenzione: i file della segreteria telefonica devono essere in formato MP3, WAV o GSM.",
      "unsupportedFormat": "Formato di file non supportato. Usa MP3, WAV o GSM."
    },
    "call": {
      "title": "Modifica Evento di Chiamata",
      "save": "Salva",
      "name": "Nome",
      "nameRequired": "Il nome è obbligatorio",
      "callWhisper": "Attiva messaggio per l'agente",
      "whisperMessage": "Messaggio per l'agente",
      "thisIsTheMessage": "Questo è il messaggio che verrà riprodotto all'agente prima di connettere la chiamata.",
      "callTimeoutS": "Timeout chiamata (s)",
      "timeoutSeconds": "Timeout (secondi)",
      "disableVoicemailDetect": "Disabilita il rilevamento della segreteria telefonica",
      "callWillPatchInstantly": "La chiamata verrà inoltrata immediatamente senza rilevare la segreteria telefonica."
    }
  },
  "emailTemplate": {
    "createdOn": "Data di creazione:",
    "updatedOn": "Data di aggiornamento:"
  },
  "cnam": {
    "learnMore": {
      "title": "Scopri di più su CNAM",
      "description": "Descrizione CNAM"
    },
    "submitted": {
      "checkStatus": "Controlla lo stato CNAM",
      "description": "Il nome della tua azienda dovrebbe essere iniziare a essere visualizzato dai contatti pertinenti tra circa 3-5 giorni.",
      "subtitle": "La tua richiesta per CNAM è stata inviata.",
      "title": "Congratulazioni!"
    },
    "registration": {
      "confirm": "Conferma",
      "learnMore": "Scopri di più",
      "characterLimit": "{count}/15",
      "title": "Registrazione CNAM",
      "description": "Inserisca il nome della sua attività (max 15 caratteri)",
      "warning": "Attenzione: il nome della tua azienda sarà visualizzato sull'ID chiamante. "
    }
  },
  "updateModals": {
    "error": {
      "title": "Errore di aggiornamento",
      "message": "Messaggio di errore di aggiornamento"
    },
    "success": {
      "message": "Il tuo brand A2P e la tua campagna sono stati inviati.<br/><br/><b>Nota:</b> <b>riceverai un messaggio OTP al numero di cellulare fornito per la verifica</b> da parte di TCR. <b>Rispondi &quot;Yes&quot; entro 24 ore</b> dalla ricezione dell'SMS.",
      "title": "Il tuo brand A2P e la tua campagna sono stati inviati. Potrebbero volerci fino a <b>7 giorni</b> per l'approvazione del tuo brand e ulteriori 4-5 settimane per l'approvazione della campagna."
    }
  },
  "regulatoryBundle": {
    "error": {
      "title": "Errore del pacchetto normativo",
      "status": "Stato di errore del pacchetto normativo"
    },
    "createAddress": {
      "successMessage": "Il tuo brand A2P e la tua campagna sono stati inviati.",
      "successTitle": "Indirizzo inviato correttamente",
      "underReview": "L'indirizzo inviato è in fase di revisione"
    },
    "createEndUser": {
      "dateFormat": "Il formato della data deve essere AAAA-MM-GG.",
      "phoneExample": " Esempio: +14155552671",
      "title": "Dettagli aziendali:"
    },
    "success": {
      "title": "Pacchetto normativo inviato correttamente",
      "underReview": "Pacchetto inviato in fase di revisione",
      "message": "La tua richiesta di registrazione SHAKEN/STIR è stata inviata. Per la sua approvazione potrebbero essere necessari fino a <b>3-4 giorni</b>. Lo stato sarà aggiornato a breve."
    },
    "documents": {
      "additionalInfo": "Informazioni aggiuntive",
      "createAddressLink": "Crea indirizzo.",
      "createAddressPrompt": "Ti chiediamo di creare un indirizzo prima di procedere con la creazione del pacchetto.",
      "selectAddress": "Seleziona l'indirizzo:"
    },
    "selectBundle": {
      "addressBundle": {
        "description": "Questa opzione aggiungerà un nuovo indirizzo al tuo account",
        "label": "Pacchetto Indirizzi"
      },
      "regulatoryBundle": {
        "description": "Questa opzione ti aiuterà a creare un nuovo pacchetto normativo",
        "label": "Pacchetto normativo"
      },
      "title": "Scegli quale pacchetto desideri aggiungere"
    },
    "modal": {
      "back": "Indietro",
      "next": "Avanti",
      "submit": "Invia",
      "title": "Nuovo Pacchetto Normativo",
      "description": "Crea un nuovo pacchetto normativo per il tuo luogo"
    }
  },
  "reminder": {
    "phone": "Telefono",
    "noReplyYet": "Ancora nessuna risposta"
  },
  "sendGrid": {
    "apiKey": "Chiave API di SendGrid",
    "save": "Salvataggio SendGrid",
    "apiKeyRequired": "Chiave API di SendGrid obbligatoria"
  },
  "twilioReselling": {
    "upgradeBanner": {
      "upgradeButton": "Passa a un piano superiore",
      "subtitle": "Le agenzie con un piano pro guadagnano circa 363 $ al mese rifatturando i costi telefonici ai loro clienti",
      "title": "Vuoi rifatturare questo importo ai tuoi clienti?"
    }
  },
  "emailField": {
    "label": "Email",
    "placeholder": "Email",
    "tooltip": {
      "primary": "Primario",
      "emails": "Email"
    }
  },
  "attachSnapshotToggle": {
    "loadSnapshot": "Carica snapshot:",
    "loadSnapshotWarning": "Vuoi caricare lo snapshot associato a questo piano? <br /> <strong class='text-danger'>I dati esistenti possono andare persi</strong>"
  },
  "suspension": {
    "suspended": {
      "description": "Solo gli amministratori/utenti dell'agenzia hanno accesso a questo account secondario. Attualmente, tu e altri amministratori/utenti dell'account non avete accesso a questo account secondario.",
      "heading": "Questo account secondario è stato sospeso."
    },
    "temporarily": {
      "description": "Tutti i tuoi dati sono al sicuro e tutti i trigger/le campagne, ecc. riprenderanno a funzionare dopo l'attivazione.",
      "heading": " Il Suo account è stato sospeso temporaneamente."
    }
  },
  "callerIdUpdateModal": {
    "friendlyName": "Nome informale dell'azienda",
    "title": "Aggiorna ID chiamante"
  },
  "drChronoOfficeSelect": {
    "selectOffice": "Seleziona ufficio",
    "whichOffice": "A quale ufficio desideri collegare questo account?",
    "connect": "Collega!"
  },
  "phoneField": {
    "label": "Telefono",
    "placeholder": "Numero di telefono",
    "tooltip": {
      "invalidNumber": "Numero di telefono non valido",
      "notSmsCapable": "Questo numero {type} non è compatibile con SMS"
    }
  },
  "submissionDetail": {
    "titles": {
      "bookingDetails": "Dettagli della prenotazione",
      "form": "Modulo",
      "quiz": "Quiz",
      "submissionDetail": "Dettagli dell'invio",
      "survey": "Sondaggio"
    }
  },
  "shakenStir": {
    "confirmation": {
      "description": "La tua richiesta di registrazione SHAKEN/STIR è stata inviata. Per la sua approvazione potrebbero essere necessari fino a <b>3-4 giorni</b>. Lo stato sarà aggiornato a breve.",
      "title": "Chiamate attendibili SHAKEN/STIR abilitate."
    },
    "modal": {
      "andThe": " e il ",
      "businessProfile": "Profilo aziendale",
      "certification": "Certifico che il profilo aziendale associato è l'origine delle chiamate telefoniche e certifico che mi impegnerò in iniziative di traceback, incluse quelle avviate da",
      "failedTitle": "Invio non riuscito",
      "friendlyName": "Nome semplice",
      "friendlyNamePlaceholder": "Ex: SHST 2022-11-24 alle 19:47:14",
      "linkInfo": {
        "description": "Tutti i numeri attualmente disponibili e quelli acquistati in futuro saranno automaticamente registrati con SHAKEN/STIR.",
        "title": "Tutti i numeri verranno collegati automaticamente"
      },
      "stiPa": "Secure Telephone Identity Policy Administrator (STI-PA)",
      "subtitle": "Inserisci i dettagli e la descrizione",
      "successMessage": "La tua richiesta di registrazione SHAKEN/STIR è stata inviata. Per la sua approvazione potrebbero essere necessari fino a <b>3-4 giorni</b>. Lo stato sarà aggiornato a breve.",
      "successTitle": "Chiamate attendibili SHAKEN/STIR abilitate.",
      "title": "Abilita le chiamate attendibili SHAKEN/STIR",
      "tracebackGroup": "US Telecom Traceback Group"
    },
    "withCnam": {
      "cnamPromo": "Registrati a CNAM per visualizzare il nome della tua azienda sull'ID chiamante",
      "registerCnam": "Registra CNAM"
    }
  },
  "task": {
    "2day": "2 giorni",
    "3day": "3 giorni",
    "4day": "4 giorni",
    "5day": "5 giorni",
    "addTask": "Aggiungi attività",
    "countTasks": "{count} attività"
  },
  "updatedProductsModal": {
    "title": "Prodotti Aggiornati",
    "copyDirectSaleLink": "Copia link di vendita diretta",
    "setupFeeInstruction": "La commissione di configurazione può essere configurata tramite la Dashboard Stripe. ",
    "doNotDeleteWarning": "Non eliminare prodotti o prezzi dalla Dashboard Stripe. Questo interromperà l'integrazione."
  },
  "termsOfService": {
    "privacyLink": "Informativa sulla privacy",
    "accept": "Accetta",
    "termsLink": "Termini di servizio",
    "updateMessage": "Abbiamo aggiornato i nostri Termini di Servizio e l'Informativa sulla Privacy. Leggili e accettali per continuare.",
    "agreementPrefix": "Continuando, accetti i nostri ",
    "agreementConjunction": " e "
  },
  "callerIdVerificationModal": {
    "answerCall": "Rispondi alla chiamata e inserisci questo codice di verifica:",
    "leadConnectorCalling": "Lead Connector sta chiamando...",
    "title": "Aggiungi un ID chiamante tramite voce",
    "waitingForVerification": "In attesa della verifica..."
  },
  "emailOTPModal": {
    "confirmCode": "Conferma il codice",
    "resendCode": "Se non hai ricevuto il codice, fai clic qui per inviarlo di nuovo"
  },
  "survey": {
    "copy": {
      "cancel": "Annulla",
      "location": "Luogo",
      "copy": "Copia",
      "newSurveyName": "Nuovo nome del sondaggio",
      "title": "Copia sondaggio",
      "locationRequired": "Il luogo è obbligatorio"
    }
  },
  "stripeProductDetailsModal": {
    "productName": "Nome del prodotto",
    "planDetails": "Dettagli del piano",
    "title": "Dettagli del prodotto",
    "planId": "ID piano",
    "copiedToClipboard": "Copiato negli appunti"
  },
  "importCustomers": {
    "newExperience": {
      "efficient": "Più Efficiente",
      "faster": "Più veloce",
      "itsText": "È",
      "smoother": "Più agevole",
      "title": "È arrivata una nuova esperienza di importazione!",
      "warningMessage": "Abilitando la nuova esperienza di importazione, si attivano i laboratori per questo account secondario e la funzionalità Beta.",
      "tryNow": "Prova ora"
    },
    "validateEmails": "Vuoi convalidare le email?"
  },
  "yext": {
    "reselling": {
      "zero": "0",
      "highlevelPrice": "Prezzo di HighLevel",
      "howDoesItWork": "Come funziona?",
      "payNow": "Paga ora",
      "priceError": "Il prezzo deve essere maggiore o uguale al prezzo di HighLevel",
      "saving": "Salvataggio",
      "yourPrice": "Il tuo prezzo",
      "yourProfit": "Il tuo profitto",
      "subscriptionCreating": "L'abbonamento è in fase di creazione.<br/>Non ricaricare la pagina o premere il pulsante Indietro",
      "subscriptionCreated": "Abbonamento creato correttamente. Attendi...",
      "unableToCreate": "Non è stato possibile creare l'abbonamento, contatta l'assistenza",
      "perMonth": "al mese",
      "agreeToEnable": "Accetto di abilitare le inserzioni per questo cliente senza l'upselling e sono consapevole del fatto che mi verrà addebitato il costo",
      "deployDirectly": "Implementa le inserzioni direttamente",
      "deployDirectlyDesc": "Utilizza questa opzione se offri le inserzioni come parte dell'offerta o se desideri fatturare al cliente esternamente",
      "minimumCommitment": "con un periodo di impegno minimo di 1 mese.",
      "offerListings": "Elenco Offerte",
      "resellListings": "Inserzioni di rivendita",
      "subscribedInfo": "{withoutUpsell} senza upselling, {withUpsell} con upselling e {withSaas} con il pacchetto SaaS",
      "yourResellOffer": "La Sua offerta di rivendita"
    }
  }
}
